var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _g, _path, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g3, _g4, _path18, _path19, _path20, _path21, _path22, _rect, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g5, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _g6, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g7, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _g8, _g9, _g0, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 631,
    height: 565,
    viewBox: "0 0 631 565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.44,
    y1: -0.824,
    x2: 0.44,
    y2: -1.678,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e33a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0665a5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -0.385,
    y1: 0.266,
    x2: -0.385,
    y2: -0.702,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1.695,
    y1: 13.118,
    x2: 1.695,
    y2: 11.624,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#365e8b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.348,
    y1: -0.237,
    x2: 0.348,
    y2: -1.255,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1852a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#067ed3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 3.591,
    y1: 9,
    x2: 3.591,
    y2: 8.239,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#836ceb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3a4eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#81300f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#af6c51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e28181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9acf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1d1f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a3283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#552c88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 0,
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 0,
    y1: 0.499,
    x2: 1,
    y2: 0.499,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 0.001,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: -0.001,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 0,
    y1: 0.5,
    x2: 1.001,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 0,
    y1: 0.5,
    x2: 1.001,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 0.001,
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: -0.001,
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: 0,
    y1: 0.5,
    x2: 1.001,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: 0,
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: 0,
    y1: 0.499,
    x2: 1,
    y2: 0.499,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: -0.001,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5cdf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3edfb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8642a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6456c0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#755cbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccedff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#131322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a4455"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#776d7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d68c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#cb"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cd",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccedff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d68c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d68c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccedff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ci",
    x1: -0.129,
    y1: 1.723,
    x2: 0.758,
    y2: 1.723,
    xlinkHref: "#ce"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cj",
    x1: 2.071,
    y1: -0.062,
    x2: 2.071,
    y2: -1.671,
    xlinkHref: "#bs"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cm",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5afae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#673e3e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cn",
    x1: 2.361,
    y1: 1.05,
    x2: 2.361,
    y2: 0.144,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "co",
    x1: 2.738,
    y1: 1.066,
    x2: 2.738,
    y2: 0.156,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cp",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff51aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe117e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cq",
    x1: -27.714,
    y1: -31.286,
    x2: -27.714,
    y2: -31.777,
    xlinkHref: "#cp"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cr",
    x1: -69.63,
    y1: -39.688,
    x2: -69.63,
    y2: -40.192,
    xlinkHref: "#cp"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-67 -174)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 277,
    cy: 277,
    r: 277,
    transform: "translate(78 182)",
    fill: "#fff",
    opacity: 0.214
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(470 174)",
    fill: "#59d973"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 65.5,
    r: 65.5,
    transform: "translate(567 608)",
    fill: "#eaa02a"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(67 437)",
    fill: "#665efb"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(154 239)",
    fill: "#ea2a8a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-287 135.604)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(354 101.369)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.934)",
    opacity: 0.771
  }, /*#__PURE__*/React.createElement("path", {
    d: "M563.68,475.929c-90.171,7.21-166.264,13.271-192.262-49.115s50.535-56.7,50.535-98.278S351.1,206.289,399.277,137.306C453.132,60.186,732.411,121.21,829,242c112.975,141.277,23.321,277.719-44.735,293.477C708.359,553.049,656.274,468.522,563.68,475.929Z",
    transform: "translate(-344.871 -93.674)",
    fill: "#e0f3ff",
    opacity: 0.328
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.334,179.969a51.624,51.624,0,0,0,10.637-20.861,9.087,9.087,0,0,0,.334-3.765c-.443-2.415-2.626-4.168-4.917-5.051-5.608-2.163-12.393-.11-16.333,4.428a18.736,18.736,0,0,0-3.515,16.954c.863,3.186,2.624,6.3,5.5,7.919s6.986,1.26,8.958-1.388a1.537,1.537,0,0,0-2.494-.655Z",
    transform: "translate(-145.48 -47.186)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.957,157.6a9.572,9.572,0,0,0,6.91-6.165c-2.167-2.379-5.354-4.082-8.538-3.615s-5.978,3.665-5.247,6.8,5.628,4.486,7.394,1.795Z",
    transform: "translate(-143.371 -48.875)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.353,141.2a4.918,4.918,0,0,0,4.326-.282,5.069,5.069,0,0,0-1.1-1.674,1.727,1.727,0,0,0-1.861-.362c-.817.421-.925,1.524-.927,2.443l-.537-.537Z",
    transform: "translate(-133.051 -57.903)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.952,144.5a2.252,2.252,0,0,1-.819,1.063c-.5-1.053.006-2.3.569-3.319.312-.571.8-1.214,1.442-1.126.451.06.765.461,1.164.677.8.431,2.085.254,2.353,1.122a1.114,1.114,0,0,1-.671,1.242,3.264,3.264,0,0,1-1.512.19l-3.359-.114Z",
    transform: "translate(-134.384 -55.527)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.234,108.76c.865-.375.381-1.865-.541-2.063a3.424,3.424,0,0,0-2.572.945,3.3,3.3,0,0,0,3.265,1.67Z",
    transform: "translate(-121.15 -90.075)",
    fill: "#e0f3ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.474,100.9a.852.852,0,0,1-.985-.659,1.587,1.587,0,0,1,.32-1.248,1.51,1.51,0,0,1,.567-.523,1.114,1.114,0,0,1,1.466.633,1.194,1.194,0,0,1-.729,1.452,1.286,1.286,0,0,1-1.516-.649Z",
    transform: "translate(-134.853 -98.379)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.265,134.048a1.318,1.318,0,0,0,1.951,1.146,2.3,2.3,0,0,0-.33-1.406,1.114,1.114,0,0,0-1.282-.447.743.743,0,0,0-.228,1.2Z",
    transform: "translate(-136.157 -63.386)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.921,145.86a3.757,3.757,0,0,0,3.162.851l-.775-2.668a2.488,2.488,0,0,0-.573-1.158,1.489,1.489,0,0,0-2.189.419,2.091,2.091,0,0,0,.35,2.367Z",
    transform: "translate(-135.996 -54.068)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.956,106.445c-.068-.3-.134-.611-.2-.915a1.139,1.139,0,0,0-1.29.6.95.95,0,0,0,.553,1.25.813.813,0,0,0,1-.833Z",
    transform: "translate(-133.914 -91.238)",
    fill: "#e0f3ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.331,137.989c-.569-.222-1.112.495-1.073,1.106a17.722,17.722,0,0,0,.495,1.764,2.2,2.2,0,0,1-.485,1.766,1.055,1.055,0,0,1-.953.439,1.312,1.312,0,0,1-.615-.391,6.635,6.635,0,0,1-1.977-2.98,3.1,3.1,0,0,1,.975-3.265,2.374,2.374,0,0,1,3.755,1.756Z",
    transform: "translate(-137.71 -60.663)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.7,143.324a1.476,1.476,0,0,0,2.011-.387,2.131,2.131,0,0,0,.056-2.175c-.156-.3-.463-.6-.783-.495a.842.842,0,0,0-.427.517q-.571,1.289-1.138,2.578Z",
    transform: "translate(-128.872 -56.393)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.563,126.354a2.493,2.493,0,0,1-1.729-3.555A6.224,6.224,0,0,1,589,124.415c.783.913.833,2.552-.208,3.154l-2.073-.385Z",
    transform: "translate(-124.729 -73.889)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.95,180.842a.644.644,0,0,1-.821.439,1.511,1.511,0,0,1-.775-.683,1.819,1.819,0,0,1-.326-.785,1.262,1.262,0,0,1,.9-1.274,1.6,1.6,0,0,1,1.548.455,1.026,1.026,0,0,1,.324.735.56.56,0,0,1-.513.543Z",
    transform: "translate(-149.329 -18.046)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.172,132.215l.957-.214a2.069,2.069,0,0,0-.495-1.392c-.377-.338-1.146-.206-1.182.3a1.025,1.025,0,0,0,.166.537l.851,1.608Z",
    transform: "translate(-132.854 -66.245)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.391,125.023a5.922,5.922,0,0,0,1.977-1.342,2.025,2.025,0,0,0,.363-2.231,1.8,1.8,0,0,0-.9-.747,2.222,2.222,0,1,0-1.4,4.21Z",
    transform: "translate(-131.503 -76.131)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.71,121.835q.411-.706.823-1.414a2.9,2.9,0,0,0-1.055-.657,1.541,1.541,0,0,0-.2,2.147Z",
    transform: "translate(-127.355 -76.933)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.94,149.957a20.672,20.672,0,0,0,.36-9.365,3.618,3.618,0,0,0-.511-1.424,2.95,2.95,0,0,0-2.636-1.009,6.051,6.051,0,0,0-5.189,4.352,7.5,7.5,0,0,0,1.57,6.75,5.056,5.056,0,0,0,3.329,1.953,2.845,2.845,0,0,0,3.022-2.009.616.616,0,0,0-1.015.18Z",
    transform: "translate(-119.557 -58.495)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.26,244.794a20.672,20.672,0,0,0,.36-9.365,3.619,3.619,0,0,0-.511-1.424A2.95,2.95,0,0,0,371.474,233a6.051,6.051,0,0,0-5.189,4.352,7.5,7.5,0,0,0,1.57,6.749,5.056,5.056,0,0,0,3.329,1.953,2.847,2.847,0,0,0,3.022-2.009.615.615,0,0,0-1.015.18Z",
    transform: "translate(-344.871 36.609)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.509,145.643a4.914,4.914,0,0,0,3.295-2.818,5.107,5.107,0,0,0-1.883-.683,1.731,1.731,0,0,0-1.708.825c-.4.827.174,1.775.723,2.512l-.753-.106Z",
    transform: "translate(-148.27 -54.498)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.323,141.146a1.917,1.917,0,0,0,.749-.983,2.023,2.023,0,0,0-.246-1.172,18.758,18.758,0,0,1-1.005-3.17q-1.286,2.454-2.572,4.911a1.132,1.132,0,0,1-.254.357c-.4.324-.985-.024-1.494.032-.745.082-1.088.969-1.16,1.714C558.834,148.146,563.575,142.625,565.323,141.146Z",
    transform: "translate(-151.053 -60.831)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.6,150.632a3.752,3.752,0,0,0,3.042-1.212l-2.217-1.672a2.5,2.5,0,0,0-1.154-.585,1.488,1.488,0,0,0-1.5,1.646,2.09,2.09,0,0,0,1.7,1.686Z",
    transform: "translate(-148.583 -49.464)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.234,144.5a1.477,1.477,0,0,0,1.378-1.516,2.121,2.121,0,0,0-1.258-1.772c-.3-.146-.729-.2-.921.072a.838.838,0,0,0-.034.669q.315,1.373.633,2.746Z",
    transform: "translate(-143.99 -55.55)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.582,149.359a5.956,5.956,0,0,0,1.977-1.344,2.021,2.021,0,0,0,.363-2.229,1.784,1.784,0,0,0-.9-.747,2.222,2.222,0,1,0-1.4,4.21Z",
    transform: "translate(-139.334 -51.727)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.443,134.17c-.03-.813-.929-1.274-1.706-1.516s-1.692-.557-1.909-1.342a.708.708,0,0,1,.092-.637c.366-.441,1.046-.01,1.6.124a6.012,6.012,0,0,0,1.368-.006,2.734,2.734,0,0,1,2.494,1.785,1.5,1.5,0,0,1-2.664.731Z",
    transform: "translate(-126.494 -66.185)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.349,124.6c-.032-.813-.929-1.276-1.706-1.516s-1.694-.557-1.911-1.342a.708.708,0,0,1,.094-.637c.365-.441,1.046-.01,1.6.122a5.881,5.881,0,0,0,1.366,0,2.728,2.728,0,0,1,2.493,1.785,1.5,1.5,0,0,1-2.664.729Z",
    transform: "translate(-129.598 -75.784)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.014,117.6a4.329,4.329,0,0,0,.839-1.783.781.781,0,0,0,.018-.318.619.619,0,0,0-.429-.411,1.27,1.27,0,0,0-1.36.417,1.575,1.575,0,0,0-.25,1.434,1.064,1.064,0,0,0,.485.651.6.6,0,0,0,.749-.14.128.128,0,0,0-.21-.048Z",
    transform: "translate(-124.522 -81.679)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.584,161.539a4.915,4.915,0,0,0,3.295-2.816A5.083,5.083,0,0,0,568,158.04a1.726,1.726,0,0,0-1.708.825c-.4.827.172,1.775.723,2.512l-.753-.108Z",
    transform: "translate(-144.183 -38.555)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.234,157.206a1.317,1.317,0,0,0,2.247-.252,2.306,2.306,0,0,0-1.106-.927,1.116,1.116,0,0,0-1.3.411.745.745,0,0,0,.535,1.094Z",
    transform: "translate(-150.362 -40.627)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.6,148.948a1.316,1.316,0,0,0,2.247-.25,2.306,2.306,0,0,0-1.106-.927,1.116,1.116,0,0,0-1.3.411.743.743,0,0,0,.535,1.094Z",
    transform: "translate(-140.967 -48.907)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.691,159.165c-.591.162-.595,1.061-.2,1.528a17.736,17.736,0,0,0,1.452,1.116,2.2,2.2,0,0,1,.671,1.7,1.059,1.059,0,0,1-.5.923,1.314,1.314,0,0,1-.727.054,6.587,6.587,0,0,1-3.367-1.2,3.1,3.1,0,0,1-1.176-3.2,2.375,2.375,0,0,1,4.06-.843Z",
    transform: "translate(-149.614 -38.158)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.69,129.747c-.591.162-.595,1.061-.2,1.528a17.777,17.777,0,0,0,1.452,1.116,2.206,2.206,0,0,1,.671,1.706,1.058,1.058,0,0,1-.5.921,1.313,1.313,0,0,1-.727.054,6.588,6.588,0,0,1-3.367-1.2,3.1,3.1,0,0,1-1.176-3.2,2.375,2.375,0,0,1,4.06-.843Z",
    transform: "translate(-129.558 -67.657)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.272,131.442c-.589.162-.593,1.061-.2,1.528a17.738,17.738,0,0,0,1.452,1.118,2.2,2.2,0,0,1,.671,1.7,1.064,1.064,0,0,1-.5.923,1.314,1.314,0,0,1-.727.054,6.606,6.606,0,0,1-3.367-1.2,3.091,3.091,0,0,1-1.176-3.2,2.372,2.372,0,0,1,4.058-.843Z",
    transform: "translate(-125.965 -65.957)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.578,136.3c-.591.162-.595,1.061-.2,1.528a17.755,17.755,0,0,0,1.452,1.116,2.205,2.205,0,0,1,.671,1.706,1.058,1.058,0,0,1-.5.921,1.314,1.314,0,0,1-.727.054,6.588,6.588,0,0,1-3.367-1.2,3.1,3.1,0,0,1-1.176-3.2,2.375,2.375,0,0,1,4.06-.843Z",
    transform: "translate(-129.671 -61.082)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.577,103.966c-.591.162-.593,1.061-.2,1.528a17.428,17.428,0,0,0,1.452,1.118,2.2,2.2,0,0,1,.671,1.7,1.061,1.061,0,0,1-.5.923,1.314,1.314,0,0,1-.727.054,6.605,6.605,0,0,1-3.367-1.2,3.091,3.091,0,0,1-1.176-3.2,2.374,2.374,0,0,1,4.058-.843Z",
    transform: "translate(-157.749 -93.51)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.31,153.337l.637-.745a2.064,2.064,0,0,0-1.23-.819c-.5-.044-1.04.521-.767.947a1.028,1.028,0,0,0,.455.33l1.644.777Z",
    transform: "translate(-149.476 -44.836)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.712,122.811a5.952,5.952,0,0,0,1.977-1.342,2.025,2.025,0,0,0,.363-2.231,1.793,1.793,0,0,0-.9-.747,2.222,2.222,0,1,0-1.4,4.21Z",
    transform: "translate(-146.223 -78.349)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.328,153.761a1.623,1.623,0,0,1-2.766.136,4.541,4.541,0,0,1,.613-1.789,2.849,2.849,0,0,1,1.654,1.228Z",
    transform: "translate(-137.757 -44.497)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.28,119.734a3.362,3.362,0,0,0,.967-.971,1.159,1.159,0,0,0-.038-1.3c-.5-.575-1.456-.266-2.159-.551s-1.14-1.166-1.9-1.2-1.256.887-1.09,1.62a3.3,3.3,0,0,0,1.368,1.734,3.656,3.656,0,0,0,1.788.865,1.444,1.444,0,0,0,1.576-.951Z",
    transform: "translate(-143.307 -80.991)",
    fill: "#e0f3ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.807,141.273a9.561,9.561,0,0,0,9.225-.8c-.31-3.2-1.841-6.477-4.671-8.011s-6.982-.645-8.276,2.3,1.821,6.966,4.847,5.868Z",
    transform: "translate(-134.525 -64.936)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.451,155.694a.851.851,0,0,1-.395-1.12,1.584,1.584,0,0,1,1-.807,1.524,1.524,0,0,1,.767-.078,1.115,1.115,0,0,1,.8,1.386,1.194,1.194,0,0,1-1.454.725,1.286,1.286,0,0,1-.825-1.428Z",
    transform: "translate(-133.321 -42.933)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.663,147.414c-.3-.757-1.3-.9-2.111-.867s-1.782.036-2.247-.633a.714.714,0,0,1-.122-.631c.2-.537.984-.356,1.552-.417a5.916,5.916,0,0,0,1.288-.457,2.728,2.728,0,0,1,2.944.859,1.5,1.5,0,0,1-2.271,1.57Z",
    transform: "translate(-135.16 -52.353)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.561,134.368c.128-.286.256-.571.387-.857a1.14,1.14,0,0,0-1.392-.29.947.947,0,0,0-.307,1.33.812.812,0,0,0,1.3-.07Z",
    transform: "translate(-138.23 -63.566)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.557,143.92a.641.641,0,0,1-.919-.14,1.508,1.508,0,0,1-.214-1.011,1.814,1.814,0,0,1,.21-.823,1.259,1.259,0,0,1,1.486-.479,1.589,1.589,0,0,1,.967,1.29,1.033,1.033,0,0,1-.18.783.56.56,0,0,1-.737.128Z",
    transform: "translate(-137.903 -55.246)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.207,143.922a9.564,9.564,0,0,0,7.5,5.434c1.861-2.626,2.844-6.1,1.706-9.115s-4.859-5.057-7.763-3.673-3.181,6.459-.174,7.609Z",
    transform: "translate(-151.014 -60.524)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.517,152.978c.865-.375.38-1.867-.541-2.063a3.429,3.429,0,0,0-2.572.943,3.3,3.3,0,0,0,3.263,1.672Z",
    transform: "translate(-147.943 -45.733)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.785,151.7l.387-.857a1.14,1.14,0,0,0-1.392-.29.947.947,0,0,0-.307,1.33.812.812,0,0,0,1.3-.07Z",
    transform: "translate(-129.983 -46.182)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.02,152.922a22.451,22.451,0,0,0,4.875-8.913,3.967,3.967,0,0,0,.192-1.628,3.2,3.2,0,0,0-2.069-2.253,6.557,6.557,0,0,0-7.138,1.714,8.138,8.138,0,0,0-1.738,7.308,5.482,5.482,0,0,0,2.287,3.5,3.082,3.082,0,0,0,3.9-.489.667.667,0,0,0-1.073-.316Z",
    transform: "translate(-139.415 -56.95)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.593,131.315a9.572,9.572,0,0,0,6.912-6.165c-2.167-2.379-5.356-4.084-8.54-3.617s-5.976,3.665-5.245,6.8,5.628,4.486,7.394,1.8Z",
    transform: "translate(-159.779 -75.236)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.458,248.045a9.565,9.565,0,0,0,6.91-6.165c-2.167-2.377-5.354-4.082-8.538-3.615s-5.978,3.665-5.247,6.8,5.63,4.486,7.4,1.8Z",
    transform: "translate(-355.465 41.825)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.374,119.192a4.914,4.914,0,0,0,3.295-2.818,5.068,5.068,0,0,0-1.883-.681,1.725,1.725,0,0,0-1.708.825c-.4.825.174,1.772.723,2.51l-.753-.106Z",
    transform: "translate(-127.346 -81.022)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.188,114.7a1.929,1.929,0,0,0,.749-.985,2.02,2.02,0,0,0-.246-1.172,18.711,18.711,0,0,1-1.005-3.17l-2.572,4.911a1.115,1.115,0,0,1-.254.357c-.4.324-.985-.024-1.494.032-.745.082-1.088.969-1.16,1.714C579.7,121.7,584.44,116.177,586.188,114.7Z",
    transform: "translate(-130.13 -87.355)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.9,145.326l.827-1.4a2.6,2.6,0,0,0-3.01.3c-.739.791-.379,2.405.7,2.532.665.078,1.738-.068,1.65.595Z",
    transform: "translate(-132.979 -53.04)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.524,123.167a2.228,2.228,0,0,1-.819,1.063c-.5-1.053.008-2.3.569-3.319.315-.571.8-1.214,1.444-1.126.449.06.765.461,1.164.677.8.431,2.085.254,2.353,1.122a1.117,1.117,0,0,1-.671,1.242,3.273,3.273,0,0,1-1.514.19l-3.357-.114Z",
    transform: "translate(-135.815 -76.919)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.355,119.247c.865-.373.381-1.865-.541-2.061a3.414,3.414,0,0,0-2.572.943,3.31,3.31,0,0,0,3.265,1.672Z",
    transform: "translate(-145.097 -79.558)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.314,113.393a.857.857,0,0,1-.987-.661,1.587,1.587,0,0,1,.32-1.248,1.526,1.526,0,0,1,.567-.523,1.116,1.116,0,0,1,1.468.633,1.2,1.2,0,0,1-.729,1.452,1.284,1.284,0,0,1-1.516-.649Z",
    transform: "translate(-136.019 -85.851)",
    fill: "#e0f3ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.025,114.858a1.315,1.315,0,0,0,2.245-.25,2.276,2.276,0,0,0-1.105-.927,1.109,1.109,0,0,0-1.294.409.745.745,0,0,0,.533,1.1Z",
    transform: "translate(-133.525 -83.094)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.469,124.182a3.752,3.752,0,0,0,3.042-1.212q-1.109-.835-2.217-1.672a2.5,2.5,0,0,0-1.154-.585,1.489,1.489,0,0,0-1.5,1.646,2.09,2.09,0,0,0,1.7,1.686Z",
    transform: "translate(-127.659 -75.989)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.265,114.026a1.676,1.676,0,0,1-1.867-2.457c.222-.389.759-.685,1.107-.4a1.025,1.025,0,0,1,.273.483q.4,1.175.8,2.345l-.425.074Z",
    transform: "translate(-143.149 -85.667)",
    fill: "#e0f3ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.93,109.448c-.03-.815-.929-1.276-1.707-1.518s-1.692-.557-1.909-1.342a.709.709,0,0,1,.092-.635c.366-.443,1.046-.012,1.6.122a6.012,6.012,0,0,0,1.368-.006,2.733,2.733,0,0,1,2.493,1.787,1.5,1.5,0,0,1-2.664.729Z",
    transform: "translate(-148.067 -90.979)",
    fill: "#e0f3ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.576,136.921c-.03-.815-.929-1.276-1.707-1.518s-1.692-.557-1.909-1.342a.7.7,0,0,1,.094-.635c.364-.443,1.043-.012,1.6.122a5.994,5.994,0,0,0,1.366-.006,2.732,2.732,0,0,1,2.494,1.786,1.5,1.5,0,0,1-2.664.729Z",
    transform: "translate(-123.352 -63.428)",
    fill: "#e0f3ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.945,105.773l.649-.679a1.139,1.139,0,0,0-1.216-.737.95.95,0,0,0-.731,1.156.813.813,0,0,0,1.248.363Z",
    transform: "translate(-143.725 -92.399)",
    fill: "#e0f3ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.481,116.816c-.591.162-.595,1.061-.2,1.528a17.778,17.778,0,0,0,1.452,1.118,2.2,2.2,0,0,1,.671,1.7,1.06,1.06,0,0,1-.5.923,1.308,1.308,0,0,1-.725.054,6.606,6.606,0,0,1-3.369-1.2,3.1,3.1,0,0,1-1.176-3.2,2.373,2.373,0,0,1,4.06-.843Z",
    transform: "translate(-132.777 -80.624)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.1,118.047a1.477,1.477,0,0,0,1.378-1.516,2.126,2.126,0,0,0-1.258-1.772c-.3-.146-.729-.2-.921.072a.84.84,0,0,0-.034.669l.633,2.746Z",
    transform: "translate(-123.066 -82.075)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.326,126.423a2.493,2.493,0,0,1-1.728-3.555,6.248,6.248,0,0,1,3.167,1.616c.783.913.833,2.552-.208,3.154l-2.073-.385Z",
    transform: "translate(-143.017 -73.82)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.1,110.991l.637-.745a2.065,2.065,0,0,0-1.23-.819c-.5-.046-1.039.521-.767.945a1.013,1.013,0,0,0,.455.33q.823.391,1.644.779Z",
    transform: "translate(-132.639 -87.302)",
    fill: "#e0f3ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571,154.728a5.942,5.942,0,0,0,1.977-1.342,2.025,2.025,0,0,0,.363-2.231,1.8,1.8,0,0,0-.9-.747,2.222,2.222,0,1,0-1.4,4.21Z",
    transform: "translate(-140.925 -46.342)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.831,132.322l.823-1.412a2.9,2.9,0,0,0-1.055-.659,1.541,1.541,0,0,0-.194,2.147Z",
    transform: "translate(-151.301 -66.416)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.209,172.627a.853.853,0,0,1-.985-.661,1.591,1.591,0,0,1,.32-1.248,1.544,1.544,0,0,1,.567-.523,1.114,1.114,0,0,1,1.466.633,1.192,1.192,0,0,1-.729,1.452,1.285,1.285,0,0,1-1.516-.649Z",
    transform: "translate(-150.161 -26.45)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.037,129.683l.823-1.412a2.873,2.873,0,0,0-1.055-.659,1.541,1.541,0,0,0-.194,2.147Z",
    transform: "translate(-145.077 -69.063)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.694,141.949c.613.018.881-.839.639-1.4a17.277,17.277,0,0,0-1.062-1.494,2.206,2.206,0,0,1-.138-1.829,1.058,1.058,0,0,1,.749-.733,1.316,1.316,0,0,1,.711.16,6.592,6.592,0,0,1,2.864,2.139,3.093,3.093,0,0,1,.182,3.4,2.373,2.373,0,0,1-4.126-.387Z",
    transform: "translate(-125.287 -60.167)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.933,144.864a3.39,3.39,0,0,0-1.21.645,1.159,1.159,0,0,0-.344,1.25c.306.695,1.312.681,1.9,1.162s.745,1.45,1.464,1.7,1.46-.477,1.516-1.228a3.294,3.294,0,0,0-.8-2.061,3.666,3.666,0,0,0-1.454-1.352,1.446,1.446,0,0,0-1.786.447Z",
    transform: "translate(-141.021 -51.772)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.738,130.007a18.234,18.234,0,0,0-1.592,8.117,3.194,3.194,0,0,0,.25,1.31,2.606,2.606,0,0,0,2.161,1.242,5.344,5.344,0,0,0,5.119-3.088,6.622,6.622,0,0,0-.449-6.1,4.463,4.463,0,0,0-2.636-2.157,2.511,2.511,0,0,0-2.91,1.34.544.544,0,0,0,.911-.02Z",
    transform: "translate(-132.169 -67.408)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.407,138.764a1.933,1.933,0,0,0,1.226.16,2.031,2.031,0,0,0,.9-.8,18.461,18.461,0,0,1,2.249-2.447l-5.538.208a1.068,1.068,0,0,1-.437-.042c-.479-.182-.469-.867-.771-1.28-.441-.6-1.382-.461-2.063-.152C580.11,136.615,587.256,137.983,589.407,138.764Z",
    transform: "translate(-126.979 -62.508)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.925,130.4l.695-.633a1.137,1.137,0,0,0-1.161-.819.95.95,0,0,0-.809,1.1.813.813,0,0,0,1.22.453Z",
    transform: "translate(-131.674 -67.728)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.516,133.21a1.479,1.479,0,0,0,2,.443,2.125,2.125,0,0,0,.913-1.973c-.026-.336-.188-.735-.523-.765a.842.842,0,0,0-.6.3l-2.067,1.915Z",
    transform: "translate(-124.037 -65.752)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.1,130.186a4.913,4.913,0,0,0,4.082,1.458,5.075,5.075,0,0,0-.343-1.973,1.726,1.726,0,0,0-1.566-1.072c-.915.062-1.452,1.031-1.819,1.875l-.282-.7Z",
    transform: "translate(-128.193 -68.075)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.143,127.084a2.234,2.234,0,0,1-1.33-.18c.663-.961,1.995-1.136,3.162-1.158.651-.012,1.448.09,1.694.693.17.419-.02.891-.01,1.346.024.907.815,1.935.2,2.6a1.114,1.114,0,0,1-1.412.034,3.252,3.252,0,0,1-.917-1.218q-.784-1.484-1.572-2.968Z",
    transform: "translate(-130.486 -70.934)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.911,135.692a3.757,3.757,0,0,0,2.566,2.037q.171-1.379.346-2.756a2.491,2.491,0,0,0-.066-1.292,1.485,1.485,0,0,0-2.173-.483,2.09,2.09,0,0,0-.621,2.311Z",
    transform: "translate(-126.439 -63.738)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.548,129.28c-.435-.433-1.218.01-1.424.587a17.483,17.483,0,0,0-.246,1.817,2.21,2.21,0,0,1-1.146,1.43,1.062,1.062,0,0,1-1.05.024,1.323,1.323,0,0,1-.408-.6,6.591,6.591,0,0,1-.633-3.519,3.1,3.1,0,0,1,2.191-2.612,2.375,2.375,0,0,1,2.75,3.1Z",
    transform: "translate(-125.694 -70.326)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.578,138.383a5.917,5.917,0,0,0,2.149,1.047,2.021,2.021,0,0,0,2.115-.8,1.8,1.8,0,0,0,.2-1.154,2.222,2.222,0,1,0-4.35.877Z",
    transform: "translate(-140.749 -61.071)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.262,143.715a4.9,4.9,0,0,0,4.082,1.456A5.083,5.083,0,0,0,580,143.2a1.726,1.726,0,0,0-1.566-1.072c-.915.062-1.452,1.031-1.818,1.875l-.283-.7Z",
    transform: "translate(-134.047 -54.508)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.1,126.944c.028-.813-.835-1.338-1.594-1.632s-1.65-.675-1.811-1.474a.7.7,0,0,1,.138-.627c.395-.415,1.043.062,1.59.234a6.033,6.033,0,0,0,1.362.092,2.725,2.725,0,0,1,2.361,1.955,1.5,1.5,0,0,1-2.706.541Z",
    transform: "translate(-131.622 -73.642)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.527,149.123l.178-.921a1.141,1.141,0,0,0-1.422.04.947.947,0,0,0,.012,1.364.811.811,0,0,0,1.246-.368Z",
    transform: "translate(-151.358 -48.645)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.266,136.053c.32.06.643.12.963.182a2.07,2.07,0,0,0,.1-1.476c-.21-.459-.969-.643-1.2-.194a1.014,1.014,0,0,0-.06.559q.069.907.142,1.815Z",
    transform: "translate(-130.244 -62.348)",
    fill: "#e0f3ff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.786 38.467)",
    opacity: 0.396
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.032,174.682A37.566,37.566,0,0,0,417.8,163.4a6.575,6.575,0,0,0,1.232-2.459,5.362,5.362,0,0,0-1.981-4.733,11,11,0,0,0-12.241-1.36,13.641,13.641,0,0,0-6.9,10.541,9.185,9.185,0,0,0,1.612,6.83c1.518,1.863,4.394,2.718,6.435,1.452a1.118,1.118,0,0,0-1.512-1.11Z",
    transform: "translate(-373.771 -81.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.471,159.145a6.964,6.964,0,0,0,6.323-2.329,7.319,7.319,0,0,0-4.815-4.727c-2.281-.535-5.027.885-5.368,3.2s2.614,4.54,4.528,3.19Z",
    transform: "translate(-370.002 -83.097)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.55,149.392a3.576,3.576,0,0,0,3,.963,3.708,3.708,0,0,0-.3-1.426,1.255,1.255,0,0,0-1.164-.741c-.667.066-1.033.785-1.28,1.406l-.222-.507Z",
    transform: "translate(-360.008 -86.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.628,151.5a1.617,1.617,0,0,1-.837.5,2.744,2.744,0,0,1,1.27-2.095c.365-.3.865-.609,1.278-.379.288.16.395.517.607.769.427.507,1.344.729,1.294,1.388a.814.814,0,0,1-.785.663,2.391,2.391,0,0,1-1.076-.276l-2.243-.973Z",
    transform: "translate(-361.776 -85.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.119,131.4c.687-.024.757-1.162.184-1.542a2.489,2.489,0,0,0-1.993-.046,2.407,2.407,0,0,0,1.765,2Z",
    transform: "translate(-343.201 -105.508)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.656,121.961a.62.62,0,0,1-.491-.709,1.157,1.157,0,0,1,.549-.761,1.121,1.121,0,0,1,.525-.2.811.811,0,0,1,.823.821.871.871,0,0,1-.881.789.937.937,0,0,1-.853-.845Z",
    transform: "translate(-350.372 -114.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.2,143.887a.958.958,0,0,0,1.013,1.3,1.666,1.666,0,0,0,.152-1.039.815.815,0,0,0-.749-.647.544.544,0,0,0-.475.751Z",
    transform: "translate(-360.476 -91.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.634,151.97a2.727,2.727,0,0,0,1.915,1.42l.186-2.013a1.808,1.808,0,0,0-.078-.937,1.083,1.083,0,0,0-1.592-.3,1.526,1.526,0,0,0-.4,1.7Z",
    transform: "translate(-363 -85.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.094,126.147l.108-.675a.831.831,0,0,0-1.033.062.692.692,0,0,0,.04.993.592.592,0,0,0,.9-.3Z",
    transform: "translate(-351.557 -109.827)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.565,147.185c-.326-.3-.885.038-1.023.463a13.089,13.089,0,0,0-.136,1.326,1.606,1.606,0,0,1-.8,1.068.772.772,0,0,1-.763.042.958.958,0,0,1-.31-.429,4.8,4.8,0,0,1-.543-2.546,2.249,2.249,0,0,1,1.53-1.951,1.728,1.728,0,0,1,2.075,2.191Z",
    transform: "translate(-362.598 -89.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.049,152.017a1.073,1.073,0,0,0,1.464.274,1.541,1.541,0,0,0,.617-1.456c-.024-.244-.152-.531-.4-.545a.607.607,0,0,0-.427.236q-.73.721-1.458,1.442Z",
    transform: "translate(-357.703 -84.788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.336,142.269a1.814,1.814,0,0,1-.222-2.868,4.537,4.537,0,0,1,1.712,1.941,1.566,1.566,0,0,1-.983,2.079l-1.3-.813Z",
    transform: "translate(-350.018 -95.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.115,172.492a.471.471,0,0,1-.673.078,1.088,1.088,0,0,1-.342-.669,1.321,1.321,0,0,1-.012-.619.915.915,0,0,1,.951-.621,1.155,1.155,0,0,1,.927.721.748.748,0,0,1,.024.583.406.406,0,0,1-.493.23Z",
    transform: "translate(-381.563 -64.363)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.292,143.7l.7.11a1.5,1.5,0,0,0,.036-1.076c-.162-.328-.719-.445-.877-.114a.764.764,0,0,0-.032.409c.05.439.1.877.148,1.316Z",
    transform: "translate(-357.439 -92.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.971,139.244a4.318,4.318,0,0,0,1.7-.381,1.473,1.473,0,0,0,.841-1.414,1.3,1.3,0,0,0-.413-.747,1.618,1.618,0,1,0-2.073,2.477Z",
    transform: "translate(-354.142 -98.824)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.925,138.148l.933-.737a2.1,2.1,0,0,0-.539-.729,1.123,1.123,0,0,0-.7,1.4Z",
    transform: "translate(-350.976 -98.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.547,160.684a15.024,15.024,0,0,0,2.742-6.245,2.615,2.615,0,0,0,.034-1.1,2.142,2.142,0,0,0-1.514-1.388,4.4,4.4,0,0,0-4.675,1.562,5.463,5.463,0,0,0-.739,4.989,3.673,3.673,0,0,0,1.734,2.209,2.069,2.069,0,0,0,2.582-.553.448.448,0,0,0-.737-.148Z",
    transform: "translate(-351.431 -83.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.417,148.509a3.581,3.581,0,0,0,2.982-1.027,3.671,3.671,0,0,0-1.094-.965,1.258,1.258,0,0,0-1.376.1c-.493.453-.356,1.248-.182,1.893l-.481-.274Z",
    transform: "translate(-371.323 -88.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.243,145.651a1.406,1.406,0,0,0,.769-.467,1.488,1.488,0,0,0,.146-.859,13.535,13.535,0,0,1,.164-2.415l-3.052,2.638a.777.777,0,0,1-.266.174c-.354.114-.661-.278-1.019-.376-.527-.142-1,.367-1.242.851C397.983,148.658,402.665,146.184,404.243,145.651Z",
    transform: "translate(-372.239 -93.192)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.666,152.2a2.727,2.727,0,0,0,2.383-.01l-1.055-1.724a1.816,1.816,0,0,0-.625-.7,1.082,1.082,0,0,0-1.454.715,1.519,1.519,0,0,0,.7,1.594Z",
    transform: "translate(-372.719 -85.418)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.932,166.788l.106-.675a.828.828,0,0,0-1.031.062.69.69,0,0,0,.04.993.59.59,0,0,0,.9-.3Z",
    transform: "translate(-385.815 -69.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.774,149.114a1.077,1.077,0,0,0,1.338-.659,1.552,1.552,0,0,0-.378-1.536c-.168-.178-.441-.332-.645-.2a.605.605,0,0,0-.2.443c-.1.677-.2,1.354-.3,2.029Z",
    transform: "translate(-367.997 -88.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.189,153.637a4.31,4.31,0,0,0,1.7-.381,1.473,1.473,0,0,0,.841-1.414,1.3,1.3,0,0,0-.413-.747,1.617,1.617,0,1,0-2.071,2.477Z",
    transform: "translate(-365.957 -84.39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.064,147.508c.2-.559-.288-1.112-.749-1.482s-1-.829-.935-1.418a.511.511,0,0,1,.232-.4c.365-.2.711.27,1.051.509a4.372,4.372,0,0,0,.927.362,1.986,1.986,0,0,1,1.212,1.873,1.094,1.094,0,0,1-2-.216Z",
    transform: "translate(-353.165 -90.941)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.524,140.2c.2-.559-.288-1.112-.751-1.482s-1-.829-.935-1.418a.519.519,0,0,1,.234-.407c.365-.2.711.272,1.052.511a4.442,4.442,0,0,0,.927.363,1.986,1.986,0,0,1,1.212,1.873,1.1,1.1,0,0,1-2-.216Z",
    transform: "translate(-352.705 -98.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.327,136.091a3.161,3.161,0,0,0,1.043-.983.557.557,0,0,0,.1-.21.45.45,0,0,0-.178-.393.923.923,0,0,0-1.033-.08,1.148,1.148,0,0,0-.553.9.775.775,0,0,0,.154.571.435.435,0,0,0,.545.1.093.093,0,0,0-.13-.088Z",
    transform: "translate(-347.826 -100.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.932,160.36a3.575,3.575,0,0,0,2.982-1.027,3.653,3.653,0,0,0-1.091-.963,1.257,1.257,0,0,0-1.378.1c-.493.453-.357,1.248-.18,1.893l-.481-.274Z",
    transform: "translate(-372.81 -76.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.523,155.8a.959.959,0,0,0,1.588.431,1.668,1.668,0,0,0-.5-.923.81.81,0,0,0-.985-.068.54.54,0,0,0,.068.883Z",
    transform: "translate(-376.175 -79.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.07,152.712a.958.958,0,0,0,1.588.429,1.67,1.67,0,0,0-.5-.923.81.81,0,0,0-.985-.068.541.541,0,0,0,.07.883Z",
    transform: "translate(-367.604 -83.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.272,158.161c-.443-.048-.685.559-.541.981a12.578,12.578,0,0,0,.685,1.144,1.607,1.607,0,0,1,0,1.334.777.777,0,0,1-.587.491.949.949,0,0,1-.5-.158,4.811,4.811,0,0,1-1.961-1.71,2.258,2.258,0,0,1,.058-2.479,1.729,1.729,0,0,1,2.974.511Z",
    transform: "translate(-376.582 -77.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.665,143.581c-.445-.048-.687.559-.543.981a12.628,12.628,0,0,0,.687,1.144,1.607,1.607,0,0,1,0,1.334.767.767,0,0,1-.585.491.977.977,0,0,1-.507-.156,4.8,4.8,0,0,1-1.959-1.712,2.251,2.251,0,0,1,.058-2.479,1.726,1.726,0,0,1,2.972.513Z",
    transform: "translate(-355.131 -92.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.639,145.685c-.445-.048-.687.561-.543.981a12.794,12.794,0,0,0,.685,1.144,1.6,1.6,0,0,1,0,1.334.767.767,0,0,1-.585.491.936.936,0,0,1-.507-.156,4.8,4.8,0,0,1-1.959-1.712,2.251,2.251,0,0,1,.058-2.479,1.726,1.726,0,0,1,2.972.513Z",
    transform: "translate(-353.151 -90.448)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.839,147.99c-.443-.046-.687.561-.543.983a12.908,12.908,0,0,0,.687,1.144,1.607,1.607,0,0,1,0,1.334.771.771,0,0,1-.585.491.961.961,0,0,1-.507-.158,4.8,4.8,0,0,1-1.959-1.712,2.251,2.251,0,0,1,.058-2.479,1.726,1.726,0,0,1,2.972.513Z",
    transform: "translate(-356.962 -88.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.512,118.624c-.445-.048-.687.559-.543.981s.5.739.685,1.144a1.6,1.6,0,0,1,0,1.334.771.771,0,0,1-.585.491.956.956,0,0,1-.507-.158A4.783,4.783,0,0,1,404.6,120.7a2.251,2.251,0,0,1,.058-2.479,1.728,1.728,0,0,1,2.972.513Z",
    transform: "translate(-367.318 -117.585)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.934,153.751l.631-.335a1.5,1.5,0,0,0-.615-.883c-.326-.164-.841.074-.771.437a.744.744,0,0,0,.22.344l.905.965Z",
    transform: "translate(-374.426 -82.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.623,133.829a4.326,4.326,0,0,0,1.7-.381,1.473,1.473,0,0,0,.841-1.414,1.3,1.3,0,0,0-.413-.747,1.618,1.618,0,1,0-2.073,2.478Z",
    transform: "translate(-363.516 -104.254)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.772,157.517a1.183,1.183,0,0,1-1.911-.647,3.307,3.307,0,0,1,.893-1.047,2.087,2.087,0,0,1,.791,1.272Z",
    transform: "translate(-366.716 -79.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.085,133.357a2.492,2.492,0,0,0,.915-.4.845.845,0,0,0,.318-.887c-.182-.523-.915-.569-1.316-.949s-.459-1.094-.967-1.318-1.086.264-1.168.807a2.394,2.394,0,0,0,.463,1.538,2.672,2.672,0,0,0,.979,1.064,1.051,1.051,0,0,0,1.322-.224Z",
    transform: "translate(-360.708 -105.388)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.607,149.769a6.962,6.962,0,0,0,6.459,1.923,7.322,7.322,0,0,0-1.023-6.669c-1.506-1.795-4.556-2.3-6.217-.651s-.627,5.2,1.714,5.265Z",
    transform: "translate(-359.546 -91.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.645,159.3a.623.623,0,0,1,.032-.863,1.152,1.152,0,0,1,.9-.278,1.109,1.109,0,0,1,.541.15.813.813,0,0,1,.168,1.152.87.87,0,0,1-1.178.1.938.938,0,0,1-.178-1.188Z",
    transform: "translate(-364.084 -76.903)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.338,154.178c0-.593-.641-.953-1.2-1.152s-1.216-.451-1.352-1.027a.514.514,0,0,1,.086-.461c.276-.31.759.02,1.162.134a4.557,4.557,0,0,0,.993.034,1.985,1.985,0,0,1,1.765,1.366,1.093,1.093,0,0,1-1.957.457Z",
    transform: "translate(-362.799 -83.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.661,143.895l.491-.477a.828.828,0,0,0-.863-.569.689.689,0,0,0-.563.819.591.591,0,0,0,.9.3Z",
    transform: "translate(-361.859 -92.257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.216,150.329a.468.468,0,0,1-.585-.342,1.09,1.09,0,0,1,.124-.741,1.339,1.339,0,0,1,.363-.5.912.912,0,0,1,1.134.072,1.155,1.155,0,0,1,.31,1.132.745.745,0,0,1-.331.483.407.407,0,0,1-.533-.11Z",
    transform: "translate(-363.964 -86.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.667,146.447a6.97,6.97,0,0,0,3.629,5.68,7.323,7.323,0,0,0,3.587-5.716c.034-2.341-1.941-4.719-4.276-4.558s-3.875,3.525-2.149,5.105Z",
    transform: "translate(-371.925 -93.257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.229,154.209c.687-.022.757-1.16.184-1.54a2.489,2.489,0,0,0-1.993-.046,2.407,2.407,0,0,0,1.764,2Z",
    transform: "translate(-373.175 -82.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.6,157.827l.491-.477a.829.829,0,0,0-.865-.569.689.689,0,0,0-.561.819.591.591,0,0,0,.9.3Z",
    transform: "translate(-360.914 -78.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.113,156.727a16.28,16.28,0,0,0,5.678-4.733,2.839,2.839,0,0,0,.565-1.051,2.321,2.321,0,0,0-.8-2.077,4.774,4.774,0,0,0-5.289-.745,5.92,5.92,0,0,0-3.126,4.484,3.983,3.983,0,0,0,.613,2.982,2.244,2.244,0,0,0,2.772.711.486.486,0,0,0-.643-.5Z",
    transform: "translate(-365.488 -87.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.408,136.98a6.963,6.963,0,0,0,6.323-2.327,7.322,7.322,0,0,0-4.815-4.729c-2.281-.533-5.027.887-5.368,3.2s2.614,4.538,4.528,3.188Z",
    transform: "translate(-374.077 -105.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.6,136.169a3.57,3.57,0,0,0,2.982-1.027,3.654,3.654,0,0,0-1.091-.963,1.254,1.254,0,0,0-1.376.1c-.493.453-.357,1.248-.182,1.893l-.481-.274Z",
    transform: "translate(-350.078 -101.102)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.429,133.311a1.413,1.413,0,0,0,.769-.467,1.487,1.487,0,0,0,.146-.859,13.559,13.559,0,0,1,.164-2.415q-1.526,1.322-3.052,2.638a.777.777,0,0,1-.266.174c-.354.114-.661-.278-1.021-.377-.525-.142-.993.367-1.24.851C419.169,136.317,423.849,133.846,425.429,133.311Z",
    transform: "translate(-350.994 -105.567)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.15,152.906l.933-.727a1.891,1.891,0,0,0-2.119-.6c-.709.338-.9,1.528-.2,1.9.429.23,1.2.419.959.843Z",
    transform: "translate(-361.235 -83.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.357,136.677a1.63,1.63,0,0,1-.839.5,2.741,2.741,0,0,1,1.272-2.095c.362-.3.863-.609,1.276-.379.288.162.395.517.607.769.427.507,1.344.729,1.3,1.388a.816.816,0,0,1-.787.663,2.4,2.4,0,0,1-1.076-.276l-2.243-.973Z",
    transform: "translate(-357.036 -100.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.153,132.129c.685-.022.755-1.16.184-1.54a2.5,2.5,0,0,0-1.993-.048,2.407,2.407,0,0,0,1.765,2Z",
    transform: "translate(-362.221 -104.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.537,130.109a.621.621,0,0,1-.493-.709,1.151,1.151,0,0,1,.551-.759,1.1,1.1,0,0,1,.523-.2.814.814,0,0,1,.825.821.872.872,0,0,1-.881.789.937.937,0,0,1-.853-.845Z",
    transform: "translate(-354.505 -106.704)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.193,131.609a.958.958,0,0,0,1.588.431,1.67,1.67,0,0,0-.5-.923.81.81,0,0,0-.985-.068.541.541,0,0,0,.07.883Z",
    transform: "translate(-353.441 -104.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.853,139.856a2.727,2.727,0,0,0,2.383-.01l-1.056-1.722a1.822,1.822,0,0,0-.625-.7,1.085,1.085,0,0,0-1.456.715,1.52,1.52,0,0,0,.7,1.594Z",
    transform: "translate(-351.474 -97.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.255,128.961a1.221,1.221,0,0,1-.609-2.163c.254-.2.7-.26.857.024a.745.745,0,0,1,.056.4l-.084,1.8-.308-.064Z",
    transform: "translate(-359.364 -108.518)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.1,125.027c.2-.559-.288-1.112-.751-1.482s-1-.829-.935-1.418a.518.518,0,0,1,.234-.4c.365-.2.711.27,1.051.509a4.292,4.292,0,0,0,.927.363,1.987,1.987,0,0,1,1.212,1.875,1.1,1.1,0,0,1-2-.218Z",
    transform: "translate(-361.155 -113.485)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.453,150.207c.2-.559-.288-1.112-.751-1.482s-1-.829-.935-1.42a.518.518,0,0,1,.234-.4c.365-.2.711.27,1.051.511a4.437,4.437,0,0,0,.927.361,1.989,1.989,0,0,1,1.212,1.875,1.095,1.095,0,0,1-2-.216Z",
    transform: "translate(-351.774 -88.236)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.485,123.034l.619-.286a.828.828,0,0,0-.627-.823.689.689,0,0,0-.8.587.59.59,0,0,0,.747.579Z",
    transform: "translate(-357.878 -113.245)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.943,133.97c-.443-.048-.687.559-.543.981a12.9,12.9,0,0,0,.687,1.144,1.606,1.606,0,0,1,0,1.334.771.771,0,0,1-.585.491.961.961,0,0,1-.507-.158,4.781,4.781,0,0,1-1.959-1.712,2.247,2.247,0,0,1,.058-2.477,1.727,1.727,0,0,1,2.972.511Z",
    transform: "translate(-353.849 -102.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.96,136.774a1.073,1.073,0,0,0,1.336-.659,1.544,1.544,0,0,0-.379-1.536c-.166-.178-.439-.332-.643-.2a.616.616,0,0,0-.2.445c-.1.675-.2,1.352-.3,2.027Z",
    transform: "translate(-346.751 -100.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.969,137.449a1.815,1.815,0,0,1-.222-2.868,4.536,4.536,0,0,1,1.714,1.939,1.568,1.568,0,0,1-.983,2.081c-.435-.27-.867-.543-1.3-.813Z",
    transform: "translate(-362.419 -100.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.6,129.56c.21-.112.421-.224.631-.334a1.5,1.5,0,0,0-.615-.883c-.328-.164-.843.074-.771.435a.751.751,0,0,0,.218.346l.907.965Z",
    transform: "translate(-351.693 -106.851)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.682,156.849a4.362,4.362,0,0,0,1.7-.38,1.471,1.471,0,0,0,.839-1.414,1.3,1.3,0,0,0-.411-.747,1.618,1.618,0,1,0-2.073,2.477Z",
    transform: "translate(-368.472 -81.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.957,138.874l.935-.737a2.114,2.114,0,0,0-.539-.727,1.122,1.122,0,0,0-.7,1.4Z",
    transform: "translate(-369.995 -97.704)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.18,166.451a.622.622,0,0,1-.493-.711,1.157,1.157,0,0,1,.549-.759,1.128,1.128,0,0,1,.525-.2.811.811,0,0,1,.825.819.869.869,0,0,1-.881.789.937.937,0,0,1-.855-.845Z",
    transform: "translate(-379.933 -70.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.865,138.744l.933-.737a2.077,2.077,0,0,0-.539-.727,1.123,1.123,0,0,0-.7,1.4Z",
    transform: "translate(-365.075 -97.835)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.238,152.253c.411.176.821-.334.807-.779a13,13,0,0,0-.318-1.3,1.6,1.6,0,0,1,.393-1.274.769.769,0,0,1,.7-.3.947.947,0,0,1,.439.3,4.822,4.822,0,0,1,1.37,2.213,2.254,2.254,0,0,1-.785,2.353,1.73,1.73,0,0,1-2.692-1.364Z",
    transform: "translate(-354.389 -86.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.159,150.183a2.5,2.5,0,0,0-.991.112.843.843,0,0,0-.565.755c.02.553.7.813.977,1.294s.118,1.182.537,1.544a.938.938,0,0,0,1.354-.427,2.394,2.394,0,0,0,.01-1.608,2.687,2.687,0,0,0-.623-1.3,1.056,1.056,0,0,0-1.33-.174Z",
    transform: "translate(-366.975 -84.899)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.128,142.251a13.246,13.246,0,0,0-3.243,5.069,2.29,2.29,0,0,0-.18.955,1.894,1.894,0,0,0,1.132,1.416,3.884,3.884,0,0,0,4.288-.725,4.817,4.817,0,0,0,1.326-4.248,3.251,3.251,0,0,0-1.21-2.163,1.825,1.825,0,0,0-2.327.13.394.394,0,0,0,.621.228Z",
    transform: "translate(-357.852 -92.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.315,150.893a1.409,1.409,0,0,0,.787.435,1.494,1.494,0,0,0,.819-.3,13.469,13.469,0,0,1,2.175-1.057l-3.805-1.338a.8.8,0,0,1-.284-.144c-.274-.25-.086-.713-.18-1.074-.138-.527-.811-.679-1.356-.653C414.593,146.956,419.067,149.788,420.315,150.893Z",
    transform: "translate(-354.621 -88.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.022,142.908l.639-.244a.832.832,0,0,0-.569-.865.692.692,0,0,0-.841.529.593.593,0,0,0,.705.633Z",
    transform: "translate(-356.301 -93.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.888,146.331a1.076,1.076,0,0,0,1.236.833,1.545,1.545,0,0,0,1.144-1.092c.074-.234.07-.547-.148-.657a.6.6,0,0,0-.485.046l-1.911.745Z",
    transform: "translate(-351.811 -89.712)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.62,143.175A3.573,3.573,0,0,0,420,145.25a3.686,3.686,0,0,0,.292-1.426,1.253,1.253,0,0,0-.773-1.144c-.637-.2-1.26.31-1.732.783l0-.553Z",
    transform: "translate(-353.921 -92.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.743,140.831a1.619,1.619,0,0,1-.853-.479,2.745,2.745,0,0,1,2.449.062c.445.164.957.447.963.919,0,.33-.252.6-.365.909-.228.621.034,1.528-.561,1.813a.811.811,0,0,1-.965-.352,2.381,2.381,0,0,1-.3-1.07l-.27-2.429Z",
    transform: "translate(-354.653 -95.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.514,147.48a2.735,2.735,0,0,0,1.194,2.063l.969-1.775a1.8,1.8,0,0,0,.3-.891,1.084,1.084,0,0,0-1.344-.907,1.522,1.522,0,0,0-1.035,1.4Z",
    transform: "translate(-354.028 -89.152)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.288,144.511c-.178-.409-.827-.316-1.122.018a12.866,12.866,0,0,0-.651,1.164,1.6,1.6,0,0,1-1.158.661.762.762,0,0,1-.715-.262.954.954,0,0,1-.116-.517,4.8,4.8,0,0,1,.511-2.552,2.254,2.254,0,0,1,2.179-1.184,1.728,1.728,0,0,1,1.035,2.834Z",
    transform: "translate(-352.013 -93.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.117,145.407a4.31,4.31,0,0,0,1.174,1.282,1.47,1.47,0,0,0,1.644.026,1.3,1.3,0,0,0,.443-.727,1.617,1.617,0,1,0-3.178-.567Z",
    transform: "translate(-364.454 -91.097)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.057,150.777a3.574,3.574,0,0,0,2.375,2.075,3.688,3.688,0,0,0,.294-1.426,1.258,1.258,0,0,0-.775-1.144c-.637-.2-1.26.31-1.732.783l0-.553Z",
    transform: "translate(-361.506 -84.841)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.383,141.192c.234-.545-.21-1.13-.645-1.532s-.935-.9-.833-1.48a.518.518,0,0,1,.262-.389c.378-.176.689.32,1.013.583a4.362,4.362,0,0,0,.9.427,1.985,1.985,0,0,1,1.075,1.955,1.094,1.094,0,0,1-1.977-.359Z",
    transform: "translate(-354.652 -97.359)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.9,150.4l.367-.577a.83.83,0,0,0-.973-.353.69.69,0,0,0-.356.927.591.591,0,0,0,.941.082Z",
    transform: "translate(-374.732 -85.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.9,146.87c.2.128.4.254.6.381a1.5,1.5,0,0,0,.461-.971c-.02-.367-.485-.693-.761-.453a.747.747,0,0,0-.19.363l-.389,1.266Z",
    transform: "translate(-356.926 -89.347)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 19.854)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(458.397 135.348)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M630.04,223.089l-11.206-1.408c-6.309-2.309-13.253-5.346-18.66-10.082-13.038-11.478-18-23.159-17.218-25.784.781-2.61,18.638.138,30.881,8.87C625.377,202.915,629.067,217.626,630.04,223.089Z",
    transform: "translate(-582.876 -166.845)",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M609.742,211.288s-1.422-8.516.927-13.775S621.715,187,622.831,188,609.742,211.288,609.742,211.288Z",
    transform: "translate(-556.362 -163.832)",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M582.917,185.344s25.236,10.27,32.978,18.572a73.1,73.1,0,0,1,11.736,16.846S596.971,220.269,582.917,185.344Z",
    transform: "translate(-582.836 -166.37)",
    opacity: 0.82,
    fill: "url(#c)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M625.315,220.679a71.58,71.58,0,0,1-12.656,12l-2.5-.314.789-.809s-6.767-6.087-6.257-20.166,16.1-37.8,20.345-35.338S633.292,211.049,625.315,220.679Z",
    transform: "translate(-561.029 -175.87)",
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M608.564,230.3s2.7-37.891,11.546-54.054C620.11,176.245,636.974,213.646,608.564,230.3Z",
    transform: "translate(-557.116 -175.494)",
    opacity: 0.82,
    fill: "url(#e)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(448.235 62.191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M619.638,189.426a35.523,35.523,0,0,0-1.746-16.017,6.244,6.244,0,0,0-1.228-2.293,5.071,5.071,0,0,0-4.735-1.053,10.41,10.41,0,0,0-7.729,8.708,12.9,12.9,0,0,0,4.372,11.084,8.691,8.691,0,0,0,6.153,2.481c2.265-.156,4.494-1.911,4.633-4.176a1.057,1.057,0,0,0-1.682.563Z",
    transform: "translate(-551.429 -108.697)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.442,176.574a6.582,6.582,0,0,0,1.652-6.155,6.924,6.924,0,0,0-6.277,1.14c-1.656,1.47-2.059,4.364-.455,5.892s4.931.459,4.933-1.757Z",
    transform: "translate(-552.186 -108.456)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.649,164.646a3.38,3.38,0,0,0,2.383-1.795,3.5,3.5,0,0,0-1.264-.549,1.188,1.188,0,0,0-1.208.495c-.31.549.044,1.226.389,1.754l-.513-.106Z",
    transform: "translate(-550.09 -116.334)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.616,166.836a1.527,1.527,0,0,1-.07.921,2.6,2.6,0,0,1-.923-2.125c-.036-.447,0-1,.4-1.192.282-.136.615-.024.925-.05.623-.052,1.3-.639,1.779-.24a.766.766,0,0,1,.08.967,2.245,2.245,0,0,1-.8.679l-1.977,1.2Z",
    transform: "translate(-549.915 -114.605)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.18,140.372c.356-.541-.483-1.216-1.088-.981a2.356,2.356,0,0,0-1.126,1.512,2.274,2.274,0,0,0,2.51-.268Z",
    transform: "translate(-555.576 -139.343)",
    fill: "#047fc4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.116,141.608a.587.587,0,0,1-.815-.006,1.093,1.093,0,0,1-.288-.839,1.056,1.056,0,0,1,.13-.515.769.769,0,0,1,1.083-.19.825.825,0,0,1,.128,1.112.886.886,0,0,1-1.118.2Z",
    transform: "translate(-566.562 -138.771)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.46,161.411a.9.9,0,0,0,1.552-.076,1.574,1.574,0,0,0-.719-.685.767.767,0,0,0-.907.226.513.513,0,0,0,.32.775Z",
    transform: "translate(-554.229 -118.035)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.189,168.124a2.581,2.581,0,0,0,2.139-.7q-.724-.622-1.452-1.242a1.706,1.706,0,0,0-.765-.453,1.025,1.025,0,0,0-1.1,1.068,1.44,1.44,0,0,0,1.094,1.232Z",
    transform: "translate(-550.52 -112.897)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.143,144.177l-.463-.453a.785.785,0,0,0-.517.831.651.651,0,0,0,.789.511.558.558,0,0,0,.26-.855Z",
    transform: "translate(-563.41 -134.95)",
    fill: "#047fc4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.469,162.918c-.412.086-.453.7-.2,1.041s.663.519.949.829a1.524,1.524,0,0,1,.389,1.2.73.73,0,0,1-.385.611.886.886,0,0,1-.5.006,4.54,4.54,0,0,1-2.261-.967,2.132,2.132,0,0,1-.671-2.247,1.635,1.635,0,0,1,2.824-.407Z",
    transform: "translate(-553.855 -116.278)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.922,164.084a1.016,1.016,0,0,0,1.011-.981,1.465,1.465,0,0,0-.789-1.272c-.2-.112-.493-.17-.637.01a.582.582,0,0,0-.05.459l.317,1.913Z",
    transform: "translate(-547.084 -116.898)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.231,151.992A1.716,1.716,0,0,1,603.9,150.6a4.292,4.292,0,0,1,2.431-.264,1.481,1.481,0,0,1,1.07,1.895c-.445.186-.891.373-1.336.561Z",
    transform: "translate(-551.635 -128.413)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.529,192.731a.442.442,0,0,1-.306.561,1.026,1.026,0,0,1-.7-.1,1.241,1.241,0,0,1-.483-.328.865.865,0,0,1,.04-1.073,1.091,1.091,0,0,1,1.062-.322.7.7,0,0,1,.463.3.384.384,0,0,1-.09.507Z",
    transform: "translate(-544.645 -87.101)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.046,158.848c.158-.162.314-.322.471-.485a1.435,1.435,0,0,0-.811-.615c-.342-.052-.735.314-.567.617a.721.721,0,0,0,.3.246c.365.2.731.4,1.1.6Z",
    transform: "translate(-553.438 -120.891)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.394,154.247a4.116,4.116,0,0,0,.631-1.518,1.39,1.39,0,0,0-.633-1.42,1.226,1.226,0,0,0-.8-.09,1.528,1.528,0,1,0,.781,2.95Z",
    transform: "translate(-556.17 -127.463)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.259,150.744q-.03-.562-.06-1.124a1.986,1.986,0,0,0-.855.02,1.06,1.06,0,0,0,.7,1.31Z",
    transform: "translate(-554.243 -129.074)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.954,162.335a14.2,14.2,0,0,0-3.325-5.526,2.5,2.5,0,0,0-.829-.627,2.032,2.032,0,0,0-1.9.413,4.165,4.165,0,0,0-1.344,4.462,5.162,5.162,0,0,0,3.449,3.293,3.479,3.479,0,0,0,2.652-.132,1.96,1.96,0,0,0,.981-2.3.423.423,0,0,0-.517.487Z",
    transform: "translate(-542.128 -122.555)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.976,172.814a3.381,3.381,0,0,0,.833-2.864,3.471,3.471,0,0,0-1.34.318,1.182,1.182,0,0,0-.671,1.118c.08.627.767.957,1.362,1.174l-.475.222Z",
    transform: "translate(-557.757 -108.65)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.874,169.7a1.338,1.338,0,0,0,.06-.849,1.4,1.4,0,0,0-.585-.581,12.776,12.776,0,0,1-1.772-1.444q.183,1.9.37,3.8a.723.723,0,0,1-.012.3c-.106.336-.575.359-.847.583-.4.326-.26.967-.02,1.422C596.78,176.177,597.425,171.212,597.874,169.7Z",
    transform: "translate(-560.72 -111.781)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.48,175.106a2.589,2.589,0,0,0,1.294-1.847q-.955-.06-1.907-.124a1.715,1.715,0,0,0-.885.1,1.024,1.024,0,0,0-.242,1.512,1.438,1.438,0,0,0,1.614.33Z",
    transform: "translate(-556.031 -105.469)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.879,192.725l-.463-.451a.781.781,0,0,0-.515.831.652.652,0,0,0,.787.511.559.559,0,0,0,.26-.855Z",
    transform: "translate(-550.636 -86.263)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.4,170.031a1.018,1.018,0,0,0,.22-1.392,1.459,1.459,0,0,0-1.392-.547c-.23.03-.5.158-.5.391a.574.574,0,0,0,.232.4l1.4,1.342Z",
    transform: "translate(-555.822 -110.528)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.076,171.2a4.087,4.087,0,0,0,.633-1.518,1.4,1.4,0,0,0-.633-1.42,1.238,1.238,0,0,0-.8-.09,1.529,1.529,0,1,0,.781,2.952Z",
    transform: "translate(-551.472 -110.466)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.119,156.942c-.324-.457-1.016-.385-1.554-.23s-1.184.318-1.6-.052a.493.493,0,0,1-.186-.4c.044-.393.6-.4.969-.535a4.119,4.119,0,0,0,.783-.519,1.877,1.877,0,0,1,2.109.088,1.034,1.034,0,0,1-1.258,1.424Z",
    transform: "translate(-549.754 -123.719)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.728,152.6c-.324-.457-1.016-.383-1.554-.228s-1.184.318-1.6-.052a.488.488,0,0,1-.186-.4c.044-.393.6-.4.967-.535a4.065,4.065,0,0,0,.785-.519,1.877,1.877,0,0,1,2.109.088,1.034,1.034,0,0,1-1.258,1.424Z",
    transform: "translate(-555.16 -128.072)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.517,147.242a3,3,0,0,0-.19-1.342.564.564,0,0,0-.11-.19.426.426,0,0,0-.4-.076.877.877,0,0,0-.627.753,1.083,1.083,0,0,0,.4.921.722.722,0,0,0,.523.19.411.411,0,0,0,.379-.363.09.09,0,0,0-.14.052Z",
    transform: "translate(-554.355 -133.052)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.316,180.426a3.384,3.384,0,0,0,.833-2.864,3.513,3.513,0,0,0-1.34.316,1.189,1.189,0,0,0-.671,1.12c.08.627.769.955,1.362,1.172l-.473.222Z",
    transform: "translate(-549.393 -101.017)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.107,180.083a.907.907,0,0,0,1.2-.991,1.577,1.577,0,0,0-.987-.116.765.765,0,0,0-.591.723.512.512,0,0,0,.721.429Z",
    transform: "translate(-553.81 -99.636)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.385,171.8a.906.906,0,0,0,1.2-.993,1.571,1.571,0,0,0-.985-.114.765.765,0,0,0-.591.723.513.513,0,0,0,.721.429Z",
    transform: "translate(-551.526 -107.944)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.208,179.848c-.278.316.058.837.463.955a12.439,12.439,0,0,0,1.258.094,1.521,1.521,0,0,1,1.03.729.727.727,0,0,1,.058.719.891.891,0,0,1-.4.306,4.552,4.552,0,0,1-2.391.577,2.125,2.125,0,0,1-1.883-1.4,1.633,1.633,0,0,1,2.019-2.015Z",
    transform: "translate(-552.246 -98.816)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.623,155.378c-.278.316.058.835.463.955a12.439,12.439,0,0,0,1.258.094,1.525,1.525,0,0,1,1.029.727.731.731,0,0,1,.058.721.887.887,0,0,1-.4.3,4.535,4.535,0,0,1-2.391.579,2.131,2.131,0,0,1-1.883-1.4,1.633,1.633,0,0,1,2.019-2.015Z",
    transform: "translate(-551.83 -123.355)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.325,155c-.278.316.058.835.463.955a12.421,12.421,0,0,0,1.258.094,1.513,1.513,0,0,1,1.027.729.728.728,0,0,1,.06.719.91.91,0,0,1-.4.3,4.536,4.536,0,0,1-2.391.579,2.125,2.125,0,0,1-1.883-1.4,1.633,1.633,0,0,1,2.017-2.015Z",
    transform: "translate(-549.121 -123.732)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.033,159.194c-.28.316.058.835.461.953a11.875,11.875,0,0,0,1.258.1,1.513,1.513,0,0,1,1.03.727.728.728,0,0,1,.06.719.908.908,0,0,1-.4.306,4.554,4.554,0,0,1-2.391.579,2.131,2.131,0,0,1-1.883-1.4,1.635,1.635,0,0,1,2.019-2.017Z",
    transform: "translate(-549.415 -119.529)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.724,151.144c-.278.316.058.835.463.953a11.872,11.872,0,0,0,1.258.1,1.5,1.5,0,0,1,1.027.727.731.731,0,0,1,.06.721.913.913,0,0,1-.4.3,4.553,4.553,0,0,1-2.391.579,2.131,2.131,0,0,1-1.883-1.4,1.632,1.632,0,0,1,2.017-2.015Z",
    transform: "translate(-577.802 -127.601)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.855,177.017l.084-.669a1.42,1.42,0,0,0-1.015-.008c-.306.164-.4.693-.086.835a.722.722,0,0,0,.387.018l1.24-.172Z",
    transform: "translate(-554.898 -102.335)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.111,158.508a4.071,4.071,0,0,0,.633-1.518,1.4,1.4,0,0,0-.633-1.42,1.225,1.225,0,0,0-.8-.088,1.528,1.528,0,1,0,.781,2.95Z",
    transform: "translate(-565.477 -123.189)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.432,172.31a1.117,1.117,0,0,1-1.54,1.122,3.067,3.067,0,0,1-.323-1.262,1.97,1.97,0,0,1,1.414.084Z",
    transform: "translate(-547.952 -106.517)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.279,154.579a2.361,2.361,0,0,0,.192-.925.8.8,0,0,0-.513-.729c-.5-.144-.937.395-1.45.5s-1.1-.242-1.544.028a.886.886,0,0,0-.016,1.342,2.269,2.269,0,0,0,1.442.483,2.524,2.524,0,0,0,1.354-.176.994.994,0,0,0,.549-1.144Z",
    transform: "translate(-564.919 -125.748)",
    fill: "#047fc4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.836,164.688a6.587,6.587,0,0,0,5.009-3.938,6.934,6.934,0,0,0-5.71-2.85c-2.205.186-4.262,2.263-3.893,4.446s3.675,3.321,5,1.548Z",
    transform: "translate(-553.338 -120.751)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.373,172.824a.587.587,0,0,1-.651-.495,1.1,1.1,0,0,1,.274-.843,1.029,1.029,0,0,1,.413-.334.766.766,0,0,1,.979.5.824.824,0,0,1-.563.967.886.886,0,0,1-1.013-.513Z",
    transform: "translate(-544.801 -107.492)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.515,167.714c-.457-.324-1.086-.026-1.542.3s-1.011.693-1.532.483a.481.481,0,0,1-.308-.316c-.088-.385.431-.575.737-.823a4.191,4.191,0,0,0,.569-.749,1.879,1.879,0,0,1,2.019-.617,1.035,1.035,0,0,1-.715,1.76Z",
    transform: "translate(-549.403 -112.709)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.151,161.9l-.1-.639a.782.782,0,0,0-.911.357.652.652,0,0,0,.327.881.558.558,0,0,0,.719-.529Z",
    transform: "translate(-555.466 -117.397)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.71,167.463a.443.443,0,0,1-.583.266,1.034,1.034,0,0,1-.5-.5,1.254,1.254,0,0,1-.188-.553.861.861,0,0,1,.673-.835,1.092,1.092,0,0,1,1.043.379.7.7,0,0,1,.192.517.387.387,0,0,1-.375.353Z",
    transform: "translate(-552.099 -112.796)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.629,173.317a6.586,6.586,0,0,0,6.365.3,6.922,6.922,0,0,0-2.455-5.888c-1.789-1.306-4.7-1.079-5.852.813s.607,4.917,2.77,4.444Z",
    transform: "translate(-561.236 -111.706)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.481,175.894c.357-.541-.485-1.216-1.089-.983a2.356,2.356,0,0,0-1.124,1.514,2.275,2.275,0,0,0,2.51-.268Z",
    transform: "translate(-554.271 -103.723)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.422,168.775l-.1-.639a.787.787,0,0,0-.911.356.652.652,0,0,0,.327.881.558.558,0,0,0,.719-.529Z",
    transform: "translate(-544.164 -110.503)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.321,172.645a15.4,15.4,0,0,0-.555-6.966,2.71,2.71,0,0,0-.5-1.009,2.2,2.2,0,0,0-2.039-.517,4.512,4.512,0,0,0-3.461,3.679,5.6,5.6,0,0,0,1.755,4.861,3.767,3.767,0,0,0,2.638,1.152,2.12,2.12,0,0,0,2.061-1.75.459.459,0,0,0-.737.222Z",
    transform: "translate(-552.836 -114.516)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.113,167.616a6.577,6.577,0,0,0,1.652-6.153,6.923,6.923,0,0,0-6.277,1.14c-1.656,1.47-2.057,4.364-.455,5.892s4.931.459,4.933-1.756Z",
    transform: "translate(-571.57 -117.438)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.008,149.725a3.372,3.372,0,0,0,.833-2.864,3.515,3.515,0,0,0-1.34.316,1.192,1.192,0,0,0-.671,1.12c.08.627.769.955,1.362,1.172l-.473.222Z",
    transform: "translate(-555.719 -131.804)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.907,146.614a1.324,1.324,0,0,0,.058-.849,1.408,1.408,0,0,0-.583-.583,12.787,12.787,0,0,1-1.775-1.444q.186,1.9.37,3.8a.759.759,0,0,1-.01.3c-.106.336-.577.359-.849.583-.4.328-.26.967-.02,1.424C598.812,153.087,599.457,148.124,599.907,146.614Z",
    transform: "translate(-558.682 -134.936)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.832,166.115c-.018-.372-.034-.745-.052-1.118a1.788,1.788,0,0,0-1.62,1.308c-.124.733.691,1.526,1.358,1.194.411-.206.975-.695,1.174-.28Z",
    transform: "translate(-548.375 -113.617)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.751,155.1a1.543,1.543,0,0,1-.072.921,2.6,2.6,0,0,1-.923-2.125c-.034-.447,0-1,.407-1.192.28-.134.613-.024.923-.05.623-.052,1.3-.639,1.778-.24a.767.767,0,0,1,.082.967,2.231,2.231,0,0,1-.8.679l-1.975,1.2Z",
    transform: "translate(-558.805 -126.376)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.394,155.412c.356-.541-.485-1.216-1.089-.981a2.347,2.347,0,0,0-1.124,1.512,2.274,2.274,0,0,0,2.51-.268Z",
    transform: "translate(-565.389 -124.261)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.159,149.236a.588.588,0,0,1-.817-.008,1.1,1.1,0,0,1-.286-.837,1.056,1.056,0,0,1,.13-.515.767.767,0,0,1,1.083-.19.825.825,0,0,1,.128,1.112.889.889,0,0,1-1.12.2Z",
    transform: "translate(-562.507 -131.123)",
    fill: "#047fc4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.8,149.383a.907.907,0,0,0,1.2-.991,1.564,1.564,0,0,0-.987-.116.765.765,0,0,0-.591.723.513.513,0,0,0,.721.429Z",
    transform: "translate(-560.136 -130.424)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.512,152.016a2.581,2.581,0,0,0,1.294-1.845l-1.907-.126a1.729,1.729,0,0,0-.883.1,1.024,1.024,0,0,0-.244,1.514,1.442,1.442,0,0,0,1.614.33Z",
    transform: "translate(-553.994 -128.623)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.975,151.786a1.154,1.154,0,0,1-2-.711c-.018-.306.18-.681.487-.649a.713.713,0,0,1,.338.174l1.346,1.049-.218.2Z",
    transform: "translate(-566.6 -128.231)",
    fill: "#047fc4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.416,150.826c-.324-.457-1.015-.385-1.554-.23s-1.184.318-1.6-.052a.479.479,0,0,1-.186-.4c.042-.393.6-.4.967-.535a4.153,4.153,0,0,0,.785-.517,1.878,1.878,0,0,1,2.107.086,1.034,1.034,0,0,1-1.258,1.424Z",
    transform: "translate(-571.518 -129.85)",
    fill: "#047fc4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.959,157.341c-.325-.457-1.016-.383-1.554-.23s-1.184.318-1.6-.052a.486.486,0,0,1-.186-.4c.044-.391.6-.4.967-.533a4.155,4.155,0,0,0,.785-.519,1.881,1.881,0,0,1,2.109.086,1.034,1.034,0,0,1-1.258,1.424Z",
    transform: "translate(-546.906 -123.317)",
    fill: "#047fc4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.134,147.55l.116-.635a.783.783,0,0,0-.977.034.652.652,0,0,0,.016.939.559.559,0,0,0,.855-.26Z",
    transform: "translate(-569.5 -131.904)",
    fill: "#047fc4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.9,149.147c-.278.316.058.835.463.955a12.432,12.432,0,0,0,1.258.094,1.521,1.521,0,0,1,1.029.729.727.727,0,0,1,.058.719.888.888,0,0,1-.4.3,4.536,4.536,0,0,1-2.391.579,2.128,2.128,0,0,1-1.883-1.4,1.633,1.633,0,0,1,2.019-2.015Z",
    transform: "translate(-558.572 -129.604)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.427,146.94a1.016,1.016,0,0,0,.22-1.392,1.457,1.457,0,0,0-1.392-.545c-.228.03-.5.158-.5.389a.578.578,0,0,0,.232.4l1.4,1.34Z",
    transform: "translate(-553.785 -133.682)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.763,158.908a1.714,1.714,0,0,1-2.335-1.392,4.291,4.291,0,0,1,2.432-.264,1.479,1.479,0,0,1,1.069,1.893q-.67.282-1.338.561Z",
    transform: "translate(-562.133 -121.476)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.547,146.317c.028-.224.056-.447.084-.669a1.41,1.41,0,0,0-1.016-.008c-.306.164-.4.691-.086.833a.7.7,0,0,0,.386.02l1.24-.174Z",
    transform: "translate(-561.224 -133.122)",
    fill: "#047fc4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.188,174.883a4.1,4.1,0,0,0,.631-1.518,1.391,1.391,0,0,0-.633-1.42,1.239,1.239,0,0,0-.8-.09,1.529,1.529,0,1,0,.781,2.952Z",
    transform: "translate(-550.357 -106.768)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.471,165.784c-.02-.375-.038-.749-.058-1.124a2.018,2.018,0,0,0-.855.02,1.06,1.06,0,0,0,.7,1.31Z",
    transform: "translate(-564.056 -113.991)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.38,188.642a.585.585,0,0,1-.815-.008,1.091,1.091,0,0,1-.286-.839,1.045,1.045,0,0,1,.128-.515.767.767,0,0,1,1.083-.188.822.822,0,0,1,.128,1.11.882.882,0,0,1-1.118.2Z",
    transform: "translate(-548.244 -91.606)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.047,161.925q-.027-.562-.058-1.124a2.018,2.018,0,0,0-.855.02,1.06,1.06,0,0,0,.7,1.31Z",
    transform: "translate(-561.473 -117.861)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.952,161.742c.361-.22.19-.815-.16-1.047a12.394,12.394,0,0,0-1.174-.461,1.517,1.517,0,0,1-.771-1,.733.733,0,0,1,.156-.7.9.9,0,0,1,.469-.174,4.518,4.518,0,0,1,2.456.15,2.123,2.123,0,0,1,1.388,1.889,1.633,1.633,0,0,1-2.521,1.334Z",
    transform: "translate(-546.696 -120.376)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.493,169.171a2.357,2.357,0,0,0-.455.825.8.8,0,0,0,.274.849c.439.286,1.013-.1,1.532-.048s.975.553,1.484.429a.888.888,0,0,0,.411-1.28,2.265,2.265,0,0,0-1.236-.885,2.547,2.547,0,0,0-1.346-.23,1,1,0,0,0-.861.931Z",
    transform: "translate(-552.521 -109.796)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.585,157.7a12.54,12.54,0,0,0,2.143,5.269,2.211,2.211,0,0,0,.639.661,1.792,1.792,0,0,0,1.71-.1,3.674,3.674,0,0,0,1.782-3.707,4.553,4.553,0,0,0-2.558-3.341,3.067,3.067,0,0,0-2.331-.248,1.728,1.728,0,0,0-1.168,1.869.374.374,0,0,0,.517-.354Z",
    transform: "translate(-552.95 -122.535)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.767,159.744a1.335,1.335,0,0,0,.765-.371,1.394,1.394,0,0,0,.214-.8,12.865,12.865,0,0,1,.37-2.257l-3.108,2.209a.7.7,0,0,1-.266.14c-.344.076-.6-.32-.927-.445-.481-.182-.967.254-1.244.689C605.6,162.013,610.232,160.1,611.767,159.744Z",
    transform: "translate(-548.43 -122.319)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317,157.2l.16-.625a.781.781,0,0,0-.977-.034.651.651,0,0,0-.05.937.559.559,0,0,0,.871-.2Z",
    transform: "translate(-553.262 -122.25)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.877,156.621a1.016,1.016,0,0,0,1.318-.5,1.463,1.463,0,0,0-.22-1.48c-.14-.182-.383-.35-.587-.242a.577.577,0,0,0-.23.4l-.467,1.881Z",
    transform: "translate(-547.83 -124.28)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.371,156.528a3.386,3.386,0,0,0,2.9-.7,3.479,3.479,0,0,0-.943-1.005,1.187,1.187,0,0,0-1.3-.026c-.5.381-.447,1.142-.34,1.765l-.428-.3Z",
    transform: "translate(-551.275 -124.031)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.676,155.374a1.546,1.546,0,0,1-.835.4,2.6,2.6,0,0,1,1.384-1.859c.37-.252.867-.5,1.236-.242.256.178.324.523.5.779.354.513,1.2.805,1.093,1.422a.769.769,0,0,1-.8.553,2.239,2.239,0,0,1-.985-.356q-1.012-.556-2.025-1.116Z",
    transform: "translate(-553.696 -125.082)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.505,158.909a2.588,2.588,0,0,0,2.243.2c-.28-.573-.559-1.146-.839-1.718a1.718,1.718,0,0,0-.525-.717,1.026,1.026,0,0,0-1.434.541,1.441,1.441,0,0,0,.517,1.564Z",
    transform: "translate(-548.643 -122.091)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.15,153.347c-.413-.084-.7.467-.6.877a11.841,11.841,0,0,0,.545,1.138,1.519,1.519,0,0,1-.12,1.254.73.73,0,0,1-.595.411.9.9,0,0,1-.463-.192,4.55,4.55,0,0,1-1.692-1.789,2.131,2.131,0,0,1,.276-2.327,1.634,1.634,0,0,1,2.754.747Z",
    transform: "translate(-550.52 -126.42)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.18,166.006a4.068,4.068,0,0,0,1.632-.206,1.4,1.4,0,0,0,.917-1.256,1.243,1.243,0,0,0-.32-.739,1.529,1.529,0,1,0-2.173,2.145Z",
    transform: "translate(-555.783 -115.305)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.113,166.514a3.374,3.374,0,0,0,2.9-.7,3.5,3.5,0,0,0-.941-1.005,1.194,1.194,0,0,0-1.306-.026c-.5.383-.447,1.144-.341,1.766l-.427-.3Z",
    transform: "translate(-549.527 -114.016)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.32,154.714c-.292-.479-.985-.455-1.534-.338s-1.2.234-1.6-.164a.489.489,0,0,1-.158-.415c.07-.387.623-.357,1-.465a4.1,4.1,0,0,0,.819-.461,1.879,1.879,0,0,1,2.1.234,1.035,1.035,0,0,1-1.356,1.332Z",
    transform: "translate(-555.516 -125.994)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.217,175.318l-.246-.6a.788.788,0,0,0-.8.559.653.653,0,0,0,.523.781.557.557,0,0,0,.577-.681Z",
    transform: "translate(-557.395 -103.869)",
    fill: "#047fc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.7,160.24l.623-.258a1.414,1.414,0,0,0-.5-.885c-.294-.184-.8,0-.765.34a.693.693,0,0,0,.176.344l.765.989Z",
    transform: "translate(-550.469 -119.607)",
    fill: "#047fc4"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M495.817,232.713s-.531-17.573-10.629-23.048C485.188,209.665,482.706,231.119,495.817,232.713Z",
    transform: "translate(-222.631 -6.632)",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M434.179,171.815S427.448,192.636,408.315,215c0,0,23.385,3.585,31.889,15.986,0,0,5.055-16.431,18.294-25.223C458.5,205.763,438.069,187.563,434.179,171.815Z",
    transform: "translate(-299.532 -44.589)",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M420.386,176.237s1.106,33.289,15.215,40.209c0,0,5.7-7.386,10.791-10.687,0,0-17.579-9.662-24.314-33.94Z",
    transform: "translate(-287.427 -44.585)",
    fill: "#ba645e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M585.919,371.248l71.809-168.505s1.59,4.5,0,8.39c-25.951,63.5-66.968,160.215-66.968,160.215Z",
    transform: "translate(-121.428 -13.574)",
    fill: "#9b5ed7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M768.449,202.742l-222.615,8.524L475.508,373.3l221.132-2.055Z",
    transform: "translate(-232.15 -13.574)",
    fill: "#744ca2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M541.213,214.61,747.3,206.4,680.6,360.292,484.482,353.32Z",
    transform: "translate(-223.151 -9.906)",
    fill: "#665efb"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M544.138,207.651s-2.357,4.564-12.267,18.851c-9.93,14.306-18.2,21.15-20.2,24.216s-13.707,30.126-13.707,30.126a23.153,23.153,0,0,1-8.378-24.124s2.469-4.114,2.245-7.891c-.244-3.777-11.222-19.84-11.222-25.506s12.043-19.131,15.111-26.461c3.066-7.312,7.629-17.541,9.163-17.9s4.9,6.862,4.188,12.884-9.089,11.388-11.462,15.053c-2.357,3.665-2.021,5.61-2.021,5.61s11.594-5.61,15.84-10.341a48.86,48.86,0,0,0,6.151-8.135s4.134-9.461,9.089-18.308a68.1,68.1,0,0,1,8.378-12.285c.711-1.065,4.134-.823,4.618,0,.469.823-2.73,10.977-4.731,15.466-1.047,2.337-3.535,6.543-5.666,10.19-1.963,3.347-3.609,6.191-3.553,6.7.13,1.065,3.8-1.384,6.153-.561,1.7.6,5.554,2.431,5.778,5.684a4.493,4.493,0,0,1-.841,2.413,3.319,3.319,0,0,1,2.037-1.384C542.005,201.949,544.138,204.4,544.138,207.651Z",
    transform: "translate(-227.031 -53.696)",
    fill: "url(#g)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M526.5,210.1l-9.72,9.075c-30.146,11.348-27.332-8.017-27.332-8.017,4.264-4.713,19.343-17.122,19.343-17.122s4.134-9.461,9.089-18.308a68.107,68.107,0,0,1,8.378-12.285c.711-1.065,4.134-.823,4.618,0,.469.823-2.73,10.977-4.731,15.466-1.047,2.337-3.535,6.543-5.666,10.19-3.01,1.534-7.368,3.889-7.443,4.582-.112,1.065,2.411,4.506,2.411,4.506l7.386,6a31.56,31.56,0,0,1-1.682,3.627C520.855,208.026,526.5,210.1,526.5,210.1Z",
    transform: "translate(-218.24 -53.696)",
    fill: "#d37a73"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M493.1,170.842s-2.882,12.425,2.754,16.752a12.266,12.266,0,0,0,1.322-9.369C495.875,172.554,493.1,170.842,493.1,170.842Z",
    transform: "translate(-215.249 -45.565)",
    fill: "#ba645e"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M448.768,295.664s53.385-47.277,72.754-86c0,0-.354,19.151,10.629,23.048,0,0-42.113,90.7-52.414,104.168C479.738,336.882,458.217,326.371,448.768,295.664Z",
    transform: "translate(-258.965 -6.632)",
    fill: "url(#i)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M502.384,176.7s-.973,5.315-2.017,9.666a5,5,0,0,0,5.191.038c3.016-1.574,3.9-8.524,3.637-11.426S502.384,176.7,502.384,176.7Z",
    transform: "translate(-207.221 -42.373)",
    fill: "#e39790"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M515.666,186.82s3.08-7.12,1.841-12.436a14.9,14.9,0,0,0-3.455-2.568s-10.1-.975-21.112-.975c0,0-1.318,1.5.719,5.666s10.118,3.915,15.079,3.491a47.607,47.607,0,0,0,7.7-1.027A42.214,42.214,0,0,1,515.666,186.82Z",
    transform: "translate(-215.09 -45.565)",
    fill: "url(#g)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M511.714,178.694s-8.56,4.9-13.343,10.927c0,0-.661,6.509,5.758,3.02,7.823-4.252,16.187-8.252,16.187-8.252S519.82,179.006,511.714,178.694Z",
    transform: "translate(-209.241 -37.691)",
    fill: "url(#g)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M514.975,181.812s-10,6.191-11.592,8.085,2.944,4.326,8.935,2.692a14.545,14.545,0,0,0,8.4-5.6S521.707,180.011,514.975,181.812Z",
    transform: "translate(-204.519 -34.862)",
    fill: "url(#g)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M488.18,190.743c-.719-1.817,3.847,8.728,4.62,18.019,0,0,3.315-13.91-3.242-23.441C489.558,185.321,487.4,188.79,488.18,190.743Z",
    transform: "translate(-219.614 -31.045)",
    fill: "#e39790"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M492.521,199.43s4.789-9.992,18.963-8.326C511.484,191.1,498.537,196.417,492.521,199.43Z",
    transform: "translate(-215.089 -25.434)",
    fill: "#e39790"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(193.553)",
    opacity: 0.395
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.86,117.279a17.714,17.714,0,0,0,7.066,3.809,3.115,3.115,0,0,0,1.29.144,2.522,2.522,0,0,0,1.768-1.646,5.179,5.179,0,0,0-1.39-5.632,6.426,6.426,0,0,0-5.784-1.338,4.324,4.324,0,0,0-2.756,1.825,2.436,2.436,0,0,0,.4,3.08.527.527,0,0,0,.244-.849Z",
    transform: "translate(-445.577 -104.149)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.94,115.567A3.281,3.281,0,0,0,462,117.984a3.448,3.448,0,0,0,1.306-2.9,2.085,2.085,0,0,0-2.289-1.851c-1.079.226-1.582,1.895-.673,2.522Z",
    transform: "translate(-441.385 -103.368)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.274,116.845a1.688,1.688,0,0,0,.062,1.484,1.733,1.733,0,0,0,.583-.363.592.592,0,0,0,.138-.637c-.136-.282-.515-.328-.829-.336l.188-.18Z",
    transform: "translate(-437.112 -99.746)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.419,116.687a.773.773,0,0,1-.359-.29,1.292,1.292,0,0,1,1.134.222c.192.11.409.282.374.5-.024.152-.164.258-.242.393-.154.27-.1.713-.4.8a.385.385,0,0,1-.421-.24,1.11,1.11,0,0,1-.052-.521c.02-.383.042-.765.064-1.15Z",
    transform: "translate(-438.187 -100.227)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.254,122.193c.122.3.637.146.711-.168a1.178,1.178,0,0,0-.3-.889,1.131,1.131,0,0,0-.6,1.106Z",
    transform: "translate(-426.155 -95.411)",
    fill: "#0c409a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.04,116.856a.294.294,0,0,1,.234-.332.551.551,0,0,1,.427.12.5.5,0,0,1,.174.2.385.385,0,0,1-.228.5.411.411,0,0,1-.493-.262.443.443,0,0,1,.234-.515Z",
    transform: "translate(-423.171 -100.045)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.937,115.972a1.291,1.291,0,0,0-.316,1.078l.921-.244a.863.863,0,0,0,.4-.188.509.509,0,0,0-.126-.753.717.717,0,0,0-.813.1Z",
    transform: "translate(-438.645 -100.783)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.019,117.318l.316-.062a.391.391,0,0,0-.2-.447.324.324,0,0,0-.433.18.279.279,0,0,0,.278.348Z",
    transform: "translate(-425.515 -99.777)",
    fill: "#0c409a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.594,118.322a.507.507,0,0,0,.116.693.73.73,0,0,0,.745.034c.1-.05.21-.152.176-.262a.294.294,0,0,0-.174-.152l-.875-.409Z",
    transform: "translate(-437.743 -98.329)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.8,111.593a.219.219,0,0,1-.144-.284.523.523,0,0,1,.24-.26.618.618,0,0,1,.27-.106.431.431,0,0,1,.431.32.548.548,0,0,1-.168.527.356.356,0,0,1-.254.106.193.193,0,0,1-.182-.18Z",
    transform: "translate(-450.641 -105.634)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.738,119.17l.477.294a.961.961,0,0,0,.234-.356.526.526,0,0,0-.733-.084Z",
    transform: "translate(-430.509 -97.641)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.525,120.06a7.09,7.09,0,0,0,3.207.2,1.247,1.247,0,0,0,.493-.164,1.016,1.016,0,0,0,.367-.9,2.076,2.076,0,0,0-1.452-1.813,2.568,2.568,0,0,0-2.325.485,1.733,1.733,0,0,0-.7,1.126.975.975,0,0,0,.665,1.051.21.21,0,0,0-.054-.348Z",
    transform: "translate(-444.15 -99.276)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.892,114.12a1.683,1.683,0,0,0,.939,1.152,1.727,1.727,0,0,0,.248-.639.593.593,0,0,0-.268-.593c-.28-.144-.609.046-.867.228l.044-.258Z",
    transform: "translate(-434.344 -102.578)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.4,115.145a.664.664,0,0,0,.331.264.69.69,0,0,0,.4-.076,6.324,6.324,0,0,1,1.094-.318q-.829-.463-1.662-.921a.379.379,0,0,1-.12-.09c-.108-.138.016-.336,0-.513-.022-.254-.322-.379-.577-.409C467.055,112.865,468.909,114.534,469.4,115.145Z",
    transform: "translate(-433.143 -103.507)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.874,113.553a1.287,1.287,0,0,0,.393,1.051c.2-.248.393-.5.591-.747a.855.855,0,0,0,.208-.391.508.508,0,0,0-.551-.527.715.715,0,0,0-.593.569Z",
    transform: "translate(-436.374 -103.632)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.493,108.827l.314-.062a.39.39,0,0,0-.194-.447.324.324,0,0,0-.433.18.279.279,0,0,0,.278.348Z",
    transform: "translate(-449.107 -108.291)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.793,115.145a2.05,2.05,0,0,0,.445.689.692.692,0,0,0,.761.14.619.619,0,0,0,.264-.3.762.762,0,1,0-1.432-.515Z",
    transform: "translate(-439.457 -101.948)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.249,120.338a1.488,1.488,0,0,0,.6.3.3.3,0,0,0,.11.01.221.221,0,0,0,.144-.144.435.435,0,0,0-.132-.469.54.54,0,0,0-.491-.1.368.368,0,0,0-.226.16.206.206,0,0,0,.042.258.044.044,0,0,0,.018-.072Z",
    transform: "translate(-428.99 -96.634)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.5,112.991a1.683,1.683,0,0,0,.939,1.152,1.763,1.763,0,0,0,.248-.639.591.591,0,0,0-.27-.593c-.278-.144-.609.046-.865.228l.042-.256Z",
    transform: "translate(-443.765 -103.71)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.736,110.845a.452.452,0,0,0,.068.773.794.794,0,0,0,.326-.373.379.379,0,0,0-.13-.447.254.254,0,0,0-.379.174Z",
    transform: "translate(-442.711 -105.809)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.493,114.122a.452.452,0,0,0,.068.773.8.8,0,0,0,.326-.373.385.385,0,0,0-.13-.447.255.255,0,0,0-.381.174Z",
    transform: "translate(-439.946 -102.525)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.787,112.365c-.052-.2-.361-.212-.523-.08a6.269,6.269,0,0,0-.395.489.751.751,0,0,1-.589.216.363.363,0,0,1-.312-.178.46.46,0,0,1-.014-.25,2.277,2.277,0,0,1,.439-1.144,1.063,1.063,0,0,1,1.106-.379.815.815,0,0,1,.258,1.4Z",
    transform: "translate(-444.32 -105.578)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.77,110.015c-.052-.2-.36-.212-.523-.08a6.266,6.266,0,0,0-.395.489.753.753,0,0,1-.589.218.365.365,0,0,1-.312-.18.453.453,0,0,1-.014-.248,2.284,2.284,0,0,1,.439-1.146,1.06,1.06,0,0,1,1.106-.377.828.828,0,0,1,.539.623.837.837,0,0,1-.28.775Z",
    transform: "translate(-425.283 -107.933)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.014,113.988l.25.224a.718.718,0,0,0,.29-.417c.02-.17-.17-.359-.318-.268a.328.328,0,0,0-.116.152l-.28.559Z",
    transform: "translate(-437.404 -103.064)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.924,116.05a.557.557,0,0,1-.024-.949,1.576,1.576,0,0,1,.609.224.982.982,0,0,1-.435.557Z",
    transform: "translate(-441.61 -101.463)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.614,125.751a1.2,1.2,0,0,0,.326.338.4.4,0,0,0,.445,0c.2-.164.1-.5.206-.735s.409-.383.425-.643-.294-.437-.547-.385a1.12,1.12,0,0,0-.6.455,1.251,1.251,0,0,0-.31.607.5.5,0,0,0,.313.547Z",
    transform: "translate(-416.636 -92.223)",
    fill: "#0c409a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.192,116.761a.292.292,0,0,1,.387-.126.542.542,0,0,1,.27.35.509.509,0,0,1,.02.262.381.381,0,0,1-.481.262.41.41,0,0,1-.238-.5.441.441,0,0,1,.5-.27Z",
    transform: "translate(-442.128 -99.952)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.189,117.583c.262-.1.318-.439.315-.717s0-.611.234-.765a.242.242,0,0,1,.216-.036c.184.072.116.338.13.535a2.107,2.107,0,0,0,.148.445.934.934,0,0,1-.318,1,.514.514,0,0,1-.521-.789Z",
    transform: "translate(-439.06 -100.508)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.34,115.52a.222.222,0,0,1,.054-.314.522.522,0,0,1,.349-.066.613.613,0,0,1,.28.078.434.434,0,0,1,.154.515.55.55,0,0,1-.451.32.346.346,0,0,1-.266-.068.189.189,0,0,1-.038-.252Z",
    transform: "translate(-437.952 -101.428)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.126,124.733a3.281,3.281,0,0,0-1.921,2.528,3.448,3.448,0,0,0,3.11.657,2.085,2.085,0,0,0,1.32-2.632c-.451-1.007-2.189-1.142-2.606-.12Z",
    transform: "translate(-425.005 -92.076)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.307,112.691c.122.3.637.144.711-.17a1.171,1.171,0,0,0-.3-.889,1.132,1.132,0,0,0-.6,1.108Z",
    transform: "translate(-441.144 -104.942)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.448,118.276l.29.14a.39.39,0,0,0,.112-.475.325.325,0,0,0-.455-.116.28.28,0,0,0,.014.447Z",
    transform: "translate(-440.962 -98.782)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.087,116.659a7.685,7.685,0,0,0,3.016,1.74,1.367,1.367,0,0,0,.557.078,1.091,1.091,0,0,0,.789-.691,2.246,2.246,0,0,0-.533-2.459,2.783,2.783,0,0,0-2.49-.653,1.882,1.882,0,0,0-1.22.755,1.057,1.057,0,0,0,.138,1.342.228.228,0,0,0,.116-.365Z",
    transform: "translate(-439.217 -101.956)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.269,123.484a3.281,3.281,0,0,0,2.059,2.417,3.45,3.45,0,0,0,1.306-2.9,2.085,2.085,0,0,0-2.289-1.853c-1.079.226-1.582,1.895-.673,2.522Z",
    transform: "translate(-425.01 -95.429)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.88,119.078a1.687,1.687,0,0,0,.939,1.152,1.726,1.726,0,0,0,.25-.641.591.591,0,0,0-.27-.591c-.28-.144-.609.044-.865.226l.042-.256Z",
    transform: "translate(-429.342 -97.606)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.39,120.1a.665.665,0,0,0,.332.262.7.7,0,0,0,.4-.074,6.3,6.3,0,0,1,1.1-.32l-1.664-.919a.379.379,0,0,1-.12-.09c-.108-.138.016-.338,0-.513-.024-.256-.324-.381-.579-.411C472.043,117.824,473.9,119.49,474.39,120.1Z",
    transform: "translate(-428.14 -98.536)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463,117.684l.473.294a.891.891,0,0,0-.08-1.035c-.264-.258-.821-.148-.873.22-.032.226.01.595-.216.561Z",
    transform: "translate(-438.942 -99.757)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.43,127.188a.778.778,0,0,1-.357-.29,1.294,1.294,0,0,1,1.132.222c.194.112.411.282.375.5-.024.154-.164.258-.24.395-.154.27-.1.711-.4.8a.384.384,0,0,1-.421-.24,1.107,1.107,0,0,1-.054-.519l.066-1.152Z",
    transform: "translate(-418.116 -89.696)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.537,124.75c.122.3.637.144.711-.17a1.175,1.175,0,0,0-.3-.887,1.127,1.127,0,0,0-.6,1.106Z",
    transform: "translate(-416.846 -92.847)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.769,116.362a.294.294,0,0,1,.234-.334.544.544,0,0,1,.425.12.518.518,0,0,1,.174.2.384.384,0,0,1-.228.5.412.412,0,0,1-.493-.262.443.443,0,0,1,.234-.515Z",
    transform: "translate(-427.455 -100.542)",
    fill: "#0c409a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.12,116.933a.45.45,0,0,0,.068.771.781.781,0,0,0,.326-.371.388.388,0,0,0-.13-.449.257.257,0,0,0-.381.176Z",
    transform: "translate(-428.286 -99.706)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.683,114.281a.576.576,0,0,1,.857-.621c.132.08.228.266.13.383a.344.344,0,0,1-.168.09l-.811.256-.022-.146Z",
    transform: "translate(-427.548 -102.986)",
    fill: "#0c409a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.4,113.171c.28,0,.445-.308.535-.573s.2-.575.475-.643a.237.237,0,0,1,.216.036c.148.128,0,.359-.054.549a2.156,2.156,0,0,0-.01.469.931.931,0,0,1-.631.839.514.514,0,0,1-.228-.917Z",
    transform: "translate(-425.811 -104.628)",
    fill: "#0c409a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.292,113.892l.228.228a.394.394,0,0,0,.262-.411.326.326,0,0,0-.391-.26.279.279,0,0,0-.134.425Z",
    transform: "translate(-425.006 -103.13)",
    fill: "#0c409a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.169,118.45c-.05-.2-.359-.212-.521-.08a5.556,5.556,0,0,0-.395.491.76.76,0,0,1-.591.216.361.361,0,0,1-.31-.18.435.435,0,0,1-.014-.248,2.266,2.266,0,0,1,.439-1.146,1.059,1.059,0,0,1,1.106-.377.812.812,0,0,1,.256,1.4Z",
    transform: "translate(-429.896 -99.475)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.254,120.7a.507.507,0,0,0,.509.483.73.73,0,0,0,.619-.417c.052-.1.074-.248-.018-.316a.294.294,0,0,0-.23-.018c-.315.066-.629.132-.945.2Z",
    transform: "translate(-429.033 -96.128)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.431,125.027a.856.856,0,0,1,1.232-.565,2.126,2.126,0,0,1-.579,1.074.738.738,0,0,1-1.08-.1l.148-.707Z",
    transform: "translate(-419.189 -92.18)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.483,117.673l.25.224a.714.714,0,0,0,.29-.415c.02-.172-.17-.361-.318-.27a.353.353,0,0,0-.116.152c-.094.186-.186.373-.28.559Z",
    transform: "translate(-426.906 -99.369)",
    fill: "#0c409a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.965,114.56a2.022,2.022,0,0,0,.445.687.689.689,0,0,0,.761.142.619.619,0,0,0,.264-.3.762.762,0,1,0-1.432-.515Z",
    transform: "translate(-441.29 -102.536)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.246,113.306l.477.292a.986.986,0,0,0,.234-.357.53.53,0,0,0-.735-.084Z",
    transform: "translate(-430.002 -103.523)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.576,111.063a.292.292,0,0,1,.234-.332.619.619,0,0,1,.6.316.382.382,0,0,1-.228.5.408.408,0,0,1-.491-.26.437.437,0,0,1,.234-.515Z",
    transform: "translate(-447.705 -105.855)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.877,123.876l.477.292a.961.961,0,0,0,.234-.357.528.528,0,0,0-.733-.084Z",
    transform: "translate(-420.341 -92.923)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.416,114.614a1.172,1.172,0,0,0-.21-.421.4.4,0,0,0-.427-.128c-.24.1-.244.445-.413.643s-.5.244-.595.489.152.5.409.529a1.118,1.118,0,0,0,.713-.256,1.258,1.258,0,0,0,.475-.487.5.5,0,0,0-.14-.617Z",
    transform: "translate(-439.498 -102.524)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.47,116.449a1.679,1.679,0,0,0-.531,1.386,1.693,1.693,0,0,0,.679-.1.591.591,0,0,0,.379-.527c-.014-.316-.343-.507-.629-.639l.244-.092Z",
    transform: "translate(-438.316 -100.111)",
    fill: "#0c409a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.421,113.412l.314.068a.389.389,0,0,0,0-.487.323.323,0,0,0-.467-.008.278.278,0,0,0,.116.431Z",
    transform: "translate(-436.033 -103.681)",
    fill: "#0c409a"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.353 418.473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418,319.936a23.67,23.67,0,0,0-9.666,4.667,4.16,4.16,0,0,0-1.166,1.282,3.38,3.38,0,0,0,.395,3.208,6.932,6.932,0,0,0,7.19,2.91,8.592,8.592,0,0,0,5.982-5.215,5.785,5.785,0,0,0,.186-4.416,3.26,3.26,0,0,0-3.655-1.977.705.705,0,0,0,.729.931Z",
    transform: "translate(-346.293 -314.524)",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.832,324.97a4.382,4.382,0,0,0-4.232.336,4.614,4.614,0,0,0,2.115,3.685,2.79,2.79,0,0,0,3.8-1.027c.6-1.348-.813-3.2-2.2-2.706Z",
    transform: "translate(-345.602 -309.87)",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.568,328.059a2.249,2.249,0,0,0-1.656-1.1,2.322,2.322,0,0,0-.064.915.788.788,0,0,0,.579.647c.415.074.761-.3,1.015-.635l.048.346Z",
    transform: "translate(-350.393 -307.477)",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.887,327.22a1.027,1.027,0,0,1,.595-.162c-.108.525-.639.837-1.128,1.054-.272.122-.627.222-.839.012-.146-.146-.15-.381-.236-.571-.172-.379-.691-.669-.549-1.062a.512.512,0,0,1,.589-.266,1.469,1.469,0,0,1,.6.351q.6.484,1.2.971Z",
    transform: "translate(-349.508 -308.229)",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.12,335.7c-.419-.1-.657.575-.375.9a1.567,1.567,0,0,0,1.2.368,1.515,1.515,0,0,0-.729-1.514Z",
    transform: "translate(-363.63 -298.957)",
    opacity: 0.5,
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.514,342.641a.392.392,0,0,1,.178.515.732.732,0,0,1-.463.367.708.708,0,0,1-.352.034.512.512,0,0,1-.36-.637.547.547,0,0,1,.669-.328.589.589,0,0,1,.375.657Z",
    transform: "translate(-360.75 -291.829)",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.6,327.3a1.723,1.723,0,0,0-.919-1.188l-.457,1.19a1.136,1.136,0,0,0-.112.581.681.681,0,0,0,.915.453.957.957,0,0,0,.529-.961Z",
    transform: "translate(-348.106 -308.33)",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.409,340.065l-.18.391a.52.52,0,0,0,.637.138.435.435,0,0,0,.144-.609.372.372,0,0,0-.595.028Z",
    transform: "translate(-359.011 -294.554)",
    opacity: 0.5,
    fill: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.379,325.889a.677.677,0,0,0-.841-.415.976.976,0,0,0-.623.777c-.024.152,0,.349.148.4a.394.394,0,0,0,.3-.07l1.13-.627Z",
    transform: "translate(-351.311 -308.999)",
    fill: "url(#u)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.644,317.3a.3.3,0,0,1,.421.068.688.688,0,0,1,.094.465.843.843,0,0,1-.1.377.577.577,0,0,1-.683.214.726.726,0,0,1-.439-.595.462.462,0,0,1,.084-.358.257.257,0,0,1,.338-.056Z",
    transform: "translate(-333.234 -317.234)",
    fill: "url(#v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.531,332.84l-.693.288a1.337,1.337,0,0,0,.2.533.706.706,0,0,0,.667-.729Z",
    transform: "translate(-357.398 -301.584)",
    fill: "url(#w)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.568,318.612a9.461,9.461,0,0,0-2.728,3.319,1.677,1.677,0,0,0-.208.663,1.35,1.35,0,0,0,.683,1.1,2.771,2.771,0,0,0,3.1-.15,3.439,3.439,0,0,0,1.3-2.9,2.315,2.315,0,0,0-.675-1.634,1.3,1.3,0,0,0-1.658-.1.281.281,0,0,0,.421.214Z",
    transform: "translate(-347.576 -315.852)",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.585,332.686a2.255,2.255,0,0,0-1.985.114,2.335,2.335,0,0,0,.5.771.79.79,0,0,0,.851.172c.377-.19.429-.695.433-1.118l.246.248Z",
    transform: "translate(-349.614 -301.916)",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.733,334.656a.882.882,0,0,0-.545.152.952.952,0,0,0-.236.5,8.257,8.257,0,0,1-.511,1.434l2.3-1.077a.471.471,0,0,1,.19-.06c.234-.01.352.28.555.4.294.176.665-.052.9-.3C408.043,333.9,404.782,334.6,403.733,334.656Z",
    transform: "translate(-350.776 -299.943)",
    fill: "url(#z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.775,331.258a1.72,1.72,0,0,0-1.446-.4q.174.613.346,1.226a1.134,1.134,0,0,0,.258.533.684.684,0,0,0,1.005-.184.963.963,0,0,0-.152-1.088Z",
    transform: "translate(-346.877 -303.601)",
    fill: "url(#aa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.046,321.243l-.18.391a.52.52,0,0,0,.637.138.433.433,0,0,0,.144-.609.372.372,0,0,0-.595.028Z",
    transform: "translate(-331.296 -313.429)",
    fill: "url(#ab)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.617,326.474a2.7,2.7,0,0,0-1.094-.058.925.925,0,0,0-.749.713.814.814,0,0,0,.122.523,1.018,1.018,0,1,0,1.678-1.148Z",
    transform: "translate(-346.436 -308.062)",
    fill: "url(#ac)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.279,333.628a1.981,1.981,0,0,0-.8.419.328.328,0,0,0-.094.11.284.284,0,0,0,.042.268.585.585,0,0,0,.611.226.728.728,0,0,0,.491-.455.49.49,0,0,0,0-.372.271.271,0,0,0-.312-.156.06.06,0,0,0,.064.076Z",
    transform: "translate(-359.876 -300.793)",
    fill: "url(#ad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.171,323.4a2.25,2.25,0,0,0-1.983.114,2.288,2.288,0,0,0,.5.771.79.79,0,0,0,.853.172c.375-.19.429-.695.433-1.115l.244.246Z",
    transform: "translate(-341.002 -311.232)",
    fill: "url(#ae)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.021,326.514a.6.6,0,0,0-.889-.531,1.042,1.042,0,0,0,.146.645.514.514,0,0,0,.587.21.343.343,0,0,0,.108-.549Z",
    transform: "translate(-339.054 -308.54)",
    fill: "url(#af)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.314,326.932a.6.6,0,0,0-.891-.531,1.06,1.06,0,0,0,.148.645.507.507,0,0,0,.585.208.339.339,0,0,0,.108-.547Z",
    transform: "translate(-344.779 -308.122)",
    fill: "url(#ag)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.266,325.845c.26.1.513-.222.5-.5s-.176-.533-.22-.811a1.008,1.008,0,0,1,.226-.807.486.486,0,0,1,.439-.2.6.6,0,0,1,.28.18,3.03,3.03,0,0,1,.9,1.374,1.415,1.415,0,0,1-.459,1.492,1.086,1.086,0,0,1-1.714-.817Z",
    transform: "translate(-338.972 -310.93)",
    fill: "url(#ah)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.929,348.245c.26.1.513-.222.5-.5a7.947,7.947,0,0,0-.222-.809,1.013,1.013,0,0,1,.228-.809.489.489,0,0,1,.439-.2.6.6,0,0,1,.28.18,3.03,3.03,0,0,1,.9,1.372,1.424,1.424,0,0,1-.459,1.494,1.088,1.088,0,0,1-1.714-.817Z",
    transform: "translate(-351.344 -288.468)",
    fill: "url(#ai)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.469,329.819l-.439.1a.952.952,0,0,0,.22.641c.172.154.525.1.543-.134a.465.465,0,0,0-.074-.246l-.385-.739Z",
    transform: "translate(-346.174 -304.997)",
    fill: "url(#aj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.514,323.746a.744.744,0,0,1,1.047.717,2.065,2.065,0,0,1-.719.485,1.32,1.32,0,0,1-.264-.907Z",
    transform: "translate(-344.686 -310.779)",
    fill: "url(#ak)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.319,343.15a1.544,1.544,0,0,0-.621.086.528.528,0,0,0-.344.483c.02.349.457.5.635.8s.092.741.362.963a.591.591,0,0,0,.845-.29,1.5,1.5,0,0,0-.018-1.011,1.687,1.687,0,0,0-.413-.811.661.661,0,0,0-.839-.09Z",
    transform: "translate(-374.932 -291.245)",
    opacity: 0.5,
    fill: "url(#ac)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.389,322.393a.393.393,0,0,1-.166.519.73.73,0,0,1-.591.016.7.7,0,0,1-.3-.184.51.51,0,0,1,.094-.725.548.548,0,0,1,.733.138.587.587,0,0,1-.1.749Z",
    transform: "translate(-345.985 -312.521)",
    fill: "url(#am)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.82,325.338c-.1.358.226.687.531.9s.661.481.645.855a.322.322,0,0,1-.13.262c-.222.142-.459-.14-.681-.278a2.88,2.88,0,0,0-.6-.19,1.247,1.247,0,0,1-.837-1.128.688.688,0,0,1,1.264.056Z",
    transform: "translate(-348.459 -309.107)",
    fill: "url(#an)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.506,327.849c.16-.024.3.144.3.306a.683.683,0,0,1-.2.427.819.819,0,0,1-.3.244.579.579,0,0,1-.675-.238.729.729,0,0,1,.006-.739.465.465,0,0,1,.282-.236.255.255,0,0,1,.3.158Z",
    transform: "translate(-347.685 -306.833)",
    fill: "url(#ao)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.371,337.491a4.384,4.384,0,0,0-1.232-4.062,4.608,4.608,0,0,0-3.148,2.854,2.784,2.784,0,0,0,1.817,3.491c1.444.3,2.95-1.476,2.171-2.728Z",
    transform: "translate(-370.394 -300.993)",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.129,326.966c-.421-.1-.657.575-.375.9a1.565,1.565,0,0,0,1.2.368,1.514,1.514,0,0,0-.727-1.514Z",
    transform: "translate(-341.56 -307.719)",
    fill: "url(#aq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.591,322.453l-.379.206a.525.525,0,0,0,.429.493.436.436,0,0,0,.481-.4.374.374,0,0,0-.495-.334Z",
    transform: "translate(-347.996 -312.064)",
    fill: "url(#ar)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.121,326.127a10.258,10.258,0,0,0-4.25,1.9,1.847,1.847,0,0,0-.523.543,1.468,1.468,0,0,0,.132,1.4,3.007,3.007,0,0,0,3.08,1.352,3.728,3.728,0,0,0,2.66-2.187,2.5,2.5,0,0,0,.136-1.911,1.411,1.411,0,0,0-1.56-.9.307.307,0,0,0,.3.413Z",
    transform: "translate(-348.988 -308.316)",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.458,336.448a4.386,4.386,0,0,0-4.232.334,4.611,4.611,0,0,0,2.115,3.685,2.785,2.785,0,0,0,3.8-1.027c.6-1.346-.811-3.2-2.2-2.706Z",
    transform: "translate(-367.037 -298.36)",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.306,334.2a2.254,2.254,0,0,0-1.985.114,2.334,2.334,0,0,0,.5.771.79.79,0,0,0,.851.172c.377-.19.429-.695.433-1.118l.246.248Z",
    transform: "translate(-358.919 -300.396)",
    fill: "url(#au)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.456,336.172a.888.888,0,0,0-.547.152.935.935,0,0,0-.234.5,8.487,8.487,0,0,1-.513,1.434q1.151-.538,2.3-1.08a.541.541,0,0,1,.19-.06c.234-.008.354.282.555.4.294.176.665-.052.9-.3C398.764,335.415,395.5,336.118,394.456,336.172Z",
    transform: "translate(-360.081 -298.423)",
    fill: "url(#av)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.807,325.9l-.691.282a1.2,1.2,0,0,0,1.184.725c.489-.084.8-.775.447-1.118-.222-.212-.655-.457-.439-.675Z",
    transform: "translate(-349.096 -309.328)",
    fill: "url(#aw)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.828,340.662a1.032,1.032,0,0,1,.593-.162c-.108.525-.639.837-1.128,1.055-.272.12-.627.22-.839.01-.146-.146-.15-.381-.236-.569-.172-.379-.691-.671-.549-1.063a.515.515,0,0,1,.591-.266,1.5,1.5,0,0,1,.6.351c.4.324.8.647,1.194.971Z",
    transform: "translate(-376.645 -294.75)",
    fill: "url(#ax)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.075,343.752c-.421-.1-.657.575-.375.9a1.572,1.572,0,0,0,1.2.367,1.514,1.514,0,0,0-.727-1.514Z",
    transform: "translate(-373.704 -290.886)",
    fill: "url(#ay)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.4,338.4a.389.389,0,0,1,.176.513.724.724,0,0,1-.463.368.7.7,0,0,1-.352.032.509.509,0,0,1-.359-.637.546.546,0,0,1,.667-.328.59.59,0,0,1,.374.657Z",
    transform: "translate(-356.852 -296.08)",
    opacity: 0.5,
    fill: "url(#az)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.156,337.32a.6.6,0,0,0-.891-.531,1.056,1.056,0,0,0,.148.645.507.507,0,0,0,.585.208.339.339,0,0,0,.108-.547Z",
    transform: "translate(-356.971 -297.704)",
    fill: "url(#ba)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.667,340.077a.769.769,0,0,1,0,1.416c-.188.08-.467.038-.515-.16a.461.461,0,0,1,.034-.252l.357-1.078.176.09Z",
    transform: "translate(-354.081 -294.401)",
    opacity: 0.5,
    fill: "url(#bb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.144,343.062c-.214.306-.014.723.2,1.027s.463.673.324,1.019a.327.327,0,0,1-.21.206c-.256.06-.385-.286-.551-.489a2.759,2.759,0,0,0-.5-.379,1.245,1.245,0,0,1-.415-1.342.689.689,0,0,1,1.174.473Z",
    transform: "translate(-354.287 -291.487)",
    opacity: 0.5,
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.9,343.047l-.425.068a.52.52,0,0,0,.24.607.434.434,0,0,0,.585-.22.373.373,0,0,0-.354-.479Z",
    transform: "translate(-355.776 -291.374)",
    opacity: 0.5,
    fill: "url(#bd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.4,336.652c.26.1.511-.222.495-.5a7.373,7.373,0,0,0-.22-.811,1.015,1.015,0,0,1,.228-.809.489.489,0,0,1,.439-.2.606.606,0,0,1,.28.18,3.036,3.036,0,0,1,.9,1.372,1.42,1.42,0,0,1-.457,1.494,1.09,1.09,0,0,1-1.716-.817Z",
    transform: "translate(-356.889 -300.094)",
    fill: "url(#be)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.9,333.325a.677.677,0,0,0-.923.172.974.974,0,0,0-.032,1c.07.136.21.276.356.228.1-.032.154-.138.2-.234l.529-1.178Z",
    transform: "translate(-360.415 -301.213)",
    fill: "url(#bf)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.589,341.25a1.142,1.142,0,0,1-.354,1.776,2.853,2.853,0,0,1-.707-1.468c-.034-.549.4-1.162.949-1.094l.651.715Z",
    transform: "translate(-372.753 -293.943)",
    fill: "url(#bg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.271,338.267l-.439.1a.949.949,0,0,0,.222.639c.17.156.523.1.543-.132a.467.467,0,0,0-.076-.246l-.385-.739Z",
    transform: "translate(-358.406 -296.524)",
    opacity: 0.5,
    fill: "url(#bh)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.686,324.954a2.7,2.7,0,0,0-1.094-.058.93.93,0,0,0-.751.713.819.819,0,0,0,.122.523,1.018,1.018,0,1,0,1.678-1.148Z",
    transform: "translate(-344.363 -309.586)",
    fill: "url(#bi)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.486,337.987l-.693.288a1.35,1.35,0,0,0,.2.533.707.707,0,0,0,.667-.731Z",
    transform: "translate(-351.426 -296.422)",
    fill: "url(#bj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.968,320.689a.39.39,0,0,1,.176.513.725.725,0,0,1-.463.369.7.7,0,0,1-.352.032.509.509,0,0,1-.358-.637.546.546,0,0,1,.667-.328.592.592,0,0,1,.375.659Z",
    transform: "translate(-335.226 -313.845)",
    fill: "url(#bk)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.487,340.133c-.23.1-.461.192-.691.286a1.347,1.347,0,0,0,.2.535.708.708,0,0,0,.667-.731Z",
    transform: "translate(-370.476 -294.27)",
    fill: "url(#bl)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.932,328.933a1.543,1.543,0,0,0,.621.1.535.535,0,0,0,.473-.361c.08-.338-.29-.613-.372-.951s.128-.737-.062-1.027a.592.592,0,0,0-.9.028,1.5,1.5,0,0,0-.28.973,1.7,1.7,0,0,0,.156.9.664.664,0,0,0,.777.332Z",
    transform: "translate(-345.79 -307.94)",
    fill: "url(#bm)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.658,327.555a2.256,2.256,0,0,0-1.086-1.664,2.3,2.3,0,0,0-.423.815.792.792,0,0,0,.274.825c.352.232.817.026,1.184-.18l-.092.336Z",
    transform: "translate(-349.084 -308.552)",
    fill: "url(#bn)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.965,331.651l-.318.286a.52.52,0,0,0,.529.381.436.436,0,0,0,.374-.5.373.373,0,0,0-.557-.212Z",
    transform: "translate(-346.558 -302.884)",
    fill: "url(#bo)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M497.4,130.331c8.588,6.263,3.9,57.4,5.313,62.005s6.379,8.858,7.086,13.817-13.817,51.022-31.534,55.274S434.682,249.38,423.7,218.91s-1.416-67.321,7.443-78.659S480.388,117.929,497.4,130.331Z",
    transform: "translate(-289.049 -91.684)",
    fill: "url(#g)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M498.035,149.17l-5.1,1.4S481.947,144.2,461,140.053c-26.866-5.317-33.83,27.383-34.581,33.687l-3.2-17.495.449-20.671,37.465-7.947,32.592,8.514,3.785,3.911S497.907,145.806,498.035,149.17Z",
    transform: "translate(-284.92 -93.901)",
    fill: "#ba645e"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M461.691,233.417s7.583-11.987,4.382-21.62c0,0-19.483-11.945-54.565-21.618l-6.377,11.688S439.357,210.679,461.691,233.417Z",
    transform: "translate(-302.725 -26.174)",
    fill: "url(#bq)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M424.606,153.661s22.045,13.609,26.661,29.784,0,36.237,0,36.237-22.311-39.387-25.145-49.494S424.606,153.661,424.606,153.661Z",
    transform: "translate(-283.502 -62.794)",
    fill: "#c47d70"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M531.045,322a119.058,119.058,0,0,1-5.648,17.521c-16.475,41.458-55.464,92.809-56.68,94.4l-.038.036,6.938,5.143c-40.317,29.77-117.834,14.454-121.387-7.388-3.533-21.861,34.619-37.735,48.326-86.5,13.687-48.753,17.184-108.443,19.654-113.229,11.538-22.309,35.288-36.97,35.288-36.97,30.873,8.883,64.272,37.437,64.272,37.437S540.973,278.714,531.045,322Z",
    transform: "translate(-354 -21.327)",
    fill: "url(#br)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M464.7,219.95l-1.488-4.488s-7.681-7.681-18.334-.318-25.947,30.867-31,58.859,2.994,64.367,19.878,80.724c0,0,25.894-10.931,33.081-32.187l-18.15-49.6Z",
    transform: "translate(-295.445 -4.34)",
    opacity: 0.5,
    fill: "url(#bs)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 195.583,
    height: 11.811,
    transform: "translate(154.818 359.729)",
    fill: "#36295c"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M643.044,286.877v11.031l-114.09,2.835V288.932Z",
    transform: "translate(-178.553 70.797)",
    fill: "#9b5ed7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M435.3,153.348s-2.375,10.819-1.009,20.024c0,0,16.6,9.7,27.228,5.554,0,0,5-19.908,1.969-39.574,0,0-5.622,5.315-11,5.492S436.9,150.868,435.3,153.348Z",
    transform: "translate(-273.905 -77.144)",
    fill: "url(#g)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M557.626,310.064h75.588s-10.983-22.133-37.793-24.258S557.626,310.064,557.626,310.064Z",
    transform: "translate(-149.801 69.601)",
    fill: "#36295c"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M657.342,286.535c.789,3.251-7.743,5.155-9.389,4.314,0,0,7.795,9.275,7.795,11.388,0,.879-.843,1.216-1.945,1.234a8.809,8.809,0,0,1-4.376-1.2,4.058,4.058,0,0,1,.561.523,2.058,2.058,0,0,1,.673,2.281c-.318.637-1.851.6-3.627.28a27.8,27.8,0,0,1-5.928-1.812c-3.965-1.945-9.724-6.731-9.724-6.731s-10.977.877-18.588,3.439l2.193-3.018c1.907.206,9.119-.246,13.082.745,2.263.579,14.571,9.547,14.571,10.427,0,1.776-6.615,3.645-19.489-5.512,0,0-21.614,10.805-34.012,11.8-15.708,1.252-25.039-3.835-25.039-3.835l-29.061,1.31s10.322-13.669,18.925-17.989c0,0,71.677-14.737,80.167-12.958C642.639,282.994,656.845,284.48,657.342,286.535Z",
    transform: "translate(-172.453 64.974)",
    fill: "url(#g)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M679.31,360.117S664.893,366.492,659,380.892c0,0-95.669,4.488-134.415-1.646,0,0-35.6-38.652-62.328-59.223-.036-.036-.074-.056-.092-.074,0,0-6.734,23.393-29.135,26.573,0,0-28.069-29.3-17.018-76.522,9.632-41.158,39.363-56.063,40.3-56.511l.018-.018s11.334,6.525,17,14.342c0,0,1.122,2.281,3.14,6.209,10.136,19.728,43.049,81.064,71.042,102.72,0,0,71.677,16.3,117.175,21.9h.018C669.978,359.294,674.9,359.8,679.31,360.117Z",
    transform: "translate(-294.397 -2.816)",
    fill: "url(#i)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M666.879,353.638s-14.416,6.375-20.308,20.775c0,0-95.669,4.488-134.415-1.646,0,0-35.6-38.652-62.328-59.223-.036-.036-.074-.056-.092-.074-3.1-2.411-20.365,7.442-20.365,7.442a136.877,136.877,0,0,1-3.124-19.934c-4.094-50.789,23.489-81.046,23.489-81.046,5.478.354,12.117,6.731,12.117,6.731l2.187.879c10.136,19.728,43.049,81.064,71.042,102.72,0,0,71.677,16.3,117.175,21.9h.018C657.548,352.815,662.467,353.32,666.879,353.638Z",
    transform: "translate(-281.966 3.663)",
    fill: "url(#bq)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M504.989,182.6c-.581-1.945-2.449.709-11.482,1.963-9.033,1.234-22.852-5.852-22.852-5.852-10.453-.357-22.327,6.711-22.327,6.711-7.368-.018-14.006-11.462-17.691-19.241v-.018c-1.889-4.022-2.992-7.052-2.992-7.052-2.618,2.039-2.169,4.376-2.169,4.376.879,8.51-4.244,21.076-4.244,21.076s1.945,14.7,20.365,31.7A48.95,48.95,0,0,0,482.175,228.6a.056.056,0,0,0,.036-.018C499.884,219.121,505.55,184.563,504.989,182.6Zm-16.437,27.993c-3.367,0-2.133-9.387-7.088-10.266-4.955-.9-12.754,11.164-18.346,7.611-5.59-3.535-5.2-18.774-2.822-21.43,3.627-4.076,9.293-3.907,9.293-3.907a42.97,42.97,0,0,0,14.885,8C493.693,193.445,499,188.1,499,188.1,501.828,201.038,491.916,210.593,488.552,210.593Z",
    transform: "translate(-286.58 -57.329)",
    fill: "url(#bx)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(188.783 106.537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.3,172.8s-3.293-10.166-9.638-11.244-12.4,11.052-12.4,11.052Z",
    transform: "translate(-448.259 -161.485)",
    fill: "#d57f71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.3,167.535c.324-.823-17.607-1.212-22.039-.192a17.461,17.461,0,0,0,10.1,5.92C464.766,174.353,469.473,169.628,470.3,167.535Z",
    transform: "translate(-448.259 -156.224)",
    fill: "#ba645e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.973,171.678s-2.359-4.122-6.313-4.192C448.66,167.486,451.985,170.849,454.973,171.678Z",
    transform: "translate(-447.857 -155.467)",
    fill: "#801e47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.009,176.96s5.568-2.1,6.517-5.309a30.16,30.16,0,0,0-5.119-9.023s3.563,6.245,3.451,8.8C460.858,171.424,458.939,175.51,456.009,176.96Z",
    transform: "translate(-440.487 -160.339)",
    fill: "#ba645e"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M462.774,139.352a16.352,16.352,0,0,1-4.8,7.973s-14.172.885-23.385,6.022c0,0,2.692-5.5,10.669-7.971C454.878,142.39,462.774,139.352,462.774,139.352Z",
    transform: "translate(-273.187 -77.144)",
    fill: "#0f101d"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M462.219,144.136s-7.521,18.85-7.575,24.292.312,6.277.312,6.277,9.125,3.978,11.783-.805c0,0-1.027-14.881.018-24.448C466.757,149.451,466.2,140.416,462.219,144.136Z",
    transform: "translate(-253.079 -73.247)",
    fill: "url(#g)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M452.652,152.09s3.9,7.026.226,14.07c0,0-10.284,1.7-15.638-7.044C437.24,159.116,441.492,152.09,452.652,152.09Z",
    transform: "translate(-270.526 -64.37)",
    fill: "#ffebed"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M452.419,153.721a42,42,0,0,0-2.69-4.759s-9.832,3.665-12.49,13.291h.531S441.756,156.348,452.419,153.721Z",
    transform: "translate(-270.526 -67.506)",
    fill: "#ba645e"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M454.311,161.39s3.535-9.073,9.918-9.427c0,0,1.686,5.67.711,10.276,0,0-.781,4.606-3.97,4.428S454.311,161.39,454.311,161.39Z",
    transform: "translate(-253.407 -64.497)",
    fill: "#ffebed"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M464.093,152.954s-1.879-4.03-3.561-3.992c-1.082.026-5.536,6.187-6.081,14.773A18.479,18.479,0,0,1,464.093,152.954Z",
    transform: "translate(-253.266 -67.507)",
    fill: "#ba645e"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M447.909,152.6s.939,10.325-3.669,11.961c0,0-5.318-1.935-7-5.95A14.641,14.641,0,0,1,447.909,152.6Z",
    transform: "translate(-270.526 -63.861)",
    fill: "#2b405a"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M461.221,152.6s1.821,10.341-2.323,12.722c0,0-3.878-2.477-4.586-4.564C454.311,160.754,456.7,154.412,461.221,152.6Z",
    transform: "translate(-253.407 -63.861)",
    fill: "#2b405a"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M437.24,160.191s5.354-5.7,15.412-7.026l.747,1.72s4.044-2.658,3.1-3.563C455.436,150.3,443.441,151.511,437.24,160.191Z",
    transform: "translate(-270.526 -65.445)",
    fill: "#10111f"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M454.311,162.705s2.65-7.376,9.918-9.427l.447,1.867s4.164-3.561,3.691-4.194C467.568,149.879,457.712,151.229,454.311,162.705Z",
    transform: "translate(-253.407 -65.812)",
    fill: "#10111f"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M445.039,172.245s6.215,7.523,16,8.734,13.241-3.168,13.241-3.168-3.543,6.046-13.241,5.39-18.438-10.955-18.438-10.955Z",
    transform: "translate(-265.145 -44.158)",
    fill: "#e39790"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M461.521,144.441s-7.8,18.362-7.759,22.422,5.9,14,5.9,14-4.364-8.618-4.138-13.645,6.647-20.014,6.647-20.014Z",
    transform: "translate(-253.957 -72.04)",
    fill: "#ba645e"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M456.009,157.864s3.775-14.617,7.761-16.858c2.934-1.648,1.612,10.833,1.612,10.833s.15-3.9-2.856-3.188S456.009,157.864,456.009,157.864Z",
    transform: "translate(-251.704 -75.635)",
    fill: "#0f101d"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M540.01,221.812l92.359-3.189-18.779,48.9h-92.9Z",
    transform: "translate(-186.84 2.351)",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M457.279,127.97c-.635.635-10.883,10.865-13.557,14.885v.112c-.242.074-.467.13-.691.186-4.657,1.1-2.095,3.853-2.095,3.853a26.08,26.08,0,0,1,.186,22.141c-3.385,7.18-3.683,17.3-3.4,24.048l-2.355,4.114-8.286-13.745-6.956-3.869a58.3,58.3,0,0,1-4.955-9.313,82.076,82.076,0,0,1-4.058-12.193,92.951,92.951,0,0,0,14.416-5.516c12.754-6.022,16.121-12.492,16.121-12.492l-5.161-3.759-.018-.018a.056.056,0,0,0-.02-.038.729.729,0,0,1-.056-.112c-.487-.841-2.58-4.787-2.075-7.481a2.452,2.452,0,0,1,.074-.373,1.75,1.75,0,0,1,.168-.431c.038-.074.076-.15.112-.206a3.669,3.669,0,0,1,.3-.431,1.888,1.888,0,0,1,.411-.449c1.815-1.851,5.424-3.01,6.227-3.235a.616.616,0,0,0,.168-.056,5.984,5.984,0,0,0,1.122,6.751C445.817,133.43,456.588,128.289,457.279,127.97Z",
    transform: "translate(-296.73 -92.946)",
    fill: "url(#bx)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.495 85.137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.642,159.9s-12.658-15.494-21.863-4.208c-7.044,8.638,1.074,37.248,13.6,37.282S441.431,170.971,433.642,159.9Z",
    transform: "translate(-409.17 -150.024)",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.51,168.705s-4.43-14.114-18.806-11.136a11.454,11.454,0,0,1,8.62,4.779s.234,13.07,3.142,16.425S431.428,173.394,430.51,168.705Z",
    transform: "translate(-406.629 -144.426)",
    fill: "#ba645e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.633,159.682s4.076-5.231,14.426-2.744,12.786,13.08,12.786,13.08-3.869-16.493-14.364-18.937C413.282,148.943,409.633,159.682,409.633,159.682Z",
    transform: "translate(-408.706 -150.8)",
    fill: "#e39790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.382,157.238s-5.107,8.644-2.51,17.148c0,0,.6-8.975,5.616-14.645Z",
    transform: "translate(-405.193 -144.344)",
    fill: "#ba645e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M482.211,228.583a.056.056,0,0,1-.036.018A48.95,48.95,0,0,1,441.6,216.259c-18.42-17-20.365-31.7-20.365-31.7s5.123-12.566,4.244-21.076c0,0-.449-2.337,2.169-4.376,0,0,1.1,3.03,2.992,7.052v.018a128.651,128.651,0,0,0,.15,22.8c1.254,10.807,19.672,31.36,19.672,31.36s22.778-2.526,30.819,0C489.018,222.766,482.717,228.152,482.211,228.583Z",
    transform: "translate(-286.58 -57.329)",
    opacity: 0.5,
    fill: "url(#cb)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.376,170.839s18.967,11.166,29.415,5.5C474.791,176.337,466.452,186.555,445.376,170.839Z",
    transform: "translate(-262.367 -45.568)",
    opacity: 0.5,
    fill: "url(#cc)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M486.216,205.721s12.363,10.17,19.84,1.889l-9.92,21.454S486.572,222.843,486.216,205.721Z",
    transform: "translate(-221.412 -10.588)",
    fill: "#ba645e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M483.366,214.273s.789,19.315,9.257,27.729c0,0-7.663-1.933-10.937-25.017Z",
    transform: "translate(-225.955 -2.011)",
    opacity: 0.5,
    fill: "url(#cd)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.066,223.638c-3.519,7.633-22.237,28.889-26.928,38.821-3.605,11.338,14.026,12.223,14.026,12.223s22.486-15.253,29.706-30.523c0,0-25.073,52.213-29.576,59.97,0,0-20.969-26.2-25.254-38.037A411.8,411.8,0,0,0,495.066,223.638Z",
    transform: "translate(-250.669 7.38)",
    opacity: 0.3,
    fill: "url(#ce)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M452.447,266.99s-7.527,23.3-29.227,26.5c0,0,2.924-14,8.77-19.131S449.447,264.634,452.447,266.99Z",
    transform: "translate(-284.585 50.217)",
    fill: "#4723a9",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M679.31,360.108S664.893,366.483,659,380.883c0,0-95.669,4.488-134.415-1.646,0,0-35.6-38.652-62.328-59.223-.036-.036-.074-.056-.092-.074,0,0-6.734,23.393-29.135,26.573,0,0-28.069-29.3-17.018-76.522,9.632-41.158,39.363-56.063,40.3-56.511-.823.9-27.282,29.622-32.2,55.969-3.815,20.459,8.528,33.137,14.566,38a32.37,32.37,0,0,0,3.124,2.225l22.422,4.639s42.636,42.822,63.954,53.107c21.336,10.286,118.072-1.981,136.51-8.788h.018C669.978,359.285,674.9,359.79,679.31,360.108Z",
    transform: "translate(-294.397 -2.807)",
    opacity: 0.3,
    fill: "url(#ce)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.964,308.765s6.74-13.755,19.87-22.812c0,0-15.081,13.265-16.675,22.812Z",
    transform: "translate(-178.544 69.87)",
    opacity: 0.5,
    fill: "url(#cd)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.837,428.057c2.189-.655,38.134,3.513,62.78-7.465C435.3,450.362,357.783,435.047,354.23,413.2c-3.533-21.861,34.619-37.735,48.326-86.5,13.687-48.753,17.184-108.443,19.654-113.229,0,0-7.959,87.918-23.918,138.361-16.293,51.5,7.565,44.423,36.031,36.341,0,0,41.292-13.641,63.884-41.3,14.6-17.871,23.563-26.928,23.563-26.928l3.627,1.065c-16.475,41.458-55.464,92.809-56.68,94.4l-.038.036S446.854,425.149,412.837,428.057Z",
    transform: "translate(-354 -2.816)",
    opacity: 0.5,
    fill: "url(#bs)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M478.809,228.559s-46.638,18.494-67.9,17.765c-21.262-.711-22.852-14.342-22.852-14.342,11.538-22.309,35.288-36.97,35.288-36.97C452.067,204.624,478.809,228.559,478.809,228.559Z",
    transform: "translate(-319.848 -21.327)",
    fill: "#ce47b8",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M417.832,250.183s52.366,34.841,97.143,40.563C514.975,290.746,457.065,261.889,417.832,250.183Z",
    transform: "translate(-289.989 34)",
    opacity: 0.3,
    fill: "url(#ci)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.741,325.1s32.416-8.993,57.074-58.741C434.815,266.356,399.283,309.395,377.741,325.1Z",
    transform: "translate(-330.193 50.218)",
    opacity: 0.5,
    fill: "url(#cj)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.526,207.98s-26.375-1.594-38.32-4.895a75.1,75.1,0,0,1-20.4-9.1l-1.126,2.059a204.472,204.472,0,0,1,56.467,31.218A26.3,26.3,0,0,0,465.526,207.98Z",
    transform: "translate(-302.179 -22.358)",
    opacity: 0.3,
    fill: "url(#ce)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.739,299.888s-31.312,28.682-41.3,67.178l17.7-4.967s46.664-64.919,55.8-92.236l-2.744-3.229s-8.85,21.959-29.135,26.573Z",
    transform: "translate(-305.423 50.498)",
    opacity: 0.5,
    fill: "url(#bs)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M522.444,249.672l-6.5,16.472,90.314,2,6.532-18.474Z",
    transform: "translate(-191.596 33.488)",
    fill: "#ea2a8a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M534.985,252.943l-1.889,4.79,26.262.582,1.9-5.372Z",
    transform: "translate(-174.4 36.768)",
    fill: "#fff",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M554.121,287.4s-.709,6.85,8.74,17.124l-26.589,1.19s5.476-12.538,16.742-18.053Z",
    transform: "translate(-171.215 71.317)",
    fill: "#ba645e"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M610.116,298.295H610a17.057,17.057,0,0,1-6.521-2.481c-3.549-2.628-9.579-7.308-9.579-7.308s-8.017-.815-12.86-.088l-9.079,2.636,16.651-.545,5.736-.757S600.53,297.011,610.116,298.295Z",
    transform: "translate(-135.423 72.039)",
    fill: "#ba645e"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M596.62,289.946a71.837,71.837,0,0,0-10.393-7.975s14.44,3.559,17.432,6.753C603.659,288.724,600.281,291.072,596.62,289.946Z",
    transform: "translate(-121.119 65.877)",
    fill: "#ba645e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M597.575,313.412l-1.833-6.811,36.4-85.428v8.149Z",
    transform: "translate(-111.578 4.908)",
    opacity: 0.2,
    fill: "url(#cm)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(178.959 333.005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M567.33,358.4c-5.792,0-11.693-.691-15.281-2.033-2.636-.985-3.976-2.3-3.982-3.922-.006-1.388,1-2.786,3.082-4.25-8.906-.615-18.73-1.134-28.121-1.628-48.2-2.546-79.788-4.807-79.674-12.744.038-2.718.142-9.94,106.848-14.578,52.322-2.275,105.3-2.786,105.831-2.79l.016,1.871c-.529.006-53.477.515-105.769,2.788-94.713,4.116-105.022,10.28-105.056,12.738-.1,6.731,44.983,9.111,77.9,10.847,11.937.631,22.251,1.2,30.837,1.815a63.4,63.4,0,0,1,6.487-2.848c24.535-9.407,71.122-9.157,108.553-8.971,15.46.082,30.066.156,40.958-.459,66.311-3.743,97.211-10.328,103.317-22.021a8.38,8.38,0,0,0,.156-8.081c-8.548-17.208-69.169-27.631-69.782-27.735l.312-1.841c2.534.425,62.173,10.689,71.144,28.742a10.268,10.268,0,0,1-.172,9.78C808.4,325.6,778.017,332.269,710.067,336.1c-10.947.619-25.58.543-41.07.463-37.279-.184-83.666-.435-107.876,8.844-1.268.489-2.391.949-3.389,1.388,16.317,1.292,25.506,2.88,26.716,5.748a2.223,2.223,0,0,1-.539,2.425C581.883,357.284,574.7,358.4,567.33,358.4Zm-12.952-9.976c-4.036,2.2-4.444,3.555-4.442,4.014,0,.729,1.013,1.522,2.77,2.179,7.763,2.9,26.978,2.337,29.8-.877.1-.12.272-.341.218-.467C581.785,351.044,569.8,349.567,554.378,348.426Z",
    transform: "translate(-443.354 -274.56)",
    fill: "#36295c"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.724 192.011)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M420.169,208.167a11.846,11.846,0,0,0-4.849,2.349,2.09,2.09,0,0,0-.585.645,1.691,1.691,0,0,0,.2,1.608,3.476,3.476,0,0,0,3.611,1.456,4.3,4.3,0,0,0,3-2.622,2.9,2.9,0,0,0,.09-2.215,1.633,1.633,0,0,0-1.835-.991.352.352,0,0,0,.365.467Z",
    transform: "translate(-330.946 -200.146)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M378.821,319.082a11.9,11.9,0,0,0-4.849,2.349,2.088,2.088,0,0,0-.585.645,1.69,1.69,0,0,0,.2,1.608,3.477,3.477,0,0,0,3.611,1.458,4.321,4.321,0,0,0,3-2.622,2.911,2.911,0,0,0,.09-2.217,1.634,1.634,0,0,0-1.837-.989.355.355,0,0,0,.367.467Z",
    transform: "translate(-372.411 -88.918)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M404.848,215.153a3.513,3.513,0,0,0-2.826-1.881,3.688,3.688,0,0,0-.493,3.363,2.23,2.23,0,0,0,2.9,1.232c1.043-.549,1.07-2.411-.048-2.788Z",
    transform: "translate(-344.282 -195.026)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M412.277,215.971a1.8,1.8,0,0,0-.5-1.508,1.851,1.851,0,0,0-.493.545.634.634,0,0,0,.044.693c.226.25.627.186.953.1l-.142.24Z",
    transform: "translate(-334.361 -193.832)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M413.481,216.047a.827.827,0,0,1,.453.192,1.384,1.384,0,0,1-1.23.1c-.232-.058-.5-.17-.533-.407-.02-.166.092-.314.132-.475.08-.324-.1-.763.18-.939a.408.408,0,0,1,.5.122,1.19,1.19,0,0,1,.206.519c.09.4.18.8.27,1.2Z",
    transform: "translate(-333.392 -193.817)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M399.4,213.511c-.212-.272-.7.038-.681.383a1.244,1.244,0,0,0,.573.825,1.213,1.213,0,0,0,.29-1.312Z",
    transform: "translate(-346.878 -194.891)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M413.82,224.34a1.254,1.254,0,0,0-.435-.254.427.427,0,0,0-.455.134c-.158.23.04.541,0,.817s-.308.513-.248.785a.474.474,0,0,0,.675.236,1.211,1.211,0,0,0,.489-.647,1.372,1.372,0,0,0,.142-.713.531.531,0,0,0-.485-.471Z",
    transform: "translate(-332.881 -184.198)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M398.029,219.614a.313.313,0,0,1-.142.411.58.58,0,0,1-.473,0,.554.554,0,0,1-.238-.152.409.409,0,0,1,.09-.579.435.435,0,0,1,.581.124.469.469,0,0,1-.09.6Z",
    transform: "translate(-348.51 -189.049)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M409.963,217.3a.483.483,0,0,0,.226-.8.838.838,0,0,0-.469.248.406.406,0,0,0-.04.495.271.271,0,0,0,.445-.03Z",
    transform: "translate(-335.954 -191.791)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M414.129,216.376a1.371,1.371,0,0,0,.01-1.2l-.873.523a.9.9,0,0,0-.358.31.546.546,0,0,0,.35.737.767.767,0,0,0,.807-.342Z",
    transform: "translate(-332.703 -193.117)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M422.324,222.961a.615.615,0,0,1-.7.891c-.158-.044-.312-.206-.244-.357a.37.37,0,0,1,.146-.142q.379-.249.757-.5l.066.144Z",
    transform: "translate(-324.171 -185.418)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M419.448,223.1c-.088.284.168.553.407.731s.519.4.5.695a.262.262,0,0,1-.11.208c-.18.108-.363-.122-.539-.236a2.247,2.247,0,0,0-.475-.162,1,1,0,0,1-.647-.919.551.551,0,0,1,1.009.068Z",
    transform: "translate(-326.957 -185.169)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M417.764,223.623l-.306.156a.414.414,0,0,0,.33.4.346.346,0,0,0,.393-.31.3.3,0,0,0-.389-.276Z",
    transform: "translate(-328.088 -184.694)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M399.847,218.432l-.306.158a.418.418,0,0,0,.332.4.348.348,0,0,0,.393-.312.3.3,0,0,0-.389-.276Z",
    transform: "translate(-346.055 -189.9)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M411.165,216.384c-.028.224.278.348.491.278a6.536,6.536,0,0,0,.581-.339.817.817,0,0,1,.671.008.4.4,0,0,1,.244.3.491.491,0,0,1-.082.254,2.432,2.432,0,0,1-.875.977,1.137,1.137,0,0,1-1.248-.044.87.87,0,0,1,.276-1.494Z",
    transform: "translate(-334.933 -192.034)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M412.6,213.9a.54.54,0,0,0-.322-.677.783.783,0,0,0-.777.18c-.09.084-.17.22-.1.324a.312.312,0,0,0,.222.1l1.019.164Z",
    transform: "translate(-334.187 -195.119)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M405.974,213.716a.912.912,0,0,1-1.1.941,2.276,2.276,0,0,1,.278-1.272.789.789,0,0,1,1.138-.218c.02.256.038.515.056.771Z",
    transform: "translate(-340.707 -195.296)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M427.631,217.077a.233.233,0,0,1,.23.25.541.541,0,0,1-.17.338.673.673,0,0,1-.248.188.464.464,0,0,1-.535-.2.584.584,0,0,1,.018-.591.381.381,0,0,1,.23-.184.205.205,0,0,1,.24.132Z",
    transform: "translate(-318.683 -191.415)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M408.945,216l-.164-.32a.758.758,0,0,0-.449.3c-.086.164.032.425.214.391a.372.372,0,0,0,.176-.108l.491-.451Z",
    transform: "translate(-337.268 -192.615)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M406.271,216.327a2.178,2.178,0,0,0-.659-.577.743.743,0,0,0-.825.076.65.65,0,0,0-.18.391.814.814,0,1,0,1.622.108Z",
    transform: "translate(-340.98 -192.63)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M404.74,214.937l-.577-.162a1.081,1.081,0,0,0-.136.437.568.568,0,0,0,.781-.13Z",
    transform: "translate(-341.556 -193.519)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M399.108,215.815a7.587,7.587,0,0,0-3.355.739,1.317,1.317,0,0,0-.457.312,1.077,1.077,0,0,0-.114,1.029,2.214,2.214,0,0,0,2.023,1.436,2.748,2.748,0,0,0,2.249-1.182,1.844,1.844,0,0,0,.383-1.36,1.039,1.039,0,0,0-.991-.885.225.225,0,0,0,.158.342Z",
    transform: "translate(-350.503 -192.476)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M379.062,306.607a7.56,7.56,0,0,0-3.355.739,1.325,1.325,0,0,0-.459.312,1.083,1.083,0,0,0-.114,1.027,2.221,2.221,0,0,0,2.025,1.438,2.744,2.744,0,0,0,2.247-1.182,1.85,1.85,0,0,0,.385-1.362,1.041,1.041,0,0,0-.991-.885.227.227,0,0,0,.158.344Z",
    transform: "translate(-370.606 -101.429)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M415.211,220.63a1.8,1.8,0,0,0-1.3-.907,1.89,1.89,0,0,0-.068.731.635.635,0,0,0,.453.529c.328.066.613-.226.823-.489l.032.276Z",
    transform: "translate(-331.731 -188.557)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M413.522,220.758a.707.707,0,0,0-.419-.174.741.741,0,0,0-.393.2,6.811,6.811,0,0,1-1.031.649l1.979.459a.4.4,0,0,1,.15.056c.152.112.082.352.15.527.1.256.445.3.715.252C416.6,222.413,414.207,221.241,413.522,220.758Z",
    transform: "translate(-333.883 -187.694)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M417.359,223.477a.828.828,0,0,1,.453.192,1.384,1.384,0,0,1-1.23.106c-.232-.058-.5-.17-.533-.409-.02-.164.092-.312.132-.475.078-.322-.1-.763.18-.937a.408.408,0,0,1,.5.122,1.18,1.18,0,0,1,.206.519l.27,1.2Z",
    transform: "translate(-329.503 -186.364)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M413.878,223.821a.313.313,0,0,1-.144.411.568.568,0,0,1-.471,0,.555.555,0,0,1-.238-.152.408.408,0,0,1,.088-.579.437.437,0,0,1,.583.124.472.472,0,0,1-.09.6Z",
    transform: "translate(-332.617 -184.83)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M414.224,223.079a.484.484,0,0,0-.3-.775.836.836,0,0,0-.226.479.4.4,0,0,0,.264.421c.172.048.383-.116.339-.29Z",
    transform: "translate(-331.856 -185.969)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M416.859,220.059a1.374,1.374,0,0,0-.711-.967l-.389.941a.922.922,0,0,0-.1.463.546.546,0,0,0,.723.381.768.768,0,0,0,.441-.759Z",
    transform: "translate(-329.896 -189.19)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M426.523,220.256l-.306.156a.416.416,0,0,0,.33.4.348.348,0,0,0,.393-.312.3.3,0,0,0-.389-.276Z",
    transform: "translate(-319.304 -188.071)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M414.577,222.115c.112.194.431.112.559-.072a6.027,6.027,0,0,0,.262-.619.815.815,0,0,1,.543-.4.388.388,0,0,1,.372.094.5.5,0,0,1,.088.252,2.418,2.418,0,0,1-.116,1.3,1.131,1.131,0,0,1-1.026.713.869.869,0,0,1-.675-1.36Z",
    transform: "translate(-331.119 -187.26)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M414.306,218.867a.544.544,0,0,0-.665-.348.785.785,0,0,0-.513.611c-.024.12,0,.276.112.32a.3.3,0,0,0,.24-.05l.915-.479Z",
    transform: "translate(-332.438 -189.784)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M419,225.129a.912.912,0,0,1-1.1.941,2.289,2.289,0,0,1,.278-1.272.79.79,0,0,1,1.14-.218l.054.769Z",
    transform: "translate(-327.647 -183.851)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M412.648,222.692l-.322-.156a.746.746,0,0,0-.176.513c.03.182.28.32.407.184a.384.384,0,0,0,.074-.192l.124-.655Z",
    transform: "translate(-333.417 -185.887)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M415.625,216.844a2.178,2.178,0,0,0-.659-.577.74.74,0,0,0-.825.078.659.659,0,0,0-.182.389.815.815,0,1,0,1.624.108Z",
    transform: "translate(-331.602 -192.111)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M408.845,213.249c-.284.086-.367.447-.379.745s-.042.651-.3.8a.264.264,0,0,1-.234.026c-.19-.088-.1-.371-.1-.581a2.207,2.207,0,0,0-.128-.483,1,1,0,0,1,.4-1.049.559.559,0,0,1,.541.272.566.566,0,0,1-.036.6Z",
    transform: "translate(-337.901 -195.596)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M405.737,215.231c-.284.086-.366.449-.38.747s-.04.651-.3.8a.257.257,0,0,1-.234.024c-.19-.088-.1-.369-.1-.579a2.308,2.308,0,0,0-.128-.485,1,1,0,0,1,.4-1.049.551.551,0,0,1,.5.877Z",
    transform: "translate(-341.018 -193.607)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M402.977,214.251a1.569,1.569,0,0,0-.709-.132.3.3,0,0,0-.114.022.23.23,0,0,0-.108.19.469.469,0,0,0,.274.445.585.585,0,0,0,.533-.044.4.4,0,0,0,.186-.232.218.218,0,0,0-.12-.252.047.047,0,0,0,0,.078Z",
    transform: "translate(-343.544 -194.179)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M420.472,217.714a1.8,1.8,0,0,0-1.3-.907,1.85,1.85,0,0,0-.068.731.633.633,0,0,0,.451.529c.331.066.613-.226.823-.489l.032.276Z",
    transform: "translate(-326.455 -191.481)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M418.141,221.535a.707.707,0,0,0-.419-.174.74.74,0,0,0-.393.2,6.812,6.812,0,0,1-1.031.649l1.979.459a.378.378,0,0,1,.15.056c.152.112.084.353.15.529.1.254.445.294.715.25C421.223,223.19,418.826,222.018,418.141,221.535Z",
    transform: "translate(-329.251 -186.915)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M419.789,232.66a.707.707,0,0,0-.419-.174.74.74,0,0,0-.393.2,6.816,6.816,0,0,1-1.031.649l1.979.459a.4.4,0,0,1,.15.056c.152.112.082.353.15.529.1.254.445.294.715.25C422.871,234.315,420.474,233.143,419.789,232.66Z",
    transform: "translate(-327.598 -175.758)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M420.521,224.88c-.192-.054-.383-.11-.573-.164a.946.946,0,0,0,.385,1.039c.348.188.887-.088.833-.481-.034-.242-.186-.611.058-.641Z",
    transform: "translate(-325.617 -183.632)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M425.385,220a.813.813,0,1,1-.046-.058Z",
    transform: "translate(-321.603 -188.584)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M422.377,220.659c.445,0,1.021.114,1.082.553.06.423-.423.693-.823.837-.174.062-.385.118-.525,0-.344-.284.324-.9.05-1.252.044-.12.272-.056.248.07Z",
    transform: "translate(-323.523 -187.619)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M422.619,220.561a.821.821,0,0,1,.453.192,1.377,1.377,0,0,1-1.23.1c-.23-.058-.5-.17-.533-.407-.02-.164.094-.314.134-.475.078-.324-.1-.763.18-.939a.409.409,0,0,1,.5.124,1.183,1.183,0,0,1,.208.519l.27,1.2Z",
    transform: "translate(-324.228 -189.289)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M421.9,223.044c-.212-.272-.7.038-.681.383a1.256,1.256,0,0,0,.573.825,1.209,1.209,0,0,0,.29-1.312Z",
    transform: "translate(-324.314 -185.331)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M419.486,220.161a.482.482,0,0,0-.3-.773.848.848,0,0,0-.226.479.409.409,0,0,0,.266.421.273.273,0,0,0,.339-.29Z",
    transform: "translate(-326.581 -188.893)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M415.691,217.6a.482.482,0,0,0-.3-.773.849.849,0,0,0-.226.477.41.41,0,0,0,.266.423c.172.046.381-.118.338-.292Z",
    transform: "translate(-330.386 -191.458)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M418.114,226.268a1.374,1.374,0,0,0-.711-.967l-.386.941a.9.9,0,0,0-.1.463.546.546,0,0,0,.723.381.765.765,0,0,0,.441-.759Z",
    transform: "translate(-328.637 -182.963)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M412.795,230.635a1.374,1.374,0,0,0-.711-.967l-.389.941a.922.922,0,0,0-.1.463.546.546,0,0,0,.723.381.765.765,0,0,0,.441-.759Z",
    transform: "translate(-333.971 -178.584)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M421.362,221.01a1.053,1.053,0,0,0-.523-1.057,1.257,1.257,0,0,0-.411.781.845.845,0,0,0,.545.943c.389.088.8-.419.553-.727Z",
    transform: "translate(-325.116 -188.327)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M422.152,222.592a.624.624,0,0,1-.03.779l-.889-.282a.72.72,0,0,1,.839-.733Z",
    transform: "translate(-324.305 -185.932)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M419.9,223.064a.615.615,0,0,1-.7.889c-.158-.044-.312-.206-.244-.356a.366.366,0,0,1,.146-.14l.757-.5.066.144Z",
    transform: "translate(-326.598 -185.315)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M417.028,223.2c-.088.284.166.553.407.731s.519.4.5.695a.255.255,0,0,1-.108.208c-.18.108-.362-.122-.541-.236a2.2,2.2,0,0,0-.473-.162,1,1,0,0,1-.647-.919.551.551,0,0,1,1.009.068Z",
    transform: "translate(-329.384 -185.066)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M415.343,223.725l-.306.156a.418.418,0,0,0,.332.4.347.347,0,0,0,.393-.31.3.3,0,0,0-.389-.276Z",
    transform: "translate(-330.515 -184.592)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M419.836,219.2c.112.194.433.112.561-.07a6.512,6.512,0,0,0,.26-.619.815.815,0,0,1,.543-.4.391.391,0,0,1,.375.092.489.489,0,0,1,.086.252,2.409,2.409,0,0,1-.114,1.306,1.133,1.133,0,0,1-1.025.713.87.87,0,0,1-.675-1.362Z",
    transform: "translate(-325.843 -190.184)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M407.553,214.827c.112.194.433.114.561-.07s.152-.423.262-.619a.806.806,0,0,1,.543-.4.389.389,0,0,1,.372.092.489.489,0,0,1,.086.252,2.406,2.406,0,0,1-.114,1.306,1.134,1.134,0,0,1-1.025.713.869.869,0,0,1-.675-1.36Z",
    transform: "translate(-338.161 -194.567)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M407.823,213.4c.112.194.431.112.561-.072a6.486,6.486,0,0,0,.26-.619.806.806,0,0,1,.543-.395.388.388,0,0,1,.375.092.478.478,0,0,1,.086.252,2.447,2.447,0,0,1-.114,1.306,1.134,1.134,0,0,1-1.025.711.869.869,0,0,1-.675-1.36Z",
    transform: "translate(-337.89 -195.998)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M409.889,214.26c.112.194.431.112.561-.07a6.524,6.524,0,0,0,.26-.619.815.815,0,0,1,.543-.4.388.388,0,0,1,.375.094.477.477,0,0,1,.086.252,2.422,2.422,0,0,1-.114,1.3,1.135,1.135,0,0,1-1.025.713.87.87,0,0,1-.675-1.362Z",
    transform: "translate(-335.818 -195.135)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M395.34,221.578c.112.194.433.112.561-.072a6.473,6.473,0,0,0,.26-.619.806.806,0,0,1,.543-.395.388.388,0,0,1,.375.092.478.478,0,0,1,.086.252,2.4,2.4,0,0,1-.114,1.3,1.132,1.132,0,0,1-1.025.713.869.869,0,0,1-.675-1.36Z",
    transform: "translate(-350.408 -187.797)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M415.56,225.076a.54.54,0,0,0-.665-.346.773.773,0,0,0-.511.609c-.024.122-.006.278.11.32a.3.3,0,0,0,.24-.05l.915-.479Z",
    transform: "translate(-331.179 -183.557)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M424.259,222.212a.915.915,0,0,1-1.1.943,2.284,2.284,0,0,1,.28-1.274.787.787,0,0,1,1.138-.216c.018.256.038.513.056.769Z",
    transform: "translate(-322.372 -186.776)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M417.53,225.229c.128-.016.234.122.232.25a.556.556,0,0,1-.17.339.652.652,0,0,1-.248.188.46.46,0,0,1-.535-.2.579.579,0,0,1,.018-.591.367.367,0,0,1,.23-.182.2.2,0,0,1,.24.13Z",
    transform: "translate(-328.811 -183.24)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M417.909,219.777l-.325-.156a.76.76,0,0,0-.176.511c.03.182.28.32.407.184a.373.373,0,0,0,.076-.19l.122-.657Z",
    transform: "translate(-328.142 -188.812)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M406.845,221.737a2.178,2.178,0,0,0-.659-.577.74.74,0,0,0-.825.078.644.644,0,0,0-.18.389.814.814,0,1,0,1.622.108Z",
    transform: "translate(-340.405 -187.204)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M416.843,215.208a.594.594,0,0,1,.3.967,1.653,1.653,0,0,1-.693-.052,1.053,1.053,0,0,1,.282-.7Z",
    transform: "translate(-329.094 -193.085)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M400.36,221.643a1.219,1.219,0,0,0-.435-.252.423.423,0,0,0-.455.134c-.158.228.04.541,0,.817s-.308.511-.248.783a.471.471,0,0,0,.675.236,1.2,1.2,0,0,0,.489-.645,1.336,1.336,0,0,0,.142-.715.531.531,0,0,0-.485-.471Z",
    transform: "translate(-346.379 -186.902)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M412.267,216.965a3.5,3.5,0,0,0-1.136-3.2,3.692,3.692,0,0,0-2.409,2.4,2.229,2.229,0,0,0,1.582,2.72c1.166.186,2.3-1.29,1.632-2.261Z",
    transform: "translate(-336.91 -194.53)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M417.384,214.242a.31.31,0,0,1-.361.242.574.574,0,0,1-.378-.28.562.562,0,0,1-.1-.264.41.41,0,0,1,.419-.411.438.438,0,0,1,.393.449.473.473,0,0,1-.431.425Z",
    transform: "translate(-329.003 -194.769)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M414.348,214.8c-.24.174-.2.543-.112.829s.178.627-.016.855a.263.263,0,0,1-.212.1c-.208-.022-.218-.316-.29-.513a2.111,2.111,0,0,0-.282-.415,1,1,0,0,1,.032-1.124.551.551,0,0,1,.767.661Z",
    transform: "translate(-332.279 -193.817)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M410.151,217.411l-.341-.058a.419.419,0,0,0,.026.521.347.347,0,0,0,.5-.016.3.3,0,0,0-.146-.453Z",
    transform: "translate(-335.835 -190.934)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M413.552,216.734a.234.234,0,0,1,.036.339.543.543,0,0,1-.339.168.635.635,0,0,1-.312,0,.459.459,0,0,1-.306-.483A.578.578,0,0,1,413,216.3a.377.377,0,0,1,.294-.01.206.206,0,0,1,.112.25Z",
    transform: "translate(-332.93 -192.026)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M397.21,220.877A3.513,3.513,0,0,0,394.384,219a3.688,3.688,0,0,0-.493,3.363,2.23,2.23,0,0,0,2.9,1.232c1.043-.549,1.069-2.411-.048-2.788Z",
    transform: "translate(-351.941 -189.286)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M417.555,218.9c-.212-.272-.7.038-.681.383a1.26,1.26,0,0,0,.573.825,1.212,1.212,0,0,0,.29-1.314Z",
    transform: "translate(-328.673 -189.494)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M415.545,224.758c.114.194.433.112.561-.072a6.521,6.521,0,0,0,.262-.619.806.806,0,0,1,.543-.395.383.383,0,0,1,.372.092.476.476,0,0,1,.086.252,2.409,2.409,0,0,1-.114,1.306,1.132,1.132,0,0,1-1.025.711.869.869,0,0,1-.675-1.36Z",
    transform: "translate(-330.146 -184.608)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M398.361,297.846c.112.194.431.112.559-.07a6.033,6.033,0,0,0,.262-.619.815.815,0,0,1,.543-.4.387.387,0,0,1,.373.092.49.49,0,0,1,.088.252,2.429,2.429,0,0,1-.116,1.306,1.131,1.131,0,0,1-1.025.713.869.869,0,0,1-.673-1.362Z",
    transform: "translate(-347.379 -111.314)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M405.191,222a1.255,1.255,0,0,0,.062-.5.425.425,0,0,0-.3-.367c-.272-.054-.481.25-.747.326s-.593-.08-.819.082a.473.473,0,0,0,.048.713,1.213,1.213,0,0,0,.787.194,1.347,1.347,0,0,0,.711-.152.532.532,0,0,0,.242-.631Z",
    transform: "translate(-342.346 -187.151)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M405.117,221.924a.312.312,0,0,1-.433.032.581.581,0,0,1-.188-.433.558.558,0,0,1,.046-.28.408.408,0,0,1,.567-.146.439.439,0,0,1,.116.585.471.471,0,0,1-.585.152Z",
    transform: "translate(-341.088 -187.239)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M406,221.935a.482.482,0,0,0,.593-.579.84.84,0,0,0-.529-.02.411.411,0,0,0-.282.411.274.274,0,0,0,.4.2Z",
    transform: "translate(-339.802 -186.974)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M405.733,220.312l.018-.358a.758.758,0,0,0-.541.04c-.156.1-.184.385-.01.447a.4.4,0,0,0,.206-.006l.651-.146Z",
    transform: "translate(-340.499 -188.355)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M405.7,223.255l-.264-.22a.419.419,0,0,0-.238.465.347.347,0,0,0,.441.236.3.3,0,0,0,.1-.465Z",
    transform: "translate(-340.393 -185.236)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M404.739,223.911a.542.542,0,0,0,.058-.749.779.779,0,0,0-.763-.23c-.12.026-.256.106-.25.228a.309.309,0,0,0,.14.2c.268.216.535.435.8.651Z",
    transform: "translate(-341.8 -185.359)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M405.569,223.629c-.134.178.066.441.286.487s.449-.028.671,0a.8.8,0,0,1,.579.34.39.39,0,0,1,.062.381.476.476,0,0,1-.2.178,2.4,2.4,0,0,1-1.244.411,1.131,1.131,0,0,1-1.059-.661.884.884,0,0,1,.152-.867.894.894,0,0,1,.831-.29Z",
    transform: "translate(-340.969 -184.682)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M415.536,212.89l-.339-.058a.421.421,0,0,0,.024.521.349.349,0,0,0,.5-.014.3.3,0,0,0-.144-.455Z",
    transform: "translate(-330.433 -195.468)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M416.712,216.269a8.185,8.185,0,0,0-3.611-.9,1.417,1.417,0,0,0-.595.082,1.166,1.166,0,0,0-.607.941,2.4,2.4,0,0,0,1.268,2.373,2.978,2.978,0,0,0,2.752-.06,2.012,2.012,0,0,0,1.031-1.136,1.129,1.129,0,0,0-.535-1.338.245.245,0,0,0-.012.411Z",
    transform: "translate(-333.682 -192.928)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M410.419,218.4a3.5,3.5,0,0,0-2.826-1.879,3.686,3.686,0,0,0-.491,3.363,2.229,2.229,0,0,0,2.9,1.232c1.044-.551,1.07-2.411-.048-2.79Z",
    transform: "translate(-338.693 -191.77)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M403.9,215.679a.795.795,0,1,0-1.372-.178.632.632,0,0,0,.451.531c.33.064.613-.226.823-.489l.032.276Z",
    transform: "translate(-343.074 -193.522)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M402.211,215.806a.719.719,0,0,0-.419-.174.755.755,0,0,0-.393.2,6.824,6.824,0,0,1-1.031.651l1.979.457a.412.412,0,0,1,.15.058c.152.11.084.35.15.527.1.256.445.3.715.252C405.293,217.461,402.9,216.291,402.211,215.806Z",
    transform: "translate(-345.226 -192.66)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M413.508,214.46c-.19-.054-.38-.11-.573-.164a.95.95,0,0,0,.387,1.039c.349.188.887-.088.833-.481-.034-.242-.186-.611.058-.641Z",
    transform: "translate(-332.648 -194.082)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M406.048,218.526a.822.822,0,0,1,.453.192,1.378,1.378,0,0,1-1.23.1c-.232-.058-.5-.17-.533-.407-.02-.164.092-.314.132-.475.08-.324-.1-.763.18-.939a.408.408,0,0,1,.5.124,1.171,1.171,0,0,1,.206.519q.135.6.272,1.2Z",
    transform: "translate(-340.846 -191.33)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M405.331,221.01c-.212-.272-.7.038-.681.383a1.253,1.253,0,0,0,.571.825,1.213,1.213,0,0,0,.292-1.314Z",
    transform: "translate(-340.932 -187.373)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M402.567,218.87a.312.312,0,0,1-.144.411.583.583,0,0,1-.471,0,.574.574,0,0,1-.238-.152.408.408,0,0,1,.088-.579.437.437,0,0,1,.583.124.469.469,0,0,1-.09.6Z",
    transform: "translate(-343.96 -189.795)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M402.913,218.126a.482.482,0,0,0-.3-.773.836.836,0,0,0-.226.479.41.41,0,0,0,.264.421c.174.046.383-.116.339-.29Z",
    transform: "translate(-343.198 -190.934)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M405.548,215.107a1.378,1.378,0,0,0-.711-.967l-.389.943a.917.917,0,0,0-.1.463.545.545,0,0,0,.723.379.762.762,0,0,0,.441-.757Z",
    transform: "translate(-341.239 -194.156)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M403.332,221.03a.614.614,0,0,1-.7.889c-.158-.044-.314-.206-.246-.357a.37.37,0,0,1,.146-.142q.379-.249.757-.5l.066.144Z",
    transform: "translate(-343.216 -187.357)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M402.068,223.165c-.284.086-.364.447-.379.745s-.042.653-.3.8a.258.258,0,0,1-.234.026c-.19-.088-.1-.371-.1-.579a2.191,2.191,0,0,0-.128-.485,1,1,0,0,1,.4-1.049.551.551,0,0,1,.5.877Z",
    transform: "translate(-344.697 -185.651)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M404.334,233.57c-.286.086-.367.447-.381.745s-.04.653-.3.8a.258.258,0,0,1-.234.026c-.19-.088-.1-.371-.106-.579a2.089,2.089,0,0,0-.128-.485,1,1,0,0,1,.4-1.049.551.551,0,0,1,.5.877Z",
    transform: "translate(-342.428 -175.216)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M400.528,222.087l-.3-.168a.42.42,0,0,0-.148.5.347.347,0,0,0,.477.15.3.3,0,0,0,.014-.475Z",
    transform: "translate(-345.55 -186.355)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M403.266,217.162c.112.194.431.112.559-.072a5.82,5.82,0,0,0,.262-.617.809.809,0,0,1,.543-.4.387.387,0,0,1,.372.092.49.49,0,0,1,.088.252,2.427,2.427,0,0,1-.116,1.306,1.131,1.131,0,0,1-1.025.713.869.869,0,0,1-.673-1.362Z",
    transform: "translate(-342.461 -192.225)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M382.518,280.406c.112.194.431.114.561-.07a6.513,6.513,0,0,0,.26-.619.814.814,0,0,1,.543-.4.393.393,0,0,1,.375.092.489.489,0,0,1,.086.252,2.448,2.448,0,0,1-.114,1.306,1.135,1.135,0,0,1-1.025.713.87.87,0,0,1-.675-1.362Z",
    transform: "translate(-363.267 -128.803)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M402.995,213.917a.54.54,0,0,0-.665-.348.782.782,0,0,0-.513.609c-.022.122,0,.278.112.32a.3.3,0,0,0,.24-.05l.915-.479Z",
    transform: "translate(-343.781 -194.75)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M407.686,220.177a.914.914,0,0,1-1.1.943,2.28,2.28,0,0,1,.28-1.274.789.789,0,0,1,1.138-.218c.018.258.036.515.054.771Z",
    transform: "translate(-338.99 -188.817)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M401.336,217.742l-.323-.156a.751.751,0,0,0-.176.511c.03.182.28.32.407.184a.37.37,0,0,0,.074-.19l.124-.657Z",
    transform: "translate(-344.76 -190.853)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M417.676,216.91a2.179,2.179,0,0,0-.659-.577.744.744,0,0,0-.825.076.67.67,0,0,0-.182.391.815.815,0,1,0,1.624.108Z",
    transform: "translate(-329.545 -192.045)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M410.669,222.433l-.577-.16a1.074,1.074,0,0,0-.136.435.566.566,0,0,0,.781-.13Z",
    transform: "translate(-335.611 -186)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M424.878,218.389a.315.315,0,0,1-.142.413.588.588,0,0,1-.473,0,.578.578,0,0,1-.238-.154.409.409,0,0,1,.09-.579.437.437,0,0,1,.581.124.472.472,0,0,1-.09.6Z",
    transform: "translate(-321.586 -190.277)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M397.483,210.317a.614.614,0,0,1-.7.889c-.158-.044-.314-.206-.246-.356a.365.365,0,0,1,.146-.14c.252-.168.5-.334.757-.5l.066.144Z",
    transform: "translate(-349.081 -198.098)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M394.608,210.457c-.086.284.168.553.409.731s.519.4.5.695a.259.259,0,0,1-.11.208c-.178.108-.362-.122-.539-.236a2.247,2.247,0,0,0-.475-.162,1,1,0,0,1-.647-.919.551.551,0,0,1,1.009.07Z",
    transform: "translate(-351.867 -197.849)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M402.791,204.432c.128-.016.234.122.232.25a.557.557,0,0,1-.17.338.651.651,0,0,1-.248.188.464.464,0,0,1-.537-.2.579.579,0,0,1,.02-.591.379.379,0,0,1,.228-.184.205.205,0,0,1,.24.132Z",
    transform: "translate(-343.593 -204.096)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M401.683,207.611l-.306.156a.414.414,0,0,0,.332.4.347.347,0,0,0,.391-.312.3.3,0,0,0-.387-.276Z",
    transform: "translate(-344.214 -200.752)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M395.632,205.069a1.8,1.8,0,0,0-1.3-.907,1.893,1.893,0,0,0-.068.731.636.636,0,0,0,.451.529c.331.066.615-.226.825-.489l.03.276Z",
    transform: "translate(-351.365 -204.162)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M400.545,207.359a.8.8,0,1,1-.044-.058Z",
    transform: "translate(-346.513 -201.264)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M397.537,208.014c.445,0,1.021.114,1.084.555.058.421-.425.691-.825.835-.172.062-.385.118-.525,0-.344-.286.326-.9.05-1.252.044-.122.274-.058.25.068Z",
    transform: "translate(-348.433 -200.299)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M397.778,207.916a.834.834,0,0,1,.455.192,1.385,1.385,0,0,1-1.23.106c-.232-.058-.5-.172-.533-.409-.02-.164.092-.314.132-.475.078-.322-.1-.763.18-.939a.411.411,0,0,1,.5.124,1.206,1.206,0,0,1,.206.519l.27,1.2Z",
    transform: "translate(-349.137 -201.97)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M397.062,210.4c-.212-.272-.7.038-.681.383a1.262,1.262,0,0,0,.573.825,1.209,1.209,0,0,0,.29-1.312Z",
    transform: "translate(-349.224 -198.012)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M394.645,207.516a.482.482,0,0,0-.3-.773.823.823,0,0,0-.226.479.4.4,0,0,0,.264.421c.172.048.383-.116.338-.29Z",
    transform: "translate(-351.49 -201.574)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M396.522,208.367a1.053,1.053,0,0,0-.521-1.06,1.25,1.25,0,0,0-.413.781.846.846,0,0,0,.547.943c.389.088.8-.419.551-.727Z",
    transform: "translate(-350.026 -201.007)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M397.314,209.948a.627.627,0,0,1-.03.777l-.891-.282a.72.72,0,0,1,.841-.731Z",
    transform: "translate(-349.215 -198.612)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M395.064,210.419a.614.614,0,0,1-.7.889c-.158-.042-.312-.206-.244-.357a.366.366,0,0,1,.146-.14q.379-.252.757-.5l.066.144Z",
    transform: "translate(-351.508 -197.996)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M395,206.552c.114.2.433.114.561-.07a6.518,6.518,0,0,0,.262-.619.815.815,0,0,1,.543-.4.387.387,0,0,1,.373.092.491.491,0,0,1,.086.254,2.4,2.4,0,0,1-.114,1.3,1.133,1.133,0,0,1-1.025.713.869.869,0,0,1-.675-1.36Z",
    transform: "translate(-350.753 -202.865)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M399.418,209.566a.914.914,0,0,1-1.1.943,2.272,2.272,0,0,1,.278-1.272.79.79,0,0,1,1.14-.218l.054.769Z",
    transform: "translate(-347.281 -199.456)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M400.037,205.745a.313.313,0,0,1-.142.411.588.588,0,0,1-.473,0,.552.552,0,0,1-.236-.154.407.407,0,0,1,.088-.579.441.441,0,0,1,.583.124.474.474,0,0,1-.09.6Z",
    transform: "translate(-346.495 -202.958)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M409.159,220.478l-.577-.162a1.08,1.08,0,0,0-.136.437.566.566,0,0,0,.779-.13Z",
    transform: "translate(-337.125 -187.963)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M394.144,217.627c-.05-.218-.381-.234-.557-.1s-.27.359-.433.515a.807.807,0,0,1-.635.218.39.39,0,0,1-.33-.2.5.5,0,0,1-.008-.266,2.4,2.4,0,0,1,.495-1.214,1.134,1.134,0,0,1,1.19-.381.872.872,0,0,1,.244,1.5Z",
    transform: "translate(-353.45 -192.137)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M414.17,218.069a1.255,1.255,0,0,0,.341.371.427.427,0,0,0,.475.006c.218-.172.12-.529.236-.783s.445-.4.469-.675-.3-.475-.577-.425a1.211,1.211,0,0,0-.657.473,1.358,1.358,0,0,0-.344.641.533.533,0,0,0,.324.593Z",
    transform: "translate(-331.449 -191.734)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M392.165,316.969a1.243,1.243,0,0,0,.339.369.423.423,0,0,0,.477.006c.218-.172.12-.529.234-.781s.447-.4.469-.677-.3-.475-.575-.425a1.207,1.207,0,0,0-.657.473,1.363,1.363,0,0,0-.346.641.532.532,0,0,0,.325.593Z",
    transform: "translate(-353.518 -92.557)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M408.175,217.017a6.7,6.7,0,0,0,3.026-.186,1.211,1.211,0,0,0,.441-.21.955.955,0,0,0,.24-.881,1.958,1.958,0,0,0-1.568-1.53,2.425,2.425,0,0,0-2.121.723,1.632,1.632,0,0,0-.521,1.136.919.919,0,0,0,.743.907.2.2,0,0,0-.09-.32Z",
    transform: "translate(-337.901 -194.121)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M410.406,212.966a.718.718,0,0,0-.058-.451.731.731,0,0,0-.365-.242,6.848,6.848,0,0,1-1.078-.573l.587,1.945a.4.4,0,0,1,.026.16c-.02.186-.264.246-.383.391-.174.212-.036.533.136.747C410.5,216.461,410.326,213.8,410.406,212.966Z",
    transform: "translate(-336.664 -196.603)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M408.153,215.562l-.29-.186a.415.415,0,0,0-.182.487.347.347,0,0,0,.465.184.3.3,0,0,0,.048-.473Z",
    transform: "translate(-337.916 -192.916)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M408.613,213.2a.542.542,0,0,0-.028-.751.779.779,0,0,0-.783-.14c-.118.04-.244.134-.224.256a.305.305,0,0,0,.164.182l.869.557Z",
    transform: "translate(-337.997 -196.041)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M407.939,215.286a1.806,1.806,0,0,0,.138-1.582,1.84,1.84,0,0,0-.667.3.633.633,0,0,0-.236.655c.108.318.5.419.833.471l-.224.166Z",
    transform: "translate(-338.424 -194.593)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M406.986,216.176a.82.82,0,0,1,.06.489,1.385,1.385,0,0,1-.7-1.015c-.064-.228-.1-.521.088-.665.132-.1.318-.074.479-.12.318-.092.611-.469.9-.31a.405.405,0,0,1,.142.5,1.2,1.2,0,0,1-.346.439l-.907.831Z",
    transform: "translate(-339.286 -193.779)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M409.7,213.958a1.377,1.377,0,0,0,.485-1.1c-.336.044-.673.088-1.009.13a.93.93,0,0,0-.453.144.546.546,0,0,0,.03.815.765.765,0,0,0,.877.006Z",
    transform: "translate(-337.021 -195.44)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M406.956,212.9c-.114.194.116.431.341.451s.443-.078.667-.08a.807.807,0,0,1,.613.272.39.39,0,0,1,.106.371.5.5,0,0,1-.176.2,2.427,2.427,0,0,1-1.19.551,1.141,1.141,0,0,1-1.13-.535.871.871,0,0,1,.845-1.264Z",
    transform: "translate(-339.482 -195.439)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M412.007,219.011a2.175,2.175,0,0,0,.172-.859.742.742,0,0,0-.477-.675.658.658,0,0,0-.429.036.814.814,0,1,0,.713,1.46Z",
    transform: "translate(-334.781 -190.831)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M413.275,216.1a1.8,1.8,0,0,0,.14-1.582,1.841,1.841,0,0,0-.667.3.633.633,0,0,0-.236.655c.108.318.5.419.833.471l-.224.166Z",
    transform: "translate(-333.071 -193.773)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M406.74,215.805c-.29.064-.4.421-.431.715s-.088.649-.354.779a.26.26,0,0,1-.236.01c-.184-.1-.074-.377-.064-.587a2.213,2.213,0,0,0-.094-.491,1,1,0,0,1,.477-1.019.552.552,0,0,1,.441.911Z",
    transform: "translate(-340.033 -193.081)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M416.593,220.649l-.344.024a.419.419,0,0,0,.146.5.347.347,0,0,0,.483-.132.3.3,0,0,0-.246-.407Z",
    transform: "translate(-329.331 -187.643)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M411.374,225.657a.815.815,0,0,1-.184.457,1.385,1.385,0,0,1-.124-1.23c.054-.232.162-.5.4-.539.164-.022.314.088.477.126.324.074.761-.114.941.164a.409.409,0,0,1-.116.5,1.179,1.179,0,0,1-.515.216l-1.2.288Z",
    transform: "translate(-334.58 -183.925)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M403.137,226.123a1.269,1.269,0,0,0,.246-.439.426.426,0,0,0-.142-.453c-.23-.154-.539.048-.815.016s-.517-.3-.789-.236a.474.474,0,0,0-.226.679,1.213,1.213,0,0,0,.653.479,1.341,1.341,0,0,0,.717.13.529.529,0,0,0,.463-.491Z",
    transform: "translate(-344.24 -183.263)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M410.876,226.313a1.371,1.371,0,0,0,1.2-.008l-.535-.867a.912.912,0,0,0-.316-.352.545.545,0,0,0-.731.362.765.765,0,0,0,.354.8Z",
    transform: "translate(-335.091 -183.228)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M404.132,234.612a.613.613,0,0,1-.9-.685c.04-.158.2-.316.35-.25a.357.357,0,0,1,.144.144l.513.749-.144.068Z",
    transform: "translate(-342.371 -174.58)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M404.262,231.741c-.286-.082-.551.176-.725.419s-.389.525-.687.511a.265.265,0,0,1-.21-.106c-.11-.178.116-.367.228-.545a2.235,2.235,0,0,0,.156-.475,1,1,0,0,1,.907-.661.55.55,0,0,1-.052,1.009Z",
    transform: "translate(-342.977 -177.365)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M403.2,230.067l-.16-.3a.417.417,0,0,0-.4.338.347.347,0,0,0,.316.387.3.3,0,0,0,.27-.393Z",
    transform: "translate(-342.951 -178.489)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M410.093,239.828c.018.128-.118.236-.246.234a.543.543,0,0,1-.343-.164.7.7,0,0,1-.192-.246.463.463,0,0,1,.194-.537.584.584,0,0,1,.591.008.379.379,0,0,1,.188.228.205.205,0,0,1-.128.242Z",
    transform: "translate(-336.282 -169.187)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M406.477,227.467a1.8,1.8,0,0,0,.887-1.318,1.848,1.848,0,0,0-.731-.058.634.634,0,0,0-.521.459c-.062.332.234.611.5.817l-.276.036Z",
    transform: "translate(-339.474 -182.189)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M406.75,225.776a.723.723,0,0,0,.168-.421.752.752,0,0,0-.2-.391,6.88,6.88,0,0,1-.667-1.021l-.427,1.987a.436.436,0,0,1-.054.15c-.108.154-.35.088-.525.158-.254.1-.288.449-.24.719C405.144,228.882,406.277,226.469,406.75,225.776Z",
    transform: "translate(-340.796 -184.325)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M404,229.65a.826.826,0,0,1-.186.455,1.386,1.386,0,0,1-.124-1.228c.054-.232.162-.507.4-.539.164-.022.316.088.479.124.324.074.761-.114.941.166a.412.412,0,0,1-.116.5,1.2,1.2,0,0,1-.517.214q-.6.147-1.2.29Z",
    transform: "translate(-341.971 -179.92)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M403.054,226.181a.314.314,0,0,1-.415-.136.583.583,0,0,1-.008-.471.553.553,0,0,1,.148-.24.408.408,0,0,1,.581.08.436.436,0,0,1-.116.583.469.469,0,0,1-.6-.08Z",
    transform: "translate(-343.001 -183.018)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M403.837,226.516a.483.483,0,0,0,.769-.308.842.842,0,0,0-.483-.218.406.406,0,0,0-.417.27c-.044.174.122.381.3.334Z",
    transform: "translate(-341.885 -182.274)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M407.35,229.1a1.382,1.382,0,0,0,.955-.727l-.947-.372a.924.924,0,0,0-.465-.094.547.547,0,0,0-.369.729.766.766,0,0,0,.765.429Z",
    transform: "translate(-339.087 -180.358)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M406.7,238.772l-.162-.3a.419.419,0,0,0-.4.338.348.348,0,0,0,.318.389.3.3,0,0,0,.27-.393Z",
    transform: "translate(-339.439 -169.759)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M405.536,226.845c-.192.116-.106.435.08.561s.425.144.623.25a.81.81,0,0,1,.4.537.386.386,0,0,1-.088.375.458.458,0,0,1-.25.09,2.416,2.416,0,0,1-1.308-.094,1.129,1.129,0,0,1-.727-1.013.87.87,0,0,1,1.35-.7Z",
    transform: "translate(-341.313 -181.549)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M408.075,226.531a.543.543,0,0,0,.339-.671.787.787,0,0,0-.619-.5c-.122-.02-.278,0-.318.116a.311.311,0,0,0,.054.24l.493.907Z",
    transform: "translate(-338.106 -182.914)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M402.25,231.312a.913.913,0,0,1-.959-1.086,2.287,2.287,0,0,1,1.276.26.788.788,0,0,1,.236,1.134l-.769.068Z",
    transform: "translate(-344.326 -178.025)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M404.194,224.934l.152-.324a.764.764,0,0,0-.515-.17c-.182.034-.316.286-.178.411a.375.375,0,0,0,.192.072l.657.114Z",
    transform: "translate(-341.988 -183.834)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M410.37,227.818a2.185,2.185,0,0,0,.567-.669.742.742,0,0,0-.092-.823.654.654,0,0,0-.391-.174.815.815,0,1,0-.082,1.624Z",
    transform: "translate(-336.016 -182.114)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M409.475,232.68a1.8,1.8,0,0,0,.887-1.318,1.884,1.884,0,0,0-.731-.056.631.631,0,0,0-.523.459c-.06.332.234.611.5.817l-.276.036Z",
    transform: "translate(-336.468 -176.959)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M406.045,230.4a.7.7,0,0,0,.166-.421.729.729,0,0,0-.2-.389,6.831,6.831,0,0,1-.667-1.021l-.427,1.987a.435.435,0,0,1-.054.15c-.108.154-.351.088-.525.158-.254.1-.288.449-.242.719C404.439,233.513,405.573,231.1,406.045,230.4Z",
    transform: "translate(-341.504 -179.681)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M394.948,232.226a.712.712,0,0,0,.166-.421.734.734,0,0,0-.2-.391,6.713,6.713,0,0,1-.667-1.019l-.427,1.985a.419.419,0,0,1-.054.15c-.108.154-.35.088-.525.158-.254.1-.29.449-.242.719C393.342,235.334,394.475,232.919,394.948,232.226Z",
    transform: "translate(-352.634 -177.855)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M402.267,232.841l.154-.575a.952.952,0,0,0-1.033.4c-.182.352.1.887.495.825.242-.036.607-.194.641.048Z",
    transform: "translate(-344.259 -176.001)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M407.418,237.628a.807.807,0,1,1,.058-.046Z",
    transform: "translate(-339.446 -172.061)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M406.658,234.626c0,.445-.1,1.021-.537,1.092-.421.064-.7-.415-.849-.813a.544.544,0,0,1-.008-.525c.278-.346.905.312,1.252.032.122.042.06.272-.066.25Z",
    transform: "translate(-340.382 -173.963)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M407,234.864a.815.815,0,0,1-.184.457,1.379,1.379,0,0,1-.124-1.228c.054-.232.162-.507.4-.539.164-.024.314.088.477.124.324.074.761-.114.941.166a.409.409,0,0,1-.114.5,1.209,1.209,0,0,1-.517.214q-.6.144-1.2.29Z",
    transform: "translate(-338.965 -174.691)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M404.189,234.193c.27-.216-.048-.695-.393-.675a1.253,1.253,0,0,0-.815.585,1.2,1.2,0,0,0,1.316.27Z",
    transform: "translate(-342.605 -174.724)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M406.833,231.732a.483.483,0,0,0,.769-.308.844.844,0,0,0-.481-.22.408.408,0,0,0-.417.272c-.046.174.122.381.294.334Z",
    transform: "translate(-338.879 -177.045)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M409.334,227.9a.481.481,0,0,0,.767-.31.849.849,0,0,0-.481-.218.406.406,0,0,0-.417.272c-.044.174.122.381.3.334Z",
    transform: "translate(-336.372 -180.89)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M401.161,230.449a1.374,1.374,0,0,0,.955-.725l-.947-.375a.9.9,0,0,0-.465-.092.546.546,0,0,0-.369.727.768.768,0,0,0,.765.431Z",
    transform: "translate(-345.294 -179.002)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M396.712,225.2a1.382,1.382,0,0,0,.955-.727l-.947-.373a.9.9,0,0,0-.465-.094.547.547,0,0,0-.369.729.769.769,0,0,0,.765.429Z",
    transform: "translate(-349.755 -184.268)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M406.424,233.618a1.05,1.05,0,0,0,1.049-.539,1.247,1.247,0,0,0-.785-.4.844.844,0,0,0-.935.561c-.082.391.431.8.735.541Z",
    transform: "translate(-339.834 -175.568)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M404.5,234.434a.626.626,0,0,1-.779-.018c.09-.3.18-.595.268-.893a.718.718,0,0,1,.745.827Z",
    transform: "translate(-341.861 -174.722)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M403.994,232.194a.616.616,0,0,1-.9-.685c.04-.16.2-.316.352-.25a.36.36,0,0,1,.142.142q.258.376.513.751l-.142.068Z",
    transform: "translate(-342.511 -177.004)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M404.121,229.324c-.286-.084-.549.176-.723.419s-.391.525-.687.509a.254.254,0,0,1-.21-.106c-.112-.176.116-.365.226-.543a2.234,2.234,0,0,0,.156-.475,1,1,0,0,1,.909-.663.552.552,0,0,1-.054,1.011Z",
    transform: "translate(-343.117 -179.791)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M403.058,227.648l-.162-.3a.419.419,0,0,0-.4.339.348.348,0,0,0,.318.389.3.3,0,0,0,.27-.393Z",
    transform: "translate(-343.091 -180.915)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M408.535,232.06c-.192.116-.106.433.08.559a6.486,6.486,0,0,0,.621.252.806.806,0,0,1,.4.537.387.387,0,0,1-.086.375.48.48,0,0,1-.25.09,2.413,2.413,0,0,1-1.308-.094,1.138,1.138,0,0,1-.729-1.013.871.871,0,0,1,1.352-.7Z",
    transform: "translate(-338.307 -176.32)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M401.886,227.883a.543.543,0,0,0,.339-.671.784.784,0,0,0-.619-.5c-.122-.022-.278,0-.318.116a.313.313,0,0,0,.054.24l.493.907Z",
    transform: "translate(-344.313 -181.558)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M405.246,236.527a.915.915,0,0,1-.959-1.086,2.274,2.274,0,0,1,1.278.26.786.786,0,0,1,.234,1.134l-.769.068Z",
    transform: "translate(-341.32 -172.795)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M373.82,302.616a.914.914,0,0,1-.959-1.086,2.292,2.292,0,0,1,1.278.258.788.788,0,0,1,.234,1.136c-.256.022-.513.044-.769.068Z",
    transform: "translate(-372.836 -106.519)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M401.785,229.856a.236.236,0,0,1-.248.234.542.542,0,0,1-.34-.164.669.669,0,0,1-.192-.244.461.461,0,0,1,.194-.539.583.583,0,0,1,.591.008.378.378,0,0,1,.188.228.207.207,0,0,1-.128.242Z",
    transform: "translate(-344.614 -179.187)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M407.191,230.149l.152-.326a.766.766,0,0,0-.515-.168c-.182.034-.316.286-.178.411a.382.382,0,0,0,.194.072l.657.112Z",
    transform: "translate(-338.983 -178.604)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M411.782,229.01a.6.6,0,0,1-.963.318,1.685,1.685,0,0,1,.042-.693,1.057,1.057,0,0,1,.705.272Z",
    transform: "translate(-334.763 -179.62)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M412.745,229.54a.312.312,0,0,1-.248-.357.578.578,0,0,1,.274-.383.561.561,0,0,1,.264-.1.411.411,0,0,1,.417.413.439.439,0,0,1-.443.4.475.475,0,0,1-.433-.425Z",
    transform: "translate(-333.066 -179.559)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M412.715,226.512c-.178-.238-.545-.19-.829-.1s-.627.188-.857,0a.261.261,0,0,1-.1-.21c.018-.208.312-.222.507-.3a2.2,2.2,0,0,0,.411-.288,1,1,0,0,1,1.124.016.551.551,0,0,1-.647.777Z",
    transform: "translate(-334.64 -182.819)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M410.213,225.748a.236.236,0,0,1-.339.04.561.561,0,0,1-.174-.336.651.651,0,0,1-.006-.31.462.462,0,0,1,.479-.316.581.581,0,0,1,.467.363.372.372,0,0,1,.014.292.2.2,0,0,1-.248.118Z",
    transform: "translate(-335.89 -183.443)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M408.273,229.782c.268-.216-.05-.695-.395-.675a1.26,1.26,0,0,0-.815.585,1.2,1.2,0,0,0,1.316.27Z",
    transform: "translate(-338.512 -179.147)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M402.907,227.856c-.192.116-.1.433.08.559a6.522,6.522,0,0,0,.623.252.805.805,0,0,1,.4.537.39.39,0,0,1-.086.375.464.464,0,0,1-.252.09,2.408,2.408,0,0,1-1.306-.094,1.131,1.131,0,0,1-.729-1.013.87.87,0,0,1,1.35-.7Z",
    transform: "translate(-343.949 -180.535)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M412.066,228.894a8.188,8.188,0,0,0,.849-3.625,1.455,1.455,0,0,0-.092-.595,1.175,1.175,0,0,0-.951-.593,2.406,2.406,0,0,0-2.353,1.306,2.98,2.98,0,0,0,.1,2.752,2.008,2.008,0,0,0,1.15,1.011,1.127,1.127,0,0,0,1.33-.555.244.244,0,0,0-.409-.006Z",
    transform: "translate(-336.339 -184.203)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M412.577,225.669l.154-.575a.952.952,0,0,0-1.033.4c-.182.352.1.887.495.825.242-.036.607-.194.641.048Z",
    transform: "translate(-333.92 -183.193)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M410.336,229.87a2.186,2.186,0,0,0,.567-.669.742.742,0,0,0-.092-.823.66.66,0,0,0-.393-.174.814.814,0,1,0-.082,1.624Z",
    transform: "translate(-336.05 -180.056)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M408.656,237.1a.314.314,0,0,1-.415-.136.583.583,0,0,1-.008-.471.535.535,0,0,1,.148-.24.408.408,0,0,1,.581.08.436.436,0,0,1-.116.583.471.471,0,0,1-.6-.08Z",
    transform: "translate(-337.383 -172.073)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M409.367,226.38a1.253,1.253,0,0,0-.364.346.426.426,0,0,0,0,.475c.176.216.531.112.785.224s.407.439.685.457.469-.31.415-.581a1.212,1.212,0,0,0-.483-.651,1.342,1.342,0,0,0-.647-.334.527.527,0,0,0-.587.332Z",
    transform: "translate(-336.638 -181.951)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M393.107,292.791a1.283,1.283,0,0,0-.365.346.426.426,0,0,0,0,.475c.176.216.531.112.785.224s.4.439.683.459.471-.312.417-.583a1.2,1.2,0,0,0-.485-.649,1.348,1.348,0,0,0-.645-.336.534.534,0,0,0-.589.334Z",
    transform: "translate(-352.944 -115.352)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M396.116,290.014a1.306,1.306,0,0,0-.365.346.426.426,0,0,0,0,.475c.176.216.531.112.785.224s.407.439.685.459.469-.312.415-.583a1.2,1.2,0,0,0-.483-.649,1.345,1.345,0,0,0-.647-.336.531.531,0,0,0-.587.332Z",
    transform: "translate(-349.926 -118.137)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M411.137,225.457a1.8,1.8,0,0,0,1.584.114,1.839,1.839,0,0,0-.316-.661.629.629,0,0,0-.657-.226c-.318.112-.413.507-.459.841l-.168-.222Z",
    transform: "translate(-334.442 -183.608)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M376.262,314a1.8,1.8,0,0,0,1.584.114,1.863,1.863,0,0,0-.317-.663.631.631,0,0,0-.657-.224c-.318.112-.413.507-.459.841l-.168-.222Z",
    transform: "translate(-369.416 -94.82)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M406.139,228.849l-.026-.344a.419.419,0,0,0-.5.154.346.346,0,0,0,.138.481.3.3,0,0,0,.4-.252Z",
    transform: "translate(-340.011 -179.778)",
    fill: "#cfb4ff",
    opacity: 0.5
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M410.105,214.828l-.024-.358a.766.766,0,0,0-.533.1c-.144.116-.138.4.042.445a.382.382,0,0,0,.2-.03c.21-.074.419-.146.629-.218Z",
    transform: "translate(-336.121 -193.83)",
    fill: "#cfb4ff",
    opacity: 0.5
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(172.696 15.457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.385,119.332a12.684,12.684,0,0,0-5.546-1.562,2.216,2.216,0,0,0-.925.1,1.809,1.809,0,0,0-.981,1.43,3.717,3.717,0,0,0,1.855,3.727,4.612,4.612,0,0,0,4.26.034,3.115,3.115,0,0,0,1.646-1.71,1.751,1.751,0,0,0-.765-2.095.378.378,0,0,0-.04.633Z",
    transform: "translate(-424.522 -114.25)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.846,118.15a2.354,2.354,0,0,0-1.821-1.372,2.48,2.48,0,0,0-.461,2.235,1.5,1.5,0,0,0,1.893.939,1.077,1.077,0,0,0,.078-1.871Z",
    transform: "translate(-433.978 -115.238)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.765,118.991a1.2,1.2,0,0,0-.276-1.029,1.249,1.249,0,0,0-.35.344.428.428,0,0,0,0,.467c.14.178.413.15.635.106l-.1.156Z",
    transform: "translate(-427.347 -114.05)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.58,119.092a.547.547,0,0,1,.3.146.932.932,0,0,1-.829.022c-.152-.048-.331-.134-.341-.294-.008-.11.074-.206.106-.312.066-.214-.038-.515.158-.623a.278.278,0,0,1,.333.1.819.819,0,0,1,.118.357l.134.815Z",
    transform: "translate(-426.709 -114.005)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.226,116.842c-.132-.192-.469,0-.473.228a.837.837,0,0,0,.351.575.813.813,0,0,0,.248-.867Z",
    transform: "translate(-435.688 -115.253)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.487,124.662a.848.848,0,0,0-.28-.186.285.285,0,0,0-.31.072c-.116.148.006.365-.03.547s-.226.332-.2.517a.317.317,0,0,0,.443.184.8.8,0,0,0,.353-.413.89.89,0,0,0,.124-.473.356.356,0,0,0-.306-.334Z",
    transform: "translate(-426.749 -107.535)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.064,120.879a.212.212,0,0,1-.112.27.389.389,0,0,1-.316-.018.375.375,0,0,1-.154-.112.275.275,0,0,1,.082-.385.3.3,0,0,1,.387.106.319.319,0,0,1-.084.4Z",
    transform: "translate(-437.01 -111.404)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.157,119.789a.324.324,0,0,0,.182-.525.577.577,0,0,0-.325.146.275.275,0,0,0-.046.33.183.183,0,0,0,.3,0Z",
    transform: "translate(-428.489 -112.745)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.995,119.322a.921.921,0,0,0,.054-.8l-.607.314a.609.609,0,0,0-.252.194.365.365,0,0,0,.206.507.512.512,0,0,0,.555-.2Z",
    transform: "translate(-426.268 -113.492)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.222,124.065a.417.417,0,0,1-.064.451.423.423,0,0,1-.439.118c-.1-.034-.2-.15-.15-.248a.249.249,0,0,1,.1-.088l.527-.306.038.1Z",
    transform: "translate(-420.844 -108.005)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.282,124.048c-.07.188.09.379.244.507s.331.286.306.485a.171.171,0,0,1-.082.136c-.124.066-.238-.1-.352-.18a1.365,1.365,0,0,0-.31-.126.674.674,0,0,1-.4-.643.369.369,0,0,1,.673.086Z",
    transform: "translate(-422.714 -107.95)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.129,124.339l-.21.094a.281.281,0,0,0,.206.282.234.234,0,0,0,.274-.194.2.2,0,0,0-.248-.2Z",
    transform: "translate(-423.487 -107.683)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.324,120.158l-.21.092a.279.279,0,0,0,.206.282.234.234,0,0,0,.274-.194.2.2,0,0,0-.248-.2Z",
    transform: "translate(-435.326 -111.877)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,119.2c-.026.148.172.244.318.2a4,4,0,0,0,.4-.2.549.549,0,0,1,.449.032.262.262,0,0,1,.152.21.322.322,0,0,1-.064.166,1.632,1.632,0,0,1-.625.621.762.762,0,0,1-.835-.078.585.585,0,0,1,.244-.991Z",
    transform: "translate(-427.802 -112.845)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.057,117.613a.363.363,0,0,0-.19-.467.524.524,0,0,0-.527.092c-.064.052-.122.14-.082.212a.2.2,0,0,0,.146.078l.677.15Z",
    transform: "translate(-427.172 -114.905)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.645,117.225a.614.614,0,0,1-.775.589,1.527,1.527,0,0,1,.238-.843.53.53,0,0,1,.771-.1l.006.519Z",
    transform: "translate(-431.559 -115.273)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.006,120.34a.158.158,0,0,1,.146.176.373.373,0,0,1-.128.22.431.431,0,0,1-.172.116.312.312,0,0,1-.352-.156.39.39,0,0,1,.036-.395.249.249,0,0,1,.162-.114.135.135,0,0,1,.154.1Z",
    transform: "translate(-416.927 -111.82)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.522,118.88l-.1-.22a.518.518,0,0,0-.312.186c-.062.106.006.286.13.27a.247.247,0,0,0,.12-.066l.348-.282Z",
    transform: "translate(-429.334 -113.351)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.721,118.994a1.465,1.465,0,0,0-.419-.413.5.5,0,0,0-.555.02.445.445,0,0,0-.138.254.547.547,0,1,0,1.084.136Z",
    transform: "translate(-431.828 -113.504)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.746,118.011l-.381-.13a.733.733,0,0,0-.108.286.379.379,0,0,0,.529-.056Z",
    transform: "translate(-432.174 -114.132)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.961,118.311a5.1,5.1,0,0,0-2.279.363.923.923,0,0,0-.318.192.729.729,0,0,0-.116.685,1.488,1.488,0,0,0,1.3,1.043,1.841,1.841,0,0,0,1.552-.7,1.238,1.238,0,0,0,.312-.9.7.7,0,0,0-.631-.633.153.153,0,0,0,.092.238Z",
    transform: "translate(-438.235 -113.714)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.544,122.24a1.205,1.205,0,0,0-.837-.659,1.233,1.233,0,0,0-.076.487.427.427,0,0,0,.282.373c.218.056.421-.128.571-.294l.01.186Z",
    transform: "translate(-425.786 -110.421)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.412,122.232a.471.471,0,0,0-.274-.132.489.489,0,0,0-.27.116,4.617,4.617,0,0,1-.717.395l1.308.385a.252.252,0,0,1,.1.044c.1.08.04.238.078.359.056.176.286.216.471.2C456.413,123.462,454.852,122.585,454.412,122.232Z",
    transform: "translate(-427.267 -109.901)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.887,124.224a.562.562,0,0,1,.3.146.921.921,0,0,1-.827.022c-.154-.048-.332-.134-.342-.292-.006-.112.076-.208.108-.314.066-.212-.038-.515.158-.621a.272.272,0,0,1,.33.1.8.8,0,0,1,.12.354l.134.817Z",
    transform: "translate(-424.395 -108.857)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.52,124.321a.207.207,0,0,1-.11.268.388.388,0,0,1-.316-.016.363.363,0,0,1-.154-.112.275.275,0,0,1,.082-.385.293.293,0,0,1,.384.106.313.313,0,0,1-.082.4Z",
    transform: "translate(-426.522 -107.952)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.784,123.838a.322.322,0,0,0-.168-.529.551.551,0,0,0-.17.31.272.272,0,0,0,.16.292.182.182,0,0,0,.238-.18Z",
    transform: "translate(-425.969 -108.688)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.686,121.913a.92.92,0,0,0-.439-.675l-.3.615a.6.6,0,0,0-.086.306.365.365,0,0,0,.469.282.514.514,0,0,0,.326-.491Z",
    transform: "translate(-424.546 -110.765)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.133,122.426l-.212.094a.285.285,0,0,0,.208.282.234.234,0,0,0,.274-.194.2.2,0,0,0-.25-.2Z",
    transform: "translate(-417.468 -109.602)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.079,123.18c.066.134.284.092.379-.026a4.47,4.47,0,0,0,.2-.4.553.553,0,0,1,.381-.244.263.263,0,0,1,.246.078.32.32,0,0,1,.048.172,1.634,1.634,0,0,1-.128.871.764.764,0,0,1-.715.437.584.584,0,0,1-.4-.939Z",
    transform: "translate(-425.445 -109.498)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.009,121.012a.364.364,0,0,0-.433-.26.524.524,0,0,0-.367.389c-.022.08-.014.186.062.22a.215.215,0,0,0,.162-.024l.633-.286Z",
    transform: "translate(-426.214 -111.261)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.926,125.385a.614.614,0,0,1-.775.589,1.549,1.549,0,0,1,.238-.843.53.53,0,0,1,.771-.1l.008.519Z",
    transform: "translate(-423.255 -107.09)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.745,123.512l-.21-.118a.5.5,0,0,0-.138.336c.012.122.174.224.264.138a.255.255,0,0,0,.058-.124l.108-.435Z",
    transform: "translate(-427.021 -108.687)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.971,119.708a1.441,1.441,0,0,0-.419-.413.5.5,0,0,0-.557.02.437.437,0,0,0-.136.252.547.547,0,1,0,1.083.136Z",
    transform: "translate(-425.561 -112.788)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.572,117.034c-.194.046-.262.286-.284.485s-.052.435-.23.525a.171.171,0,0,1-.158.008c-.124-.066-.054-.25-.048-.393a1.57,1.57,0,0,0-.066-.328.667.667,0,0,1,.31-.687.369.369,0,0,1,.3.607Z",
    transform: "translate(-429.65 -115.373)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.411,118.243c-.194.046-.262.284-.284.485s-.052.435-.23.525a.171.171,0,0,1-.158.008c-.124-.066-.054-.252-.048-.393a1.566,1.566,0,0,0-.066-.328.669.669,0,0,1,.31-.689.372.372,0,0,1,.3.609Z",
    transform: "translate(-431.817 -114.163)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.587,117.482a1.077,1.077,0,0,0-.471-.118.206.206,0,0,0-.078.012.154.154,0,0,0-.078.122.311.311,0,0,0,.166.308.391.391,0,0,0,.359-.008.263.263,0,0,0,.134-.148.149.149,0,0,0-.07-.174.032.032,0,0,0,0,.054Z",
    transform: "translate(-433.477 -114.65)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.184,120.493a1.208,1.208,0,0,0-.837-.661,1.237,1.237,0,0,0-.074.487.42.42,0,0,0,.28.373c.22.058.421-.126.573-.294l.01.186Z",
    transform: "translate(-422.135 -112.175)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.476,122.934a.467.467,0,0,0-.272-.132.5.5,0,0,0-.272.116,4.693,4.693,0,0,1-.715.395l1.308.385a.256.256,0,0,1,.1.044c.1.08.042.238.08.358.056.176.286.216.469.2C459.477,124.164,457.916,123.285,457.476,122.934Z",
    transform: "translate(-424.192 -109.197)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.931,125.272l-.377-.132a.635.635,0,0,0,.216.711c.226.14.6-.024.577-.288-.012-.164-.1-.417.064-.427Z",
    transform: "translate(-421.876 -106.856)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.391,122.205a.546.546,0,1,1-.028-.04Z",
    transform: "translate(-418.999 -110.028)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.358,122.535c.3.018.679.116.7.413s-.31.449-.585.529c-.118.034-.262.064-.352-.02-.218-.206.254-.591.084-.837.034-.08.184-.028.164.056Z",
    transform: "translate(-420.333 -109.465)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.529,122.477a.548.548,0,0,1,.3.146.932.932,0,0,1-.829.022c-.152-.048-.33-.134-.34-.294-.008-.11.074-.206.106-.312.066-.214-.038-.515.158-.623a.277.277,0,0,1,.332.1.817.817,0,0,1,.118.357l.134.815Z",
    transform: "translate(-420.744 -110.611)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.933,124.114c-.132-.192-.469,0-.473.228a.847.847,0,0,0,.352.575.811.811,0,0,0,.246-.867Z",
    transform: "translate(-420.939 -107.961)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.426,122.091a.325.325,0,0,0-.17-.531.576.576,0,0,0-.17.312.274.274,0,0,0,.162.292.183.183,0,0,0,.238-.182Z",
    transform: "translate(-422.319 -110.442)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.981,120.226a.322.322,0,0,0-.168-.529.558.558,0,0,0-.17.31.272.272,0,0,0,.16.292c.114.04.262-.062.238-.18Z",
    transform: "translate(-424.769 -112.311)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.284,126.124a.92.92,0,0,0-.439-.675c-.1.2-.2.411-.3.615a.6.6,0,0,0-.086.306.365.365,0,0,0,.469.282.517.517,0,0,0,.326-.491Z",
    transform: "translate(-423.946 -106.542)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.658,122.731a.707.707,0,0,0-.308-.731.845.845,0,0,0-.306.507.565.565,0,0,0,.328.653c.258.076.555-.246.4-.465Z",
    transform: "translate(-421.368 -110.001)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.122,123.814a.42.42,0,0,1-.05.521l-.587-.224a.484.484,0,0,1,.593-.457Z",
    transform: "translate(-420.914 -108.359)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.6,124.039a.426.426,0,0,1-.064.451.418.418,0,0,1-.439.116c-.1-.034-.2-.15-.15-.246a.236.236,0,0,1,.1-.09l.529-.3.038.1Z",
    transform: "translate(-422.475 -108.031)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.655,124.023c-.068.186.092.377.244.5s.333.286.308.487a.175.175,0,0,1-.082.134c-.124.066-.238-.1-.352-.178a1.468,1.468,0,0,0-.31-.128.673.673,0,0,1-.4-.641.371.371,0,0,1,.675.086Z",
    transform: "translate(-424.345 -107.976)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.5,124.313l-.212.092a.283.283,0,0,0,.208.282.233.233,0,0,0,.274-.192.2.2,0,0,0-.25-.2Z",
    transform: "translate(-425.119 -107.71)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.718,121.432c.068.134.284.092.379-.026s.118-.278.2-.4a.539.539,0,0,1,.379-.244.261.261,0,0,1,.246.076.326.326,0,0,1,.048.174,1.63,1.63,0,0,1-.128.869.763.763,0,0,1-.715.439.584.584,0,0,1-.4-.939Z",
    transform: "translate(-421.794 -111.251)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.658,118.021c.066.134.284.092.379-.026a4.455,4.455,0,0,0,.2-.4.553.553,0,0,1,.38-.244.258.258,0,0,1,.246.078.337.337,0,0,1,.048.172,1.624,1.624,0,0,1-.128.869.762.762,0,0,1-.715.439.585.585,0,0,1-.4-.939Z",
    transform: "translate(-429.878 -114.672)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.893,117.073c.068.136.286.094.378-.024a4.212,4.212,0,0,0,.2-.4.536.536,0,0,1,.379-.244.26.26,0,0,1,.246.076.3.3,0,0,1,.048.172,1.614,1.614,0,0,1-.126.871.766.766,0,0,1-.717.439.585.585,0,0,1-.4-.939Z",
    transform: "translate(-429.641 -115.621)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.244,117.731c.068.136.286.094.379-.024a4.213,4.213,0,0,0,.2-.4.537.537,0,0,1,.379-.244.266.266,0,0,1,.248.076.337.337,0,0,1,.048.172,1.634,1.634,0,0,1-.128.871.761.761,0,0,1-.717.437.583.583,0,0,1-.4-.937Z",
    transform: "translate(-428.286 -114.961)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.207,122.065c.068.134.284.092.379-.026a4.47,4.47,0,0,0,.2-.4.544.544,0,0,1,.381-.242.262.262,0,0,1,.246.076.32.32,0,0,1,.048.172,1.634,1.634,0,0,1-.128.871.76.76,0,0,1-.715.437.594.594,0,0,1-.475-.352.586.586,0,0,1,.076-.585Z",
    transform: "translate(-438.353 -110.615)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.607,125.223a.367.367,0,0,0-.433-.26.527.527,0,0,0-.366.389c-.022.08-.014.186.06.22a.219.219,0,0,0,.164-.024l.633-.286Z",
    transform: "translate(-425.615 -107.038)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.567,123.638a.614.614,0,0,1-.775.589,1.538,1.538,0,0,1,.236-.843.532.532,0,0,1,.773-.1l.006.519Z",
    transform: "translate(-419.603 -108.843)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.917,125.408c.086-.006.152.09.146.176a.373.373,0,0,1-.128.22.424.424,0,0,1-.174.116.307.307,0,0,1-.351-.156.39.39,0,0,1,.036-.395.249.249,0,0,1,.162-.114.135.135,0,0,1,.154.1Z",
    transform: "translate(-424.036 -106.738)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.385,121.763l-.21-.118a.517.517,0,0,0-.138.336c.014.124.176.226.266.14a.251.251,0,0,0,.056-.126l.11-.435Z",
    transform: "translate(-423.371 -110.441)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.895,122.643a1.466,1.466,0,0,0-.419-.413.5.5,0,0,0-.557.02.442.442,0,0,0-.136.254.547.547,0,1,0,1.084.136Z",
    transform: "translate(-431.654 -109.845)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.856,118.663a.4.4,0,0,1,.166.661,1.1,1.1,0,0,1-.463-.062.7.7,0,0,1,.218-.457Z",
    transform: "translate(-423.847 -113.348)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.571,122.327a.818.818,0,0,0-.28-.186.282.282,0,0,0-.31.072c-.114.146.006.363-.03.547s-.226.33-.2.517a.316.316,0,0,0,.443.184.8.8,0,0,0,.352-.413.892.892,0,0,0,.124-.475.358.358,0,0,0-.306-.334Z",
    transform: "translate(-435.69 -109.877)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.761,119.62a2.348,2.348,0,0,0-.637-2.187,2.469,2.469,0,0,0-1.706,1.512,1.5,1.5,0,0,0,.953,1.887c.773.17,1.592-.775,1.182-1.452Z",
    transform: "translate(-429.07 -114.581)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.248,118.037a.211.211,0,0,1-.252.15.4.4,0,0,1-.242-.2.374.374,0,0,1-.056-.182.274.274,0,0,1,.3-.258.3.3,0,0,1,.244.316.317.317,0,0,1-.3.268Z",
    transform: "translate(-423.71 -114.472)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.2,118.288c-.168.108-.154.357-.108.553s.094.427-.044.571a.169.169,0,0,1-.146.06c-.14-.022-.134-.218-.176-.354a1.425,1.425,0,0,0-.172-.288.674.674,0,0,1,.066-.751.37.37,0,0,1,.489.473Z",
    transform: "translate(-425.948 -113.962)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.271,119.883l-.224-.052a.28.28,0,0,0,0,.35.234.234,0,0,0,.336.01.2.2,0,0,0-.08-.31Z",
    transform: "translate(-428.437 -112.176)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.585,119.555a.158.158,0,0,1,.01.228.378.378,0,0,1-.234.1.43.43,0,0,1-.208-.01.308.308,0,0,1-.186-.336.391.391,0,0,1,.264-.294.252.252,0,0,1,.2,0,.141.141,0,0,1,.066.172Z",
    transform: "translate(-426.453 -112.785)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.5,121.687a2.358,2.358,0,0,0-1.821-1.372,2.48,2.48,0,0,0-.461,2.235,1.5,1.5,0,0,0,1.893.939,1.077,1.077,0,0,0,.078-1.871Z",
    transform: "translate(-439.337 -111.691)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.182,121.16c-.132-.19-.469,0-.473.23a.846.846,0,0,0,.352.575.812.812,0,0,0,.246-.867Z",
    transform: "translate(-423.698 -110.922)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.624,124.989c.068.134.284.092.379-.026a4.481,4.481,0,0,0,.2-.4.536.536,0,0,1,.379-.242.26.26,0,0,1,.246.076.319.319,0,0,1,.048.172,1.634,1.634,0,0,1-.128.871.758.758,0,0,1-.715.437.585.585,0,0,1-.4-.939Z",
    transform: "translate(-424.896 -107.682)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.06,117.064l-.226-.052a.28.28,0,0,0,0,.35.232.232,0,0,0,.334.01.2.2,0,0,0-.078-.31Z",
    transform: "translate(-424.639 -115.003)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.736,119.357a5.492,5.492,0,0,0-2.385-.749,1,1,0,0,0-.4.032.783.783,0,0,0-.445.609,1.612,1.612,0,0,0,.757,1.64,2,2,0,0,0,1.847.068,1.351,1.351,0,0,0,.735-.721.759.759,0,0,0-.3-.919.165.165,0,0,0-.026.274Z",
    transform: "translate(-426.938 -113.408)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.454,120.543a2.354,2.354,0,0,0-1.821-1.37,2.479,2.479,0,0,0-.463,2.235,1.5,1.5,0,0,0,1.895.937,1.077,1.077,0,0,0,.078-1.871Z",
    transform: "translate(-430.361 -112.836)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.157,118.479a1.207,1.207,0,0,0-.839-.661,1.275,1.275,0,0,0-.074.487.427.427,0,0,0,.282.373c.218.058.421-.126.571-.294l.01.186Z",
    transform: "translate(-433.194 -114.195)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.025,118.471a.487.487,0,0,0-.274-.134.5.5,0,0,0-.27.116,4.458,4.458,0,0,1-.717.395l1.308.385a.294.294,0,0,1,.1.044c.1.08.042.24.08.361.056.176.286.214.471.2C449.026,119.7,447.465,118.822,447.025,118.471Z",
    transform: "translate(-434.675 -113.674)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.639,118.014l-.377-.132a.639.639,0,0,0,.216.711c.228.14.6-.024.579-.29-.014-.164-.1-.415.064-.427Z",
    transform: "translate(-426.179 -114.137)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.5,120.463a.535.535,0,0,1,.3.146.928.928,0,0,1-.827.022c-.154-.048-.333-.134-.342-.294-.006-.11.076-.206.108-.312.066-.214-.038-.517.158-.623a.274.274,0,0,1,.33.1.819.819,0,0,1,.12.357l.134.815Z",
    transform: "translate(-431.803 -112.63)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.9,122.1c-.13-.192-.467,0-.471.228a.837.837,0,0,0,.35.575.808.808,0,0,0,.246-.867Z",
    transform: "translate(-431.997 -109.981)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.134,120.558a.209.209,0,0,1-.11.27.394.394,0,0,1-.318-.018.352.352,0,0,1-.152-.112.274.274,0,0,1,.082-.385.3.3,0,0,1,.385.106.319.319,0,0,1-.082.4Z",
    transform: "translate(-433.93 -111.726)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.4,120.077a.325.325,0,0,0-.168-.531.563.563,0,0,0-.17.312.272.272,0,0,0,.16.292.184.184,0,0,0,.238-.182Z",
    transform: "translate(-433.377 -112.462)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.3,118.15a.924.924,0,0,0-.439-.675l-.3.617a.6.6,0,0,0-.086.3.365.365,0,0,0,.469.284.519.519,0,0,0,.326-.491Z",
    transform: "translate(-431.954 -114.539)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.568,122.024a.412.412,0,0,1-.5.569c-.1-.034-.2-.15-.15-.246a.254.254,0,0,1,.1-.09l.527-.306.038.1Z",
    transform: "translate(-433.534 -110.051)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.641,123.417c-.194.046-.262.284-.284.485s-.052.435-.232.525a.172.172,0,0,1-.156.008c-.124-.068-.054-.252-.048-.393a1.468,1.468,0,0,0-.068-.33.672.672,0,0,1,.313-.687.379.379,0,0,1,.351.2.374.374,0,0,1-.048.4Z",
    transform: "translate(-434.596 -108.975)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.639,122.638l-.194-.124a.278.278,0,0,0-.118.328.234.234,0,0,0,.312.122.2.2,0,0,0,.028-.32Z",
    transform: "translate(-435.13 -109.486)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.692,119.418c.066.134.284.092.379-.026s.118-.278.2-.4a.546.546,0,0,1,.381-.244.262.262,0,0,1,.246.076.337.337,0,0,1,.048.172,1.633,1.633,0,0,1-.128.871.765.765,0,0,1-.715.439.6.6,0,0,1-.477-.352.6.6,0,0,1,.078-.587Z",
    transform: "translate(-432.853 -113.271)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.623,117.249a.364.364,0,0,0-.433-.258.52.52,0,0,0-.367.389c-.022.08-.014.186.06.218a.2.2,0,0,0,.164-.024c.21-.094.421-.19.633-.284Z",
    transform: "translate(-433.622 -115.034)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.539,121.624a.614.614,0,0,1-.775.589,1.539,1.539,0,0,1,.238-.843.53.53,0,0,1,.771-.1l.008.519Z",
    transform: "translate(-430.662 -110.863)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.358,119.749l-.21-.118a.5.5,0,0,0-.138.336c.012.124.174.226.264.14a.253.253,0,0,0,.058-.126l.108-.435Z",
    transform: "translate(-434.429 -112.461)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.343,119.831a1.467,1.467,0,0,0-.419-.413.5.5,0,0,0-.555.02.445.445,0,0,0-.138.254.547.547,0,1,0,1.084.136Z",
    transform: "translate(-424.185 -112.663)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.426,123.269l-.381-.13a.734.734,0,0,0-.108.286.381.381,0,0,0,.529-.056Z",
    transform: "translate(-428.483 -108.859)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.108,121.11a.212.212,0,0,1-.112.27.389.389,0,0,1-.316-.018.37.37,0,0,1-.154-.11.275.275,0,0,1,.082-.385.3.3,0,0,1,.387.106.317.317,0,0,1-.084.4Z",
    transform: "translate(-418.915 -111.17)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.491,121.9l-.381-.132a.714.714,0,0,0-.108.286.377.377,0,0,0,.527-.056Z",
    transform: "translate(-429.421 -110.234)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.565,119.375c-.026-.148-.246-.172-.371-.086s-.194.228-.308.326a.537.537,0,0,1-.435.122.26.26,0,0,1-.214-.146.319.319,0,0,1,.006-.178,1.609,1.609,0,0,1,.379-.8.757.757,0,0,1,.811-.206.584.584,0,0,1,.106,1.013Z",
    transform: "translate(-440.227 -113.647)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.958,120.464a.85.85,0,0,0,.214.26.286.286,0,0,0,.318.024c.152-.108.1-.35.188-.517s.314-.248.34-.435-.186-.33-.369-.306a.8.8,0,0,0-.459.29.883.883,0,0,0-.256.417.355.355,0,0,0,.192.411Z",
    transform: "translate(-425.484 -112.52)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,119.5a4.5,4.5,0,0,0,2.035-.006.816.816,0,0,0,.3-.124.645.645,0,0,0,.2-.581,1.318,1.318,0,0,0-.991-1.088,1.631,1.631,0,0,0-1.452.4,1.1,1.1,0,0,0-.393.739.621.621,0,0,0,.463.639.135.135,0,0,0-.048-.22Z",
    transform: "translate(-429.729 -114.351)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.614,116.914a.471.471,0,0,0-.02-.3.5.5,0,0,0-.234-.178,4.42,4.42,0,0,1-.7-.425l.316,1.326a.285.285,0,0,1,.01.108c-.02.124-.186.154-.27.246-.126.136-.046.356.062.507C452.544,119.262,452.53,117.471,452.614,116.914Z",
    transform: "translate(-428.768 -116.009)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.006,118.565l-.186-.138a.279.279,0,0,0-.14.32.233.233,0,0,0,.3.142.2.2,0,0,0,.05-.316Z",
    transform: "translate(-429.756 -113.584)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.407,116.991a.362.362,0,0,0,.01-.5.522.522,0,0,0-.519-.126c-.08.022-.168.08-.16.162a.205.205,0,0,0,.1.13l.561.407Z",
    transform: "translate(-429.686 -115.676)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.884,118.356a1.211,1.211,0,0,0,.154-1.055,1.233,1.233,0,0,0-.459.178.425.425,0,0,0-.184.429c.06.218.32.3.541.35l-.156.1Z",
    transform: "translate(-430.04 -114.713)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.212,118.908a.557.557,0,0,1,.02.328.928.928,0,0,1-.433-.707c-.034-.156-.048-.354.086-.443.092-.06.216-.038.325-.062.218-.048.429-.29.619-.172a.274.274,0,0,1,.076.338.8.8,0,0,1-.25.28l-.641.521Z",
    transform: "translate(-430.65 -114.193)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.11,117.521a.923.923,0,0,0,.369-.717l-.683.048a.63.63,0,0,0-.308.078.368.368,0,0,0-.012.549.519.519,0,0,0,.589.038Z",
    transform: "translate(-429.063 -115.212)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.319,116.717c-.082.126.062.294.21.316a4.252,4.252,0,0,0,.451-.028.541.541,0,0,1,.4.208.259.259,0,0,1,.056.25.323.323,0,0,1-.126.128,1.645,1.645,0,0,1-.819.322.763.763,0,0,1-.735-.4.584.584,0,0,1,.617-.813Z",
    transform: "translate(-430.717 -115.323)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.465,121.015a1.428,1.428,0,0,0,.148-.569.5.5,0,0,0-.292-.471.445.445,0,0,0-.288.006.547.547,0,1,0,.421,1.007Z",
    transform: "translate(-427.746 -112.053)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.428,119.114a1.205,1.205,0,0,0,.156-1.055,1.255,1.255,0,0,0-.461.178.422.422,0,0,0-.182.429c.06.218.318.3.541.348l-.158.1Z",
    transform: "translate(-426.484 -113.953)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.061,118.665c-.2.032-.282.266-.318.465s-.084.431-.268.507a.176.176,0,0,1-.158,0c-.118-.076-.034-.254-.02-.395a1.6,1.6,0,0,0-.042-.334.673.673,0,0,1,.358-.665.371.371,0,0,1,.26.629Z",
    transform: "translate(-431.178 -113.772)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.462,122.3h-.232a.285.285,0,0,0,.078.342.235.235,0,0,0,.328-.068.2.2,0,0,0-.148-.284Z",
    transform: "translate(-424.206 -109.708)",
    fill: "#5990ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.345,118.143l0-.24a.5.5,0,0,0-.36.048c-.1.072-.11.264.01.3a.254.254,0,0,0,.138-.012l.431-.122Z",
    transform: "translate(-428.517 -114.121)",
    fill: "#5990ff",
    opacity: 0.5
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.221 259.851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.635,260.626a15.758,15.758,0,0,0-2.746-6.607,2.759,2.759,0,0,0-.809-.823,2.247,2.247,0,0,0-2.149.142,4.622,4.622,0,0,0-2.207,4.677,5.73,5.73,0,0,0,3.249,4.176,3.861,3.861,0,0,0,2.932.29,2.175,2.175,0,0,0,1.452-2.359.47.47,0,0,0-.647.451Z",
    transform: "translate(-430.258 -223.048)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.93,245.706a2.926,2.926,0,0,0-.066-2.83,3.078,3.078,0,0,0-2.532,1.27,1.857,1.857,0,0,0,.543,2.568c.873.451,2.157-.421,1.883-1.364Z",
    transform: "translate(-435.904 -233.179)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.075,251.262a1.489,1.489,0,0,0,.791-1.061,1.531,1.531,0,0,0-.607-.076.53.53,0,0,0-.453.361c-.064.274.172.517.385.7l-.23.02Z",
    transform: "translate(-431.139 -225.919)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.746,252.167a.68.68,0,0,1,.084.4c-.344-.09-.533-.455-.659-.789-.07-.186-.124-.427.024-.559.1-.092.258-.086.389-.136.258-.1.473-.435.727-.324a.34.34,0,0,1,.156.4,1,1,0,0,1-.256.391q-.345.378-.691.759Z",
    transform: "translate(-430.833 -225.296)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.52,241.362c.084-.274-.358-.457-.587-.282a1.048,1.048,0,0,0-.29.785,1.008,1.008,0,0,0,1.035-.429Z",
    transform: "translate(-436.306 -235.05)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.329,256.345a1.079,1.079,0,0,0-.034-.417.36.36,0,0,0-.31-.248c-.232,0-.351.286-.555.395s-.5.032-.655.2a.392.392,0,0,0,.16.573,1.011,1.011,0,0,0,.675.026,1.109,1.109,0,0,0,.555-.244.443.443,0,0,0,.092-.555Z",
    transform: "translate(-437.251 -220.339)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.587,243.357a.262.262,0,0,1-.349.1.483.483,0,0,1-.226-.322.465.465,0,0,1-.01-.234.341.341,0,0,1,.439-.216.364.364,0,0,1,.192.457.39.39,0,0,1-.451.224Z",
    transform: "translate(-440.971 -233.394)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.908,250.373a.4.4,0,0,0,.653-.228.7.7,0,0,0-.393-.2.34.34,0,0,0-.358.21.227.227,0,0,0,.234.288Z",
    transform: "translate(-433.139 -226.092)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.737,252.66a1.138,1.138,0,0,0,.823-.567l-.773-.348a.771.771,0,0,0-.383-.1.455.455,0,0,0-.336.593.638.638,0,0,0,.621.387Z",
    transform: "translate(-430.89 -224.384)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.986,261.463a.526.526,0,0,1-.489.284.517.517,0,0,1-.453-.336c-.048-.13-.01-.312.124-.338a.328.328,0,0,1,.168.032l.7.278-.066.114Z",
    transform: "translate(-431.912 -214.934)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.51,259.649c-.236.076-.3.379-.3.627s-.024.545-.236.673a.223.223,0,0,1-.2.026c-.16-.072-.09-.306-.1-.483a1.933,1.933,0,0,0-.114-.4.834.834,0,0,1,.318-.881.459.459,0,0,1,.435.723Z",
    transform: "translate(-433.406 -216.803)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.211,258.771l-.252-.134a.346.346,0,0,0-.116.419.288.288,0,0,0,.4.118.247.247,0,0,0,0-.4Z",
    transform: "translate(-434.131 -217.374)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.2,244.051l-.254-.136a.349.349,0,0,0-.114.419.289.289,0,0,0,.4.12.247.247,0,0,0,0-.4Z",
    transform: "translate(-439.154 -232.137)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.323,250.706c-.166.088-.106.357.044.469a5.6,5.6,0,0,0,.509.234.671.671,0,0,1,.315.463.321.321,0,0,1-.086.308.4.4,0,0,1-.214.066,2.013,2.013,0,0,1-1.084-.13.948.948,0,0,1-.567-.875.726.726,0,0,1,1.154-.525Z",
    transform: "translate(-432.702 -225.457)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.435,250.556a.451.451,0,0,0,.308-.545.653.653,0,0,0-.495-.443c-.1-.022-.23-.012-.27.084a.255.255,0,0,0,.036.2l.375.775Z",
    transform: "translate(-429.964 -226.477)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.774,245.846a.761.761,0,0,1-1.17-.3,1.907,1.907,0,0,1,1-.417c.369,0,.759.312.693.673l-.5.407Z",
    transform: "translate(-433.337 -230.922)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.519,262.361a.2.2,0,0,1-.062.276.452.452,0,0,1-.312.046.536.536,0,0,1-.246-.08.386.386,0,0,1-.118-.463.489.489,0,0,1,.413-.268.319.319,0,0,1,.236.068.173.173,0,0,1,.024.228Z",
    transform: "translate(-425.17 -214.13)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.268,249.07l.14-.264a.622.622,0,0,0-.421-.16c-.154.02-.276.224-.166.332a.305.305,0,0,0,.158.068l.543.12Z",
    transform: "translate(-433.162 -227.397)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.93,247.383a1.8,1.8,0,0,0,.08-.725.618.618,0,0,0-.447-.527.54.54,0,0,0-.352.062.679.679,0,1,0,.7,1.16Z",
    transform: "translate(-435.088 -229.923)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.934,245.726l-.166-.471a.885.885,0,0,0-.362.114.469.469,0,0,0,.461.471Z",
    transform: "translate(-434.54 -230.794)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.35,242.028a6.282,6.282,0,0,0-2.107-1.939,1.119,1.119,0,0,0-.433-.164.907.907,0,0,0-.757.413,1.853,1.853,0,0,0-.016,2.071,2.292,2.292,0,0,0,1.881.971,1.543,1.543,0,0,0,1.114-.387.87.87,0,0,0,.132-1.1.188.188,0,0,0-.158.272Z",
    transform: "translate(-440.231 -236.141)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.23,255.62a1.5,1.5,0,0,0,0-1.326,1.584,1.584,0,0,0-.531.3.53.53,0,0,0-.146.563c.112.256.447.31.727.328l-.174.154Z",
    transform: "translate(-433.425 -221.729)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.288,254.35a.579.579,0,0,0-.08-.368.631.631,0,0,0-.322-.176,5.626,5.626,0,0,1-.935-.393c.21.523.421,1.048.633,1.57a.329.329,0,0,1,.032.13c0,.156-.2.224-.288.354-.128.188.01.445.168.609C453.63,257.246,453.286,255.049,453.288,254.35Z",
    transform: "translate(-434.996 -222.613)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.518,258.367a.668.668,0,0,1,.086.4c-.345-.09-.533-.457-.659-.789-.072-.186-.124-.427.024-.559.1-.092.258-.086.387-.136.26-.1.473-.435.729-.326a.34.34,0,0,1,.154.4.979.979,0,0,1-.254.391l-.693.757Z",
    transform: "translate(-434.069 -219.08)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.282,256.2a.263.263,0,0,1-.349.1.484.484,0,0,1-.228-.322.465.465,0,0,1-.008-.234.339.339,0,0,1,.437-.216.363.363,0,0,1,.194.457.394.394,0,0,1-.453.224Z",
    transform: "translate(-436.264 -220.519)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452,256.066a.4.4,0,0,0,.387-.573.706.706,0,0,0-.435.074.341.341,0,0,0-.16.383.228.228,0,0,0,.361.092Z",
    transform: "translate(-435.169 -220.531)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.608,256.33a1.143,1.143,0,0,0,.32-.947l-.827.186a.749.749,0,0,0-.365.15.456.456,0,0,0,.084.677.64.64,0,0,0,.729-.062Z",
    transform: "translate(-432.317 -220.637)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.7,263.148l-.254-.134a.349.349,0,0,0-.116.419.291.291,0,0,0,.4.12.25.25,0,0,0,0-.4Z",
    transform: "translate(-427.63 -212.985)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.246,255.628c-.078.168.13.349.316.349s.362-.1.549-.116a.677.677,0,0,1,.529.18.33.33,0,0,1,.116.3.415.415,0,0,1-.132.18,2.023,2.023,0,0,1-.947.545.945.945,0,0,1-.975-.361.725.725,0,0,1,.607-1.112Z",
    transform: "translate(-434.353 -220.426)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.964,254.063a.452.452,0,0,0-.078-.621.655.655,0,0,0-.663-.058c-.094.042-.192.13-.166.228.018.07.088.108.15.142l.763.4Z",
    transform: "translate(-432.887 -222.704)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.195,260.195a.761.761,0,0,1-1.17-.3,1.907,1.907,0,0,1,1-.417c.367,0,.759.312.691.675l-.5.4Z",
    transform: "translate(-434.921 -216.533)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.518,254.782l-.046-.3a.638.638,0,0,0-.435.124c-.11.108-.084.344.068.367a.306.306,0,0,0,.166-.04l.507-.228Z",
    transform: "translate(-435.978 -221.537)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.042,254.021a1.8,1.8,0,0,0,.08-.725.621.621,0,0,0-.447-.527.542.542,0,0,0-.352.062.679.679,0,1,0,.7,1.16Z",
    transform: "translate(-430.963 -223.266)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.562,247.65c-.2-.154-.481-.036-.691.1s-.465.284-.691.178a.213.213,0,0,1-.128-.146c-.032-.174.2-.246.344-.35a1.8,1.8,0,0,0,.27-.318.835.835,0,0,1,.909-.226.46.46,0,0,1-.359.765Z",
    transform: "translate(-431.888 -229.213)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.721,246.474c-.194-.154-.481-.038-.691.1s-.465.282-.691.178a.225.225,0,0,1-.128-.148c-.03-.172.2-.246.346-.348a1.794,1.794,0,0,0,.268-.318.835.835,0,0,1,.909-.226.459.459,0,0,1-.359.763Z",
    transform: "translate(-434.736 -230.392)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.572,244.2a1.339,1.339,0,0,0-.248-.549.275.275,0,0,0-.07-.066.188.188,0,0,0-.18.018.386.386,0,0,0-.172.4.479.479,0,0,0,.282.342.325.325,0,0,0,.248.016.183.183,0,0,0,.116-.2.041.041,0,0,0-.054.04Z",
    transform: "translate(-435.051 -232.479)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.735,257.822a1.5,1.5,0,0,0,0-1.326,1.586,1.586,0,0,0-.531.3.528.528,0,0,0-.146.561c.112.258.447.312.727.33l-.174.154Z",
    transform: "translate(-428.907 -219.521)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.963,257.877a.594.594,0,0,0-.08-.369.628.628,0,0,0-.322-.174,5.809,5.809,0,0,1-.935-.395q.315.784.633,1.572a.356.356,0,0,1,.032.128c0,.156-.2.224-.288.354-.128.19.01.445.168.609C455.305,260.773,454.961,258.578,454.963,257.877Z",
    transform: "translate(-433.316 -219.076)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.813,261.275l-.162-.469a.793.793,0,0,0-.527.759c.038.328.487.565.727.341.15-.14.33-.419.467-.266Z",
    transform: "translate(-433.822 -215.199)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.58,262.176a.674.674,0,1,1,.018-.058Z",
    transform: "translate(-428.634 -214.726)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.748,260.475c.21.3.411.751.138,1s-.675.04-.963-.164c-.126-.09-.264-.206-.252-.359.032-.371.771-.208.879-.565.1-.026.17.16.072.2Z",
    transform: "translate(-430.263 -215.617)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.023,260.569a.666.666,0,0,1,.086.4c-.344-.09-.533-.457-.659-.789-.072-.186-.124-.427.024-.559.1-.092.258-.086.387-.136.26-.1.473-.435.729-.326a.34.34,0,0,1,.154.4.979.979,0,0,1-.254.391l-.693.759Z",
    transform: "translate(-429.551 -216.872)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.339,267.841a.666.666,0,0,1,.086.4c-.344-.09-.533-.457-.659-.789-.07-.186-.124-.427.024-.559.1-.092.258-.086.389-.136.258-.1.471-.435.727-.324a.336.336,0,0,1,.154.4.979.979,0,0,1-.254.391l-.691.757Z",
    transform: "translate(-420.208 -209.578)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.75,261.291c.084-.276-.359-.459-.587-.284a1.042,1.042,0,0,0-.288.785,1.01,1.01,0,0,0,1.035-.427Z",
    transform: "translate(-432.063 -215.067)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.506,258.268a.4.4,0,0,0,.387-.573.706.706,0,0,0-.435.074.342.342,0,0,0-.16.383.228.228,0,0,0,.361.092Z",
    transform: "translate(-430.651 -218.323)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.442,254.453a.4.4,0,0,0,.387-.573.706.706,0,0,0-.435.074.342.342,0,0,0-.16.383.228.228,0,0,0,.361.092Z",
    transform: "translate(-430.715 -222.149)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.965,260.155a1.149,1.149,0,0,0,.32-.949l-.829.186a.741.741,0,0,0-.365.152.455.455,0,0,0,.086.675.64.64,0,0,0,.729-.062Z",
    transform: "translate(-435.971 -216.803)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.046,259.9a.875.875,0,0,0,.473-.863,1.048,1.048,0,0,0-.729.092.7.7,0,0,0-.383.823c.124.308.667.35.759.03Z",
    transform: "translate(-430.563 -216.998)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.122,261.208a.521.521,0,0,1-.547.351c-.076-.246-.154-.495-.23-.743a.6.6,0,0,1,.9.224Z",
    transform: "translate(-431.591 -215.31)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.76,259.858a.513.513,0,0,1-.941-.052c-.046-.13-.008-.312.126-.339a.325.325,0,0,1,.166.032c.234.094.469.186.705.278l-.068.114Z",
    transform: "translate(-433.141 -216.544)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.284,258.044c-.236.076-.3.379-.3.627s-.024.545-.236.673a.218.218,0,0,1-.194.026c-.16-.072-.09-.306-.1-.483a1.823,1.823,0,0,0-.116-.4.834.834,0,0,1,.318-.881.46.46,0,0,1,.437.723Z",
    transform: "translate(-434.635 -218.413)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.986,257.166l-.254-.134a.348.348,0,0,0-.116.419.29.29,0,0,0,.4.118.248.248,0,0,0,0-.4Z",
    transform: "translate(-435.36 -218.983)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.751,257.83c-.078.168.13.349.316.349s.362-.1.549-.116a.677.677,0,0,1,.529.18.33.33,0,0,1,.116.3.414.414,0,0,1-.132.18,2.023,2.023,0,0,1-.947.545.945.945,0,0,1-.975-.361.725.725,0,0,1,.607-1.112Z",
    transform: "translate(-429.835 -218.217)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.872,247.35c-.08.168.128.349.316.349s.36-.1.547-.116a.674.674,0,0,1,.529.18.325.325,0,0,1,.116.3.414.414,0,0,1-.132.18,2.026,2.026,0,0,1-.945.545.947.947,0,0,1-.977-.36.725.725,0,0,1,.609-1.112Z",
    transform: "translate(-432.723 -228.727)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.976,246.852c-.08.17.128.348.316.348a5.33,5.33,0,0,0,.547-.116.675.675,0,0,1,.531.182.321.321,0,0,1,.114.3.4.4,0,0,1-.13.18,2.015,2.015,0,0,1-.947.545.947.947,0,0,1-.977-.36.726.726,0,0,1,.609-1.112Z",
    transform: "translate(-431.615 -229.226)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.375,248.675c-.08.17.128.348.314.348s.363-.1.549-.116a.671.671,0,0,1,.529.182.32.32,0,0,1,.116.3.415.415,0,0,1-.132.18,2.011,2.011,0,0,1-.945.545.947.947,0,0,1-.977-.361.725.725,0,0,1,.607-1.112Z",
    transform: "translate(-431.216 -227.398)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.427,242.228c-.08.168.128.348.316.348a5.335,5.335,0,0,0,.547-.118.683.683,0,0,1,.529.182.325.325,0,0,1,.116.3.4.4,0,0,1-.132.178,2.014,2.014,0,0,1-.945.547.947.947,0,0,1-.977-.361.725.725,0,0,1,.609-1.112Z",
    transform: "translate(-443.197 -233.863)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.321,257.886a.45.45,0,0,0-.08-.619.647.647,0,0,0-.661-.06c-.094.042-.192.13-.166.228.018.07.086.108.148.142l.765.4Z",
    transform: "translate(-436.54 -218.87)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.7,262.4a.761.761,0,0,1-1.17-.3,1.907,1.907,0,0,1,1-.417c.367,0,.759.312.691.673l-.5.407Z",
    transform: "translate(-430.403 -214.324)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.125,259.353a.2.2,0,0,1-.062.276.451.451,0,0,1-.312.046.536.536,0,0,1-.246-.08.383.383,0,0,1-.116-.463.479.479,0,0,1,.411-.268.318.318,0,0,1,.236.068.173.173,0,0,1,.024.228Z",
    transform: "translate(-435.593 -217.147)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.023,256.984l-.046-.3a.638.638,0,0,0-.435.124c-.11.108-.084.346.068.367a.306.306,0,0,0,.166-.04l.507-.228Z",
    transform: "translate(-431.46 -219.328)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.506,250.359a1.8,1.8,0,0,0,.08-.727.618.618,0,0,0-.447-.525.542.542,0,0,0-.352.062.679.679,0,1,0,.7,1.16Z",
    transform: "translate(-438.52 -226.939)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.691,254.039a.5.5,0,0,1-.517.669,1.375,1.375,0,0,1-.294-.5.874.874,0,0,1,.613-.14Z",
    transform: "translate(-429.049 -221.985)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.742,245.86a1,1,0,0,0-.034-.417.355.355,0,0,0-.308-.248c-.232,0-.35.286-.557.393s-.5.034-.655.206a.394.394,0,0,0,.162.573,1.01,1.01,0,0,0,.675.026,1.126,1.126,0,0,0,.555-.244.44.44,0,0,0,.09-.555Z",
    transform: "translate(-441.849 -230.854)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.421,251.367a2.926,2.926,0,0,0,1.642-2.3,3.072,3.072,0,0,0-2.788-.5,1.86,1.86,0,0,0-1.106,2.379,1.337,1.337,0,0,0,2.325.036Z",
    transform: "translate(-432.909 -227.631)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.528,254.014a.26.26,0,0,1-.339-.13.488.488,0,0,1,.01-.393.472.472,0,0,1,.134-.194.34.34,0,0,1,.481.09.364.364,0,0,1-.12.481.391.391,0,0,1-.495-.09Z",
    transform: "translate(-427.773 -222.793)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.024,252.192c-.234-.08-.465.126-.619.32s-.346.423-.593.4a.215.215,0,0,1-.172-.1c-.084-.152.112-.3.212-.443a1.869,1.869,0,0,0,.148-.391.836.836,0,0,1,.783-.515.459.459,0,0,1-.084.839Z",
    transform: "translate(-430.313 -224.566)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.833,250.624l-.124-.26a.348.348,0,0,0-.342.266.29.29,0,0,0,.248.335.248.248,0,0,0,.242-.314Z",
    transform: "translate(-433.58 -225.67)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.034,252.561c.01.106-.108.19-.214.184a.463.463,0,0,1-.278-.15.549.549,0,0,1-.15-.212.389.389,0,0,1,.184-.441.481.481,0,0,1,.491.032.323.323,0,0,1,.148.2.17.17,0,0,1-.118.2Z",
    transform: "translate(-431.561 -224.14)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.371,243.22a2.931,2.931,0,0,0-.064-2.83,3.085,3.085,0,0,0-2.534,1.27,1.86,1.86,0,0,0,.543,2.57c.873.451,2.157-.423,1.883-1.366Z",
    transform: "translate(-443.485 -235.672)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.511,256.337c.084-.274-.358-.457-.587-.282a1.051,1.051,0,0,0-.29.785,1.013,1.013,0,0,0,1.037-.429Z",
    transform: "translate(-431.301 -220.033)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.9,257.552c-.08.17.128.348.316.348a5.33,5.33,0,0,0,.547-.116.669.669,0,0,1,.529.182.322.322,0,0,1,.116.3.4.4,0,0,1-.13.18,2.016,2.016,0,0,1-.947.545.947.947,0,0,1-.977-.36.724.724,0,0,1,.609-1.11Z",
    transform: "translate(-435.7 -218.494)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.494,252.146l-.122-.26a.351.351,0,0,0-.344.266.29.29,0,0,0,.25.334.248.248,0,0,0,.24-.316Z",
    transform: "translate(-427.903 -224.144)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.452,254.408a6.832,6.832,0,0,0-1.106-2.9,1.194,1.194,0,0,0-.34-.367.978.978,0,0,0-.935.034,2.008,2.008,0,0,0-1.015,2,2.491,2.491,0,0,0,1.356,1.851,1.671,1.671,0,0,0,1.268.162.939.939,0,0,0,.659-1,.2.2,0,0,0-.284.186Z",
    transform: "translate(-431.896 -224.996)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.373,251.063a2.922,2.922,0,0,0-.066-2.828,3.071,3.071,0,0,0-2.532,1.268,1.859,1.859,0,0,0,.541,2.568c.875.453,2.159-.421,1.883-1.364Z",
    transform: "translate(-435.46 -227.805)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.212,245.525a1.5,1.5,0,0,0,0-1.324,1.532,1.532,0,0,0-.531.3.526.526,0,0,0-.146.561c.112.256.447.31.727.33l-.174.152Z",
    transform: "translate(-435.448 -231.851)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.27,244.256a.594.594,0,0,0-.08-.369.628.628,0,0,0-.323-.174,5.82,5.82,0,0,1-.935-.395q.315.787.633,1.57a.375.375,0,0,1,.032.13c0,.156-.2.224-.288.354-.128.19.01.445.168.609C451.612,247.152,451.268,244.957,451.27,244.256Z",
    transform: "translate(-437.019 -232.735)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.585,251.508l-.162-.469a.793.793,0,0,0-.527.759c.038.328.487.565.729.34.148-.14.328-.419.465-.266Z",
    transform: "translate(-430.04 -224.993)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.5,248.272a.676.676,0,0,1,.086.4c-.344-.092-.533-.457-.659-.791-.072-.186-.124-.425.024-.559.1-.092.258-.086.387-.136.26-.1.473-.435.729-.324a.339.339,0,0,1,.154.4,1.007,1.007,0,0,1-.254.389l-.693.759Z",
    transform: "translate(-436.092 -229.202)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.228,248.994c.084-.274-.359-.459-.587-.282a1.044,1.044,0,0,0-.29.785,1.013,1.013,0,0,0,1.037-.429Z",
    transform: "translate(-438.605 -227.397)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.264,246.1a.259.259,0,0,1-.349.1.48.48,0,0,1-.228-.32.473.473,0,0,1-.008-.236.34.34,0,0,1,.437-.216.367.367,0,0,1,.194.459.392.392,0,0,1-.453.222Z",
    transform: "translate(-438.288 -230.641)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.983,245.972a.4.4,0,0,0,.387-.571.691.691,0,0,0-.435.072.343.343,0,0,0-.16.383.228.228,0,0,0,.361.094Z",
    transform: "translate(-437.192 -230.653)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.59,246.237a1.145,1.145,0,0,0,.32-.947l-.829.184a.772.772,0,0,0-.362.152.453.453,0,0,0,.084.675.639.639,0,0,0,.729-.06Z",
    transform: "translate(-434.341 -230.759)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.237,247.561a.511.511,0,0,1-.941-.052c-.046-.128-.008-.312.126-.336a.289.289,0,0,1,.166.032l.7.278-.066.114Z",
    transform: "translate(-439.682 -228.874)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.548,247.754c-.194-.154-.481-.036-.691.1s-.465.284-.691.18a.22.22,0,0,1-.128-.148c-.03-.172.2-.246.345-.348a1.879,1.879,0,0,0,.27-.318.831.831,0,0,1,.909-.226.459.459,0,0,1-.359.763Z",
    transform: "translate(-441.93 -229.107)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.067,246.256l-.03-.284a.344.344,0,0,0-.411.136.288.288,0,0,0,.124.4.247.247,0,0,0,.33-.218Z",
    transform: "translate(-441.374 -230.096)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.228,245.533c-.078.17.13.348.316.348a5.243,5.243,0,0,0,.549-.116.671.671,0,0,1,.529.182.321.321,0,0,1,.114.3.385.385,0,0,1-.13.18,2.016,2.016,0,0,1-.947.545.943.943,0,0,1-.975-.361.724.724,0,0,1,.607-1.11Z",
    transform: "translate(-436.376 -230.547)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.946,243.971a.451.451,0,0,0-.08-.621.647.647,0,0,0-.661-.058c-.094.04-.192.128-.166.228.018.068.086.108.15.14l.763.4Z",
    transform: "translate(-434.911 -232.826)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.177,250.1a.762.762,0,0,1-1.17-.3,1.891,1.891,0,0,1,1-.417c.367,0,.757.31.691.673l-.5.407Z",
    transform: "translate(-436.944 -226.654)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.5,244.687l-.046-.294a.628.628,0,0,0-.435.124c-.11.108-.084.344.068.364a.305.305,0,0,0,.166-.04l.507-.228Z",
    transform: "translate(-438.002 -231.658)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.978,255.454a1.831,1.831,0,0,0,.08-.725.618.618,0,0,0-.449-.527.544.544,0,0,0-.352.062.679.679,0,1,0,.7,1.16Z",
    transform: "translate(-430.026 -221.829)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.642,253.358l-.166-.471a.864.864,0,0,0-.363.114.471.471,0,0,0,.461.471Z",
    transform: "translate(-436.838 -223.14)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.247,261.117a.261.261,0,0,1-.349.1.484.484,0,0,1-.228-.322.471.471,0,0,1-.008-.236.34.34,0,0,1,.439-.214.363.363,0,0,1,.192.457.394.394,0,0,1-.451.224Z",
    transform: "translate(-427.274 -215.582)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.258,251.393l-.166-.473a.887.887,0,0,0-.362.116.471.471,0,0,0,.461.471Z",
    transform: "translate(-436.22 -225.113)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.55,239.544c.126-.138-.02-.373-.2-.427a5.077,5.077,0,0,0-.557-.05.679.679,0,0,1-.453-.328.324.324,0,0,1-.022-.32.4.4,0,0,1,.178-.134,2.038,2.038,0,0,1,1.065-.242.948.948,0,0,1,.827.633.726.726,0,0,1-.907.883Z",
    transform: "translate(-441.68 -238.034)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.695,253.482a1.045,1.045,0,0,0-.09.411.354.354,0,0,0,.222.326c.222.066.419-.17.649-.212s.485.114.685,0a.4.4,0,0,0,.016-.6,1.007,1.007,0,0,0-.639-.222,1.111,1.111,0,0,0-.6.07.44.44,0,0,0-.25.5Z",
    transform: "translate(-431.332 -222.851)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.855,248.766a5.545,5.545,0,0,0,1.572,1.979,1,1,0,0,0,.354.2.8.8,0,0,0,.717-.258,1.632,1.632,0,0,0,.3-1.8,2.029,2.029,0,0,0-1.508-1.106,1.368,1.368,0,0,0-1.023.186.768.768,0,0,0-.266.941.165.165,0,0,0,.176-.214Z",
    transform: "translate(-433.085 -228.284)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.9,248.7a.6.6,0,0,0,.28-.254.636.636,0,0,0-.008-.367,5.5,5.5,0,0,1-.124-1.007q-.526.664-1.049,1.33a.323.323,0,0,1-.1.092c-.136.076-.294-.062-.451-.074-.228-.016-.381.23-.445.451C455.552,250.439,457.287,249.047,457.9,248.7Z",
    transform: "translate(-431.005 -228.97)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.169,248.347l-.01-.286a.35.35,0,0,0-.421.108.288.288,0,0,0,.1.4.247.247,0,0,0,.346-.192Z",
    transform: "translate(-433.247 -228.01)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.948,247.535a.448.448,0,0,0,.5-.376.646.646,0,0,0-.278-.6c-.082-.062-.206-.1-.28-.032a.265.265,0,0,0-.048.2l.036.859Z",
    transform: "translate(-431.095 -229.559)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.466,247.975a1.5,1.5,0,0,0,1.148-.661,1.564,1.564,0,0,0-.527-.31.524.524,0,0,0-.559.152c-.168.224-.048.543.074.793l-.218-.074Z",
    transform: "translate(-432.555 -229.063)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.574,247.747a.68.68,0,0,1-.3.272,1.154,1.154,0,0,1,.357-.965c.126-.152.308-.318.5-.256.132.044.2.182.312.268.214.176.611.194.643.471a.34.34,0,0,1-.272.334.993.993,0,0,1-.465-.028l-1-.222Z",
    transform: "translate(-433.694 -229.26)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.145,248.576a1.148,1.148,0,0,0,.981-.194c-.19-.208-.381-.419-.573-.627a.749.749,0,0,0-.312-.24.454.454,0,0,0-.543.411.632.632,0,0,0,.415.6Z",
    transform: "translate(-431.238 -228.543)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.689,246.17c-.186.016-.238.286-.144.449s.262.264.373.417a.68.68,0,0,1,.106.551.324.324,0,0,1-.2.248.406.406,0,0,1-.222-.024,2.045,2.045,0,0,1-.943-.551.946.946,0,0,1-.172-1.027.726.726,0,0,1,1.266-.024Z",
    transform: "translate(-432.542 -230.198)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.888,252.55a1.786,1.786,0,0,0,.671-.292.613.613,0,0,0,.232-.649.538.538,0,0,0-.228-.274.679.679,0,1,0-.657,1.186Z",
    transform: "translate(-433.411 -224.794)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.456,252.013a1.5,1.5,0,0,0,1.148-.661,1.545,1.545,0,0,0-.527-.31.524.524,0,0,0-.559.152c-.168.224-.048.543.076.8l-.22-.076Z",
    transform: "translate(-430.559 -225.014)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.823,247.422c-.184-.166-.477-.07-.695.048s-.485.25-.7.13a.224.224,0,0,1-.12-.158c-.018-.174.222-.23.371-.322a1.864,1.864,0,0,0,.29-.3.835.835,0,0,1,.923-.162.459.459,0,0,1-.411.737Z",
    transform: "translate(-434.639 -229.46)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.681,256.58l-.178-.224a.348.348,0,0,0-.272.339.289.289,0,0,0,.318.268.248.248,0,0,0,.162-.362Z",
    transform: "translate(-432.709 -219.661)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.579,249.33l.232-.188a.624.624,0,0,0-.322-.314c-.148-.042-.341.1-.284.24a.319.319,0,0,0,.118.124l.451.326Z",
    transform: "translate(-431.742 -227.218)",
    fill: "#fff",
    opacity: 0.5
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(260.155 340.788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.923,285.752a1.047,1.047,0,0,0-.363-.214.358.358,0,0,0-.38.11c-.132.19.032.451,0,.681s-.258.427-.21.653a.394.394,0,0,0,.561.2,1.01,1.01,0,0,0,.411-.537,1.128,1.128,0,0,0,.12-.595.442.442,0,0,0-.4-.395Z",
    transform: "translate(-466.777 -271.348)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.773,281.753a.262.262,0,0,1-.12.343.5.5,0,0,1-.395,0,.486.486,0,0,1-.2-.128.344.344,0,0,1,.076-.483.365.365,0,0,1,.487.106.393.393,0,0,1-.078.5Z",
    transform: "translate(-479.786 -275.45)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.73,279.865a.4.4,0,0,0,.19-.665.725.725,0,0,0-.391.2.342.342,0,0,0-.034.415.226.226,0,0,0,.371-.024Z",
    transform: "translate(-469.309 -277.69)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.015,284.633a.514.514,0,0,1-.587.739c-.132-.036-.26-.174-.2-.3a.3.3,0,0,1,.122-.116l.633-.415.054.12Z",
    transform: "translate(-459.51 -272.332)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.616,284.739c-.074.238.138.463.336.611s.431.334.415.581a.221.221,0,0,1-.092.174c-.15.09-.3-.1-.449-.2a1.921,1.921,0,0,0-.395-.138.833.833,0,0,1-.537-.767.459.459,0,0,1,.841.06Z",
    transform: "translate(-461.833 -272.135)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.21,285.168l-.256.13a.348.348,0,0,0,.274.336.29.29,0,0,0,.328-.258.248.248,0,0,0-.323-.232Z",
    transform: "translate(-462.777 -271.745)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.293,280.775l-.256.128a.348.348,0,0,0,.276.336.288.288,0,0,0,.326-.258.247.247,0,0,0-.322-.23Z",
    transform: "translate(-477.736 -276.15)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.655,279.042a1.8,1.8,0,0,0-.547-.483.616.616,0,0,0-.687.062.53.53,0,0,0-.152.322.679.679,0,1,0,1.352.1Z",
    transform: "translate(-473.496 -278.407)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.689,278.583a6.321,6.321,0,0,0-2.8.6,1.113,1.113,0,0,0-.383.258.9.9,0,0,0-.1.857,1.847,1.847,0,0,0,1.682,1.206,2.3,2.3,0,0,0,1.879-.977,1.544,1.544,0,0,0,.324-1.134.868.868,0,0,0-.823-.741.187.187,0,0,0,.13.286Z",
    transform: "translate(-481.437 -278.309)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.094,282.665a1.5,1.5,0,0,0-1.083-.761,1.531,1.531,0,0,0-.06.609.527.527,0,0,0,.375.443c.274.056.511-.186.687-.4l.026.23Z",
    transform: "translate(-465.8 -274.978)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.684,282.762a.583.583,0,0,0-.346-.146.6.6,0,0,0-.328.162,5.636,5.636,0,0,1-.863.537q.826.2,1.648.389a.387.387,0,0,1,.126.048c.126.094.066.294.122.441.08.214.369.248.595.212C504.248,284.152,502.255,283.169,501.684,282.762Z",
    transform: "translate(-467.598 -274.264)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.874,285.045a.688.688,0,0,1,.377.162,1.151,1.151,0,0,1-1.026.084c-.192-.05-.419-.144-.443-.342-.016-.138.08-.26.112-.395.068-.27-.082-.637.154-.783a.34.34,0,0,1,.419.106.988.988,0,0,1,.17.433q.111.5.222,1Z",
    transform: "translate(-463.953 -273.142)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.968,285.319a.26.26,0,0,1-.12.342.478.478,0,0,1-.393,0,.471.471,0,0,1-.2-.128.34.34,0,0,1,.076-.483.364.364,0,0,1,.485.106.39.39,0,0,1-.076.5Z",
    transform: "translate(-466.553 -271.874)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.261,284.7a.4.4,0,0,0-.244-.647.7.7,0,0,0-.19.4.34.34,0,0,0,.218.352c.144.04.32-.1.284-.242Z",
    transform: "translate(-465.914 -272.821)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.47,282.194a1.145,1.145,0,0,0-.589-.809l-.326.783a.759.759,0,0,0-.086.387.454.454,0,0,0,.6.318.637.637,0,0,0,.371-.631Z",
    transform: "translate(-464.27 -275.498)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.524,282.394l-.256.13a.351.351,0,0,0,.276.336.29.29,0,0,0,.326-.258.247.247,0,0,0-.322-.232Z",
    transform: "translate(-455.442 -274.526)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.561,283.9c.092.162.358.1.467-.058a5.571,5.571,0,0,0,.22-.513A.672.672,0,0,1,503.7,283a.32.32,0,0,1,.31.078.388.388,0,0,1,.07.21,2,2,0,0,1-.1,1.088.944.944,0,0,1-.857.591.724.724,0,0,1-.557-1.138Z",
    transform: "translate(-465.296 -273.892)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.346,281.191a.451.451,0,0,0-.553-.292.651.651,0,0,0-.431.507c-.02.1,0,.23.092.266a.252.252,0,0,0,.2-.04l.765-.4Z",
    transform: "translate(-466.386 -276.003)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.235,286.426a.762.762,0,0,1-.921.781,1.9,1.9,0,0,1,.238-1.06.658.658,0,0,1,.949-.176l.044.641Z",
    transform: "translate(-462.416 -271.038)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.95,284.374l-.27-.132a.638.638,0,0,0-.148.427c.024.152.232.268.338.154a.3.3,0,0,0,.062-.158l.106-.547Z",
    transform: "translate(-467.216 -272.758)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.532,283.427a.588.588,0,0,0-.348-.146.615.615,0,0,0-.328.162,5.636,5.636,0,0,1-.861.537c.549.13,1.1.26,1.648.389a.357.357,0,0,1,.126.048c.124.094.066.294.122.441.08.214.369.248.595.212C508.1,284.817,506.1,283.834,505.532,283.427Z",
    transform: "translate(-463.739 -273.597)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.5,286.225l-.477-.138a.793.793,0,0,0,.316.867c.29.158.741-.07.7-.4-.028-.2-.152-.509.05-.533Z",
    transform: "translate(-460.721 -270.847)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.578,282.179a.68.68,0,1,1-.038-.048Z",
    transform: "translate(-457.357 -274.962)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.069,282.715c.37,0,.849.1.9.465s-.357.577-.691.7c-.144.05-.32.1-.437,0-.286-.238.274-.749.046-1.043.038-.1.228-.046.208.058Z",
    transform: "translate(-458.963 -274.165)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.269,282.634a.685.685,0,0,1,.379.162,1.158,1.158,0,0,1-1.025.082c-.192-.048-.421-.144-.443-.34-.016-.138.078-.262.112-.4.066-.268-.084-.637.152-.781a.341.341,0,0,1,.419.1,1,1,0,0,1,.172.433l.22,1Z",
    transform: "translate(-459.544 -275.56)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.3,284.3a.679.679,0,0,1,.377.162,1.151,1.151,0,0,1-1.025.082c-.192-.048-.421-.144-.443-.34-.016-.138.078-.262.112-.4.068-.268-.082-.635.154-.781a.342.342,0,0,1,.419.1,1,1,0,0,1,.17.435l.22,1Z",
    transform: "translate(-454.5 -273.885)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.662,284.7c-.176-.226-.581.03-.569.316a1.051,1.051,0,0,0,.475.691,1.012,1.012,0,0,0,.246-1.094Z",
    transform: "translate(-459.629 -272.261)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.659,282.289a.4.4,0,0,0-.246-.645.71.71,0,0,0-.19.4.342.342,0,0,0,.22.353c.144.04.318-.1.282-.24Z",
    transform: "translate(-461.505 -275.239)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.494,287.375a1.153,1.153,0,0,0-.591-.809l-.327.783a.777.777,0,0,0-.084.387.454.454,0,0,0,.6.318.643.643,0,0,0,.371-.631Z",
    transform: "translate(-463.243 -270.303)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.22,283.005a.878.878,0,0,0-.433-.885,1.043,1.043,0,0,0-.344.649.7.7,0,0,0,.451.789c.324.076.671-.345.463-.6Z",
    transform: "translate(-460.287 -274.761)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.873,284.324a.527.527,0,0,1-.028.651l-.741-.24a.6.6,0,0,1,.7-.607Z",
    transform: "translate(-459.62 -272.761)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507,284.709a.514.514,0,0,1-.587.739c-.132-.036-.26-.172-.2-.3a.317.317,0,0,1,.122-.118l.633-.415.054.12Z",
    transform: "translate(-461.533 -272.255)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.6,284.815c-.074.238.138.463.336.611s.431.334.415.583a.22.22,0,0,1-.092.172c-.15.09-.3-.1-.449-.2a1.916,1.916,0,0,0-.395-.138.833.833,0,0,1-.537-.767.459.459,0,0,1,.841.06Z",
    transform: "translate(-463.857 -272.059)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.192,285.244l-.256.13a.348.348,0,0,0,.274.336.29.29,0,0,0,.328-.258.249.249,0,0,0-.323-.232Z",
    transform: "translate(-464.8 -271.668)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.526,283.378c.092.162.358.094.467-.058a4.914,4.914,0,0,0,.22-.515.669.669,0,0,1,.455-.326.32.32,0,0,1,.31.078.4.4,0,0,1,.072.21,2.024,2.024,0,0,1-.1,1.088.949.949,0,0,1-.859.591.726.726,0,0,1-.557-1.138Z",
    transform: "translate(-481.375 -274.411)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.368,286.372a.45.45,0,0,0-.553-.292.645.645,0,0,0-.429.507c-.02.1-.006.23.09.268a.267.267,0,0,0,.2-.042l.763-.4Z",
    transform: "translate(-465.359 -270.807)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.631,284.016a.761.761,0,0,1-.921.781,1.919,1.919,0,0,1,.238-1.061.658.658,0,0,1,.949-.176l.044.643Z",
    transform: "translate(-458.007 -273.457)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.01,286.507c.106-.012.194.1.192.208a.459.459,0,0,1-.144.282.542.542,0,0,1-.206.156.386.386,0,0,1-.447-.17.488.488,0,0,1,.018-.493.309.309,0,0,1,.192-.152.172.172,0,0,1,.2.11Z",
    transform: "translate(-463.385 -270.534)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.346,281.962l-.268-.132a.633.633,0,0,0-.15.427c.026.152.234.268.338.156a.323.323,0,0,0,.064-.16l.1-.547Z",
    transform: "translate(-462.808 -275.177)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.115,283.556a1.829,1.829,0,0,0-.547-.485.623.623,0,0,0-.689.062.552.552,0,0,0-.152.324.679.679,0,1,0,1.352.094Z",
    transform: "translate(-473.037 -273.882)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.712,283.454a1.06,1.06,0,0,0-.363-.214.355.355,0,0,0-.379.11c-.134.19.03.451,0,.681s-.258.427-.21.653a.393.393,0,0,0,.561.2,1.01,1.01,0,0,0,.411-.537,1.111,1.111,0,0,0,.12-.595.442.442,0,0,0-.4-.395Z",
    transform: "translate(-478.02 -273.652)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.886,279.962l-.282-.05a.346.346,0,0,0,.018.435.291.291,0,0,0,.417-.01.247.247,0,0,0-.118-.379Z",
    transform: "translate(-469.213 -276.976)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.089,282.8a2.923,2.923,0,0,0-2.349-1.578,3.07,3.07,0,0,0-.423,2.8,1.859,1.859,0,0,0,2.409,1.037,1.337,1.337,0,0,0-.028-2.325Z",
    transform: "translate(-482.649 -275.66)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.055,281.224c-.176-.226-.581.03-.571.316a1.051,1.051,0,0,0,.475.691,1.013,1.013,0,0,0,.248-1.094Z",
    transform: "translate(-463.248 -275.746)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.358,286.1c.094.162.361.1.469-.058a5.365,5.365,0,0,0,.22-.515.67.67,0,0,1,.453-.326.324.324,0,0,1,.312.078.4.4,0,0,1,.07.21,2,2,0,0,1-.1,1.088.944.944,0,0,1-.857.591.724.724,0,0,1-.557-1.138Z",
    transform: "translate(-464.495 -271.677)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.11,280.786a2.923,2.923,0,0,0-2.349-1.578,3.078,3.078,0,0,0-.423,2.8,1.859,1.859,0,0,0,2.411,1.037,1.337,1.337,0,0,0-.03-2.325Z",
    transform: "translate(-471.595 -277.682)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.273,278.592a.582.582,0,0,0-.346-.146.615.615,0,0,0-.328.162,5.65,5.65,0,0,1-.863.537l1.648.391a.312.312,0,0,1,.126.048c.126.092.066.292.122.439.08.214.369.248.595.214C494.837,279.982,492.844,279,492.273,278.592Z",
    transform: "translate(-477.036 -278.446)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.463,280.876a.671.671,0,0,1,.377.16,1.15,1.15,0,0,1-1.025.084c-.192-.05-.419-.144-.443-.343-.016-.136.08-.26.112-.395.068-.268-.082-.637.154-.781a.339.339,0,0,1,.419.1,1,1,0,0,1,.17.433l.222,1Z",
    transform: "translate(-473.39 -277.323)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.855,282.943c-.176-.228-.581.03-.569.317a1.039,1.039,0,0,0,.473.689,1,1,0,0,0,.248-1.092Z",
    transform: "translate(-473.475 -274.024)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.559,281.149a.263.263,0,0,1-.122.342.479.479,0,0,1-.393,0,.486.486,0,0,1-.2-.128.341.341,0,0,1,.076-.483.364.364,0,0,1,.485.106.393.393,0,0,1-.076.5Z",
    transform: "translate(-475.99 -276.056)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.85,280.532a.4.4,0,0,0-.244-.647.707.707,0,0,0-.19.4.34.34,0,0,0,.22.352c.144.04.318-.1.282-.242Z",
    transform: "translate(-475.351 -277.003)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.189,282.951a.512.512,0,0,1-.585.739c-.132-.036-.26-.174-.2-.3a.332.332,0,0,1,.124-.116l.633-.415.054.12Z",
    transform: "translate(-475.38 -274.018)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.128,284.728c-.238.07-.306.373-.318.621s-.038.543-.252.667a.221.221,0,0,1-.2.02c-.158-.074-.082-.308-.086-.483a1.8,1.8,0,0,0-.1-.4.835.835,0,0,1,.339-.873.459.459,0,0,1,.419.733Z",
    transform: "translate(-476.621 -272.603)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.847,283.825l-.25-.142a.349.349,0,0,0-.126.417.29.29,0,0,0,.4.128.247.247,0,0,0,.014-.4Z",
    transform: "translate(-477.328 -273.194)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.15,279.726c.092.162.359.1.467-.056s.128-.353.22-.515a.672.672,0,0,1,.455-.328.321.321,0,0,1,.31.078.388.388,0,0,1,.07.21,2.011,2.011,0,0,1-.1,1.09.945.945,0,0,1-.857.589.724.724,0,0,1-.557-1.138Z",
    transform: "translate(-474.734 -278.073)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.824,282.258a.763.763,0,0,1-.921.781,1.918,1.918,0,0,1,.238-1.062.658.658,0,0,1,.949-.176l.044.643Z",
    transform: "translate(-471.853 -275.22)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.539,280.2l-.27-.132a.642.642,0,0,0-.148.427c.024.152.232.268.338.154a.3.3,0,0,0,.062-.158l.106-.547Z",
    transform: "translate(-476.654 -276.939)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.3,284.151l-.481-.136a.856.856,0,0,0-.114.362.469.469,0,0,0,.649-.106Z",
    transform: "translate(-469.043 -272.861)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.048,282.514l-.481-.136a.9.9,0,0,0-.114.363.473.473,0,0,0,.651-.1Z",
    transform: "translate(-470.299 -274.503)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.543,280.08c-.042-.182-.316-.2-.465-.082s-.226.3-.36.427a.667.667,0,0,1-.531.18.322.322,0,0,1-.274-.166.418.418,0,0,1-.006-.222,2.012,2.012,0,0,1,.417-1.009.941.941,0,0,1,.993-.312.726.726,0,0,1,.2,1.25Z",
    transform: "translate(-483.895 -278.041)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.429,281.3a1.78,1.78,0,0,0,.146-.715.615.615,0,0,0-.395-.565.546.546,0,0,0-.357.028.679.679,0,1,0,.589,1.222Z",
    transform: "translate(-468.335 -276.884)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.243,282.687l-.286.016a.348.348,0,0,0,.12.419.288.288,0,0,0,.4-.108.248.248,0,0,0-.2-.34Z",
    transform: "translate(-463.802 -274.207)",
    fill: "#fff",
    opacity: 0.5
  }))), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M496.472,227.3s26.153-33.038,31.763-42.137C528.235,185.161,513.113,213.391,496.472,227.3Z",
    transform: "translate(-211.127 -31.205)",
    fill: "#8e88f7"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M507.683,191.668s5.177-1,7.454-3.771v2.023l1.855-2.023s-.431-4.268-1.43-5.464C515.562,182.433,514.649,187.586,507.683,191.668Z",
    transform: "translate(-199.885 -33.941)",
    fill: "#8e88f7"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M513.831,163.089l-7.454,20.591S513.241,172.632,513.831,163.089Z",
    transform: "translate(-201.194 -53.34)",
    fill: "#8e88f7"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M471.222,299.555s27.967-69.135,38.412-78.382C509.634,221.173,478.278,289.281,471.222,299.555Z",
    transform: "translate(-236.448 4.908)",
    fill: "#8e88f7"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M473.411,170.839s-4.959,31.616-20.691,44.7C452.72,215.542,473.491,200.419,473.411,170.839Z",
    transform: "translate(-255.002 -45.568)",
    fill: "#4a46a2"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M480.38,275.02s13.038,4.15,48.847,12.339,82.951,11.036,82.951,11.036S535.061,288.217,480.38,275.02Z",
    transform: "translate(-227.264 58.907)",
    fill: "#8e88f7"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M552.827,290.921s58.939-10.317,62.306-9.758C615.133,281.163,600.786,278.93,552.827,290.921Z",
    transform: "translate(-154.613 64.902)",
    fill: "#8e88f7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.336 358.599)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M411.463,312.966a15.529,15.529,0,0,0,5.1-4.857,2.709,2.709,0,0,0,.473-1.034,2.215,2.215,0,0,0-.889-1.925,4.548,4.548,0,0,0-5.077-.377,5.634,5.634,0,0,0-2.692,4.458,3.8,3.8,0,0,0,.769,2.8,2.138,2.138,0,0,0,2.68.5.463.463,0,0,0-.643-.435Z",
    transform: "translate(-397.818 -270.453)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M419.356,298.133a2.882,2.882,0,0,0,2.578-1.057,3.024,3.024,0,0,0-2.061-1.879,1.83,1.83,0,0,0-2.169,1.4c-.106.961,1.15,1.835,1.919,1.248Z",
    transform: "translate(-388.459 -279.492)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M413.863,302.338a1.473,1.473,0,0,0,1.256.353,1.542,1.542,0,0,0-.144-.585.519.519,0,0,0-.493-.288c-.274.038-.415.34-.507.6l-.1-.206Z",
    transform: "translate(-392.305 -272.822)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M413.505,303.227a.664.664,0,0,1-.339.22,1.134,1.134,0,0,1,.493-.885c.146-.13.348-.262.523-.174.12.062.17.208.262.308.182.2.565.28.555.555a.334.334,0,0,1-.314.284.982.982,0,0,1-.449-.1l-.941-.367Z",
    transform: "translate(-393.007 -272.275)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M421.268,294.623c.282-.02.294-.491.052-.639a1.025,1.025,0,0,0-.823.01,1,1,0,0,0,.759.8Z",
    transform: "translate(-385.652 -280.759)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M407.537,299.71a1.036,1.036,0,0,0,.373-.178.351.351,0,0,0,.118-.373c-.084-.212-.387-.22-.559-.372s-.206-.445-.419-.529-.445.126-.471.351a.989.989,0,0,0,.214.629,1.112,1.112,0,0,0,.421.425.434.434,0,0,0,.543-.112Z",
    transform: "translate(-399.612 -276.408)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M417.624,290.853a.257.257,0,0,1-.214-.286.475.475,0,0,1,.214-.322.456.456,0,0,1,.214-.092.335.335,0,0,1,.353.326.357.357,0,0,1-.353.339.385.385,0,0,1-.364-.334Z",
    transform: "translate(-388.75 -284.519)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M413.638,300.062a.4.4,0,0,0,.439.519.689.689,0,0,0,.048-.433.338.338,0,0,0-.32-.254.224.224,0,0,0-.184.316Z",
    transform: "translate(-392.575 -274.748)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M412.7,303.444a1.136,1.136,0,0,0,.811.559l.048-.835a.767.767,0,0,0-.046-.387.45.45,0,0,0-.663-.1.629.629,0,0,0-.138.707Z",
    transform: "translate(-393.514 -272.055)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M404.219,305.9a.505.505,0,0,1-.284-.885c.1-.088.284-.118.355,0a.312.312,0,0,1,.028.166l-.006.745-.128-.022Z",
    transform: "translate(-402.435 -269.694)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M405.9,303.837c-.152-.192-.453-.14-.683-.06s-.509.17-.7.02a.216.216,0,0,1-.092-.17c.01-.172.25-.19.409-.258a1.857,1.857,0,0,0,.328-.246.822.822,0,0,1,.923-.018.453.453,0,0,1-.511.655Z",
    transform: "translate(-401.777 -271.663)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M405.7,302.388l.034-.282a.341.341,0,0,0-.425.042.286.286,0,0,0,.03.411.246.246,0,0,0,.367-.138Z",
    transform: "translate(-400.96 -272.585)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M417.457,292.586l.034-.28a.341.341,0,0,0-.425.042.282.282,0,0,0,.032.409.242.242,0,0,0,.365-.136Z",
    transform: "translate(-389.165 -282.413)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M414.24,301.415c-.14-.12-.365.028-.415.206a4.985,4.985,0,0,0-.036.549.662.662,0,0,1-.314.455.324.324,0,0,1-.314.028.4.4,0,0,1-.136-.172,2.007,2.007,0,0,1-.262-1.043.93.93,0,0,1,.6-.829.715.715,0,0,1,.891.875Z",
    transform: "translate(-393.413 -274.059)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M414.93,303.387a.447.447,0,0,0,.611.09.642.642,0,0,0,.232-.611c-.014-.1-.072-.216-.172-.218a.241.241,0,0,0-.172.1l-.581.617Z",
    transform: "translate(-391.317 -271.986)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M418.209,299.226a.75.75,0,0,1-.134-1.182,1.9,1.9,0,0,1,.737.775.65.65,0,0,1-.375.875l-.551-.316Z",
    transform: "translate(-388.311 -276.603)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M405.774,312.184a.194.194,0,0,1-.276.042.458.458,0,0,1-.152-.272.546.546,0,0,1-.014-.254.377.377,0,0,1,.385-.27.473.473,0,0,1,.393.282.32.32,0,0,1,.02.242.169.169,0,0,1-.2.1Z",
    transform: "translate(-400.87 -263.181)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M414.916,299.939l.292.034a.618.618,0,0,0,0-.445c-.072-.134-.3-.172-.365-.034a.32.32,0,0,0-.006.168l.08.543Z",
    transform: "translate(-391.337 -275.236)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M416.359,298.051a1.791,1.791,0,0,0,.695-.184.612.612,0,0,0,.326-.6.554.554,0,0,0-.182-.3.669.669,0,1,0-.819,1.055Z",
    transform: "translate(-390.061 -277.835)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M417.566,297.545l.375-.318a.9.9,0,0,0-.234-.292.465.465,0,0,0-.268.591Z",
    transform: "translate(-388.75 -277.716)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M421.129,293.692a6.207,6.207,0,0,0,1.037-2.622,1.055,1.055,0,0,0,0-.455.883.883,0,0,0-.647-.549,1.817,1.817,0,0,0-1.907.715,2.26,2.26,0,0,0-.23,2.071,1.518,1.518,0,0,0,.751.887.853.853,0,0,0,1.057-.268.186.186,0,0,0-.306-.05Z",
    transform: "translate(-386.921 -284.661)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M409.246,302.14a1.472,1.472,0,0,0,1.216-.471,1.542,1.542,0,0,0-.465-.38.522.522,0,0,0-.569.064c-.2.192-.128.521-.046.783l-.2-.106Z",
    transform: "translate(-397.001 -273.403)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M410.764,300.937a.587.587,0,0,0,.31-.2.6.6,0,0,0,.046-.359,5.755,5.755,0,0,1,.032-1l-1.22,1.136a.313.313,0,0,1-.108.076c-.144.052-.276-.1-.427-.14-.22-.05-.407.166-.5.371C408.223,302.273,410.119,301.182,410.764,300.937Z",
    transform: "translate(-397.428 -275.268)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M406.669,302.452a.673.673,0,0,1-.338.218,1.136,1.136,0,0,1,.493-.883c.146-.13.348-.264.523-.176.12.062.17.208.262.308.182.2.565.28.555.555a.334.334,0,0,1-.314.284.981.981,0,0,1-.449-.1l-.941-.367Z",
    transform: "translate(-399.862 -273.054)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M407.481,299.7a.258.258,0,0,1-.214-.286.476.476,0,0,1,.216-.32A.457.457,0,0,1,407.7,299a.337.337,0,0,1,.354.326.36.36,0,0,1-.353.338.388.388,0,0,1-.366-.336Z",
    transform: "translate(-398.921 -275.648)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M407.779,300.3a.4.4,0,0,0,.663.154.692.692,0,0,0-.222-.375.337.337,0,0,0-.409-.012.223.223,0,0,0,.042.362Z",
    transform: "translate(-398.448 -274.635)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M409,303.673a1.135,1.135,0,0,0,.985-.04l-.463-.7a.743.743,0,0,0-.268-.282.449.449,0,0,0-.591.316.629.629,0,0,0,.312.649Z",
    transform: "translate(-397.534 -272.013)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M403.962,309.89l.034-.28a.344.344,0,0,0-.427.042.285.285,0,0,0,.032.409.244.244,0,0,0,.367-.136Z",
    transform: "translate(-402.699 -265.06)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M408.941,301.245c-.184-.012-.274.242-.208.415a4.89,4.89,0,0,0,.3.461.674.674,0,0,1,.02.553.325.325,0,0,1-.234.21.4.4,0,0,1-.212-.056,1.986,1.986,0,0,1-.835-.679.928.928,0,0,1-.014-1.023.713.713,0,0,1,1.236.166Z",
    transform: "translate(-398.576 -273.801)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M410.636,302.334a.445.445,0,0,0,.543-.292.638.638,0,0,0-.18-.629c-.07-.07-.186-.13-.268-.07a.252.252,0,0,0-.076.186c-.032.28-.064.561-.094.841Z",
    transform: "translate(-395.617 -273.32)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M404.464,302.84a.751.751,0,0,1-.134-1.182,1.866,1.866,0,0,1,.737.775.648.648,0,0,1-.375.873c-.184-.1-.367-.21-.551-.314Z",
    transform: "translate(-402.095 -272.979)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M408.745,299.419l.254-.148a.618.618,0,0,0-.266-.354c-.138-.064-.349.044-.312.192a.3.3,0,0,0,.1.138l.388.385Z",
    transform: "translate(-397.766 -275.747)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M411.711,304.173a1.8,1.8,0,0,0,.695-.184.6.6,0,0,0,.325-.595.538.538,0,0,0-.18-.3.668.668,0,1,0-.819,1.053Z",
    transform: "translate(-394.722 -271.695)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M417.355,301.422c.074-.232-.134-.455-.332-.6s-.425-.326-.407-.571a.215.215,0,0,1,.09-.172c.148-.088.3.1.443.2a1.778,1.778,0,0,0,.389.134.825.825,0,0,1,.529.757.47.47,0,0,1-.435.242.463.463,0,0,1-.395-.3Z",
    transform: "translate(-389.545 -274.586)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M417.434,298.4c.074-.234-.136-.455-.332-.6s-.425-.326-.407-.571a.212.212,0,0,1,.09-.172c.148-.088.3.1.443.2a1.8,1.8,0,0,0,.387.134.827.827,0,0,1,.531.757.47.47,0,0,1-.435.242.463.463,0,0,1-.395-.3Z",
    transform: "translate(-389.465 -277.619)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M418.941,296.647a1.3,1.3,0,0,0,.415-.423.215.215,0,0,0,.038-.088.2.2,0,0,0-.08-.16.384.384,0,0,0-.429-.016.467.467,0,0,0-.214.38.326.326,0,0,0,.072.234.179.179,0,0,0,.226.034.038.038,0,0,0-.054-.034Z",
    transform: "translate(-387.485 -278.751)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M408.811,307.059a1.485,1.485,0,0,0,1.218-.471,1.519,1.519,0,0,0-.467-.38.515.515,0,0,0-.567.062c-.2.194-.128.521-.046.785l-.2-.106Z",
    transform: "translate(-397.435 -268.472)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M408.112,303.72a.576.576,0,0,0,.31-.2.614.614,0,0,0,.048-.357,5.557,5.557,0,0,1,.032-1l-1.222,1.136a.342.342,0,0,1-.108.076c-.144.052-.276-.106-.427-.14-.218-.052-.4.166-.5.37C405.573,305.058,407.469,303.965,408.112,303.72Z",
    transform: "translate(-400.085 -272.476)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M403.856,303.759l.375-.314a.781.781,0,0,0-.883-.216c-.288.152-.348.647-.056.789.18.088.5.154.409.334Z",
    transform: "translate(-403.099 -271.469)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M405.113,309.382a.664.664,0,1,1,.06,0Z",
    transform: "translate(-401.75 -266.537)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M405.921,307.1c-.206.3-.547.643-.873.483s-.276-.607-.19-.945c.038-.146.1-.314.24-.357.352-.1.463.635.829.609.06.086-.088.212-.162.138Z",
    transform: "translate(-401.397 -268.353)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M406.237,307.369a.677.677,0,0,1-.341.22,1.142,1.142,0,0,1,.495-.885c.146-.13.346-.264.521-.174.122.062.172.206.262.308.184.2.567.28.557.553a.338.338,0,0,1-.314.286.982.982,0,0,1-.449-.1l-.941-.368Z",
    transform: "translate(-400.297 -268.123)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M404.448,305.546c.282-.02.294-.491.052-.639a1.025,1.025,0,0,0-.823.01.991.991,0,0,0,.759.8Z",
    transform: "translate(-402.52 -269.805)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M407.346,305.221a.4.4,0,0,0,.661.152.677.677,0,0,0-.22-.373.334.334,0,0,0-.409-.014.224.224,0,0,0,.042.365Z",
    transform: "translate(-398.883 -269.704)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M410.829,303.814a.4.4,0,0,0,.663.154.693.693,0,0,0-.222-.375.337.337,0,0,0-.409-.012.223.223,0,0,0,.042.363Z",
    transform: "translate(-395.389 -271.114)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M404.2,301.673a1.124,1.124,0,0,0,.983-.04l-.463-.7a.743.743,0,0,0-.268-.282.45.45,0,0,0-.591.318.63.63,0,0,0,.314.647Z",
    transform: "translate(-402.347 -274.018)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M406.273,306.234a.86.86,0,0,0,.959.132,1.032,1.032,0,0,0-.341-.639.7.7,0,0,0-.893-.062c-.238.224-.086.739.24.709Z",
    transform: "translate(-400.309 -269.097)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M404.619,305.94a.513.513,0,0,1-.517-.379l.6-.475a.591.591,0,0,1,.11.907Z",
    transform: "translate(-402.094 -269.54)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M405.261,304.2a.505.505,0,0,1-.284-.885c.1-.088.284-.118.354,0a.306.306,0,0,1,.03.164l-.008.745-.128-.022Z",
    transform: "translate(-401.39 -271.392)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M406.939,302.144c-.154-.192-.455-.14-.685-.06s-.509.17-.7.02a.206.206,0,0,1-.092-.17c.008-.17.25-.19.409-.258a1.761,1.761,0,0,0,.328-.246.819.819,0,0,1,.921-.018.453.453,0,0,1-.511.655Z",
    transform: "translate(-400.731 -273.361)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M406.739,300.694l.034-.28a.344.344,0,0,0-.427.04.286.286,0,0,0,.032.411.246.246,0,0,0,.367-.138Z",
    transform: "translate(-399.914 -274.283)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M408.508,306.163c-.184-.014-.276.24-.21.413s.218.3.3.463a.661.661,0,0,1,.02.551.317.317,0,0,1-.234.212.379.379,0,0,1-.21-.058,1.967,1.967,0,0,1-.835-.677.927.927,0,0,1-.014-1.025.715.715,0,0,1,1.236.166Z",
    transform: "translate(-399.011 -268.869)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M417.123,299.817c-.184-.014-.276.242-.21.413a5.217,5.217,0,0,0,.3.463.662.662,0,0,1,.02.551.317.317,0,0,1-.234.212.391.391,0,0,1-.212-.058,1.992,1.992,0,0,1-.835-.677.931.931,0,0,1-.012-1.025.715.715,0,0,1,1.236.166Z",
    transform: "translate(-390.372 -275.233)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M417.97,300.656c-.184-.012-.276.242-.21.415s.218.3.3.461a.662.662,0,0,1,.02.551.317.317,0,0,1-.234.212.4.4,0,0,1-.21-.056,1.987,1.987,0,0,1-.835-.679.931.931,0,0,1-.014-1.026.714.714,0,0,1,1.236.168Z",
    transform: "translate(-389.522 -274.392)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M416.434,301.666c-.184-.014-.274.242-.208.413a5.2,5.2,0,0,0,.3.463.67.67,0,0,1,.02.551.324.324,0,0,1-.234.212.386.386,0,0,1-.212-.058,1.979,1.979,0,0,1-.835-.677.935.935,0,0,1-.014-1.025.715.715,0,0,1,1.236.166Z",
    transform: "translate(-391.061 -273.379)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M418.143,288.409c-.184-.012-.274.242-.21.415s.218.3.3.463a.662.662,0,0,1,.02.551.315.315,0,0,1-.234.21.4.4,0,0,1-.21-.056,1.987,1.987,0,0,1-.835-.679.928.928,0,0,1-.014-1.023.713.713,0,0,1,1.236.166Z",
    transform: "translate(-389.348 -286.674)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M405.838,300.335a.443.443,0,0,0,.541-.29.637.637,0,0,0-.178-.629c-.072-.072-.188-.132-.27-.072a.252.252,0,0,0-.076.186l-.094.841Z",
    transform: "translate(-400.431 -275.325)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M404.031,307.756a.75.75,0,0,1-.136-1.18,1.86,1.86,0,0,1,.737.773.646.646,0,0,1-.374.875c-.182-.106-.367-.21-.549-.316Z",
    transform: "translate(-402.529 -268.047)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M404.87,301.57a.194.194,0,0,1-.276.042.448.448,0,0,1-.152-.272.547.547,0,0,1-.014-.254.377.377,0,0,1,.383-.27.476.476,0,0,1,.395.282.306.306,0,0,1,.018.24.169.169,0,0,1-.2.1Z",
    transform: "translate(-401.776 -273.825)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M408.311,304.337l.256-.148a.622.622,0,0,0-.268-.354c-.138-.064-.346.042-.312.19a.322.322,0,0,0,.1.14l.389.385Z",
    transform: "translate(-398.201 -270.815)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M412.416,295.954a1.754,1.754,0,0,0,.7-.182.612.612,0,0,0,.326-.6.541.541,0,0,0-.182-.3.669.669,0,1,0-.819,1.056Z",
    transform: "translate(-394.015 -279.937)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M412.013,305.762a.49.49,0,0,1-.8-.238,1.373,1.373,0,0,1,.354-.447.873.873,0,0,1,.346.513Z",
    transform: "translate(-394.961 -269.55)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M415.555,291.795a1.043,1.043,0,0,0,.371-.178.348.348,0,0,0,.118-.373c-.082-.212-.385-.22-.557-.373s-.206-.445-.419-.529-.447.126-.471.35a.989.989,0,0,0,.214.629,1.1,1.1,0,0,0,.421.425.438.438,0,0,0,.543-.114Z",
    transform: "translate(-391.572 -284.345)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M414.7,302.477a2.88,2.88,0,0,0,2.7.7,3.03,3.03,0,0,0-.525-2.74,1.831,1.831,0,0,0-2.578-.174c-.661.707-.18,2.157.787,2.149Z",
    transform: "translate(-392.173 -274.837)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M412.4,306.484a.256.256,0,0,1,0-.357.474.474,0,0,1,.367-.128.467.467,0,0,1,.226.054.336.336,0,0,1,.086.473.358.358,0,0,1-.485.06.387.387,0,0,1-.092-.487Z",
    transform: "translate(-393.841 -268.626)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M413.853,304.309c-.008-.246-.278-.385-.513-.459s-.509-.168-.573-.4a.21.21,0,0,1,.028-.192c.11-.132.315,0,.481.038a1.778,1.778,0,0,0,.413,0,.822.822,0,0,1,.749.539.452.452,0,0,1-.8.218Z",
    transform: "translate(-393.415 -271.435)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M413.417,300.075l.194-.206a.341.341,0,0,0-.364-.22.284.284,0,0,0-.22.346.245.245,0,0,0,.375.11Z",
    transform: "translate(-393.155 -274.999)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M412.5,302.771a.193.193,0,0,1-.246-.132.463.463,0,0,1,.04-.308.568.568,0,0,1,.142-.212.38.38,0,0,1,.471.014.478.478,0,0,1,.144.463.318.318,0,0,1-.128.2.169.169,0,0,1-.222-.038Z",
    transform: "translate(-393.933 -272.593)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M418.972,290.309a2.879,2.879,0,0,0,2.578-1.06,3.028,3.028,0,0,0-2.061-1.879,1.831,1.831,0,0,0-2.169,1.4c-.1.963,1.15,1.837,1.919,1.25Z",
    transform: "translate(-388.844 -287.339)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M409.267,304.5c.282-.02.294-.491.054-.639a1.038,1.038,0,0,0-.825.01,1,1,0,0,0,.759.8Z",
    transform: "translate(-397.687 -270.858)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M406.7,300.69c-.184-.012-.274.242-.208.415a5.2,5.2,0,0,0,.3.461.662.662,0,0,1,.02.551.321.321,0,0,1-.234.212.4.4,0,0,1-.212-.056,2,2,0,0,1-.835-.679.935.935,0,0,1-.014-1.026.714.714,0,0,1,1.236.168Z",
    transform: "translate(-400.826 -274.358)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M414.017,305.815l.194-.2a.34.34,0,0,0-.365-.222.285.285,0,0,0-.22.346.244.244,0,0,0,.375.11Z",
    transform: "translate(-392.553 -269.243)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M412.933,305.433a6.742,6.742,0,0,0,2.275-2.041,1.186,1.186,0,0,0,.216-.443.96.96,0,0,0-.36-.845,1.976,1.976,0,0,0-2.2-.228,2.45,2.45,0,0,0-1.224,1.9,1.649,1.649,0,0,0,.3,1.222.925.925,0,0,0,1.156.25.2.2,0,0,0-.272-.2Z",
    transform: "translate(-394.543 -272.991)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M414.588,300.431a2.873,2.873,0,0,0,2.578-1.058,3.028,3.028,0,0,0-2.061-1.879,1.83,1.83,0,0,0-2.169,1.4c-.106.963,1.15,1.837,1.919,1.25Z",
    transform: "translate(-393.241 -277.187)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M417.81,296.722a1.477,1.477,0,0,0,1.216-.469,1.5,1.5,0,0,0-.467-.383.519.519,0,0,0-.567.064c-.2.194-.128.521-.046.783l-.2-.1Z",
    transform: "translate(-388.413 -278.837)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M419.328,295.518a.576.576,0,0,0,.31-.2.6.6,0,0,0,.046-.357,5.743,5.743,0,0,1,.032-1l-1.22,1.136a.342.342,0,0,1-.108.076c-.144.052-.276-.106-.427-.14-.22-.052-.407.166-.5.369C416.787,296.856,418.683,295.763,419.328,295.518Z",
    transform: "translate(-388.84 -280.701)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M414.164,303.778l.375-.314a.783.783,0,0,0-.883-.216c-.288.152-.349.647-.056.789.18.088.5.154.409.334Z",
    transform: "translate(-392.762 -271.45)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M415.233,297.034a.663.663,0,0,1-.339.22,1.131,1.131,0,0,1,.493-.885c.146-.13.348-.264.523-.174.12.06.17.206.262.308.182.2.565.28.555.553a.334.334,0,0,1-.314.284.979.979,0,0,1-.449-.1q-.469-.186-.941-.369Z",
    transform: "translate(-391.274 -278.487)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M413.445,295.211c.282-.02.294-.493.052-.639a1.025,1.025,0,0,0-.823.01,1,1,0,0,0,.759.8Z",
    transform: "translate(-393.497 -280.169)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M416.045,294.279a.257.257,0,0,1-.214-.284.48.48,0,0,1,.216-.323.448.448,0,0,1,.212-.092.338.338,0,0,1,.354.326.36.36,0,0,1-.352.338.386.386,0,0,1-.367-.334Z",
    transform: "translate(-390.333 -281.082)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M416.343,294.886a.4.4,0,0,0,.663.152.679.679,0,0,0-.222-.372.334.334,0,0,0-.409-.014.225.225,0,0,0,.042.365Z",
    transform: "translate(-389.86 -280.069)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M417.562,298.254a1.128,1.128,0,0,0,.985-.04q-.231-.346-.463-.7a.743.743,0,0,0-.268-.282.45.45,0,0,0-.591.318.625.625,0,0,0,.313.647Z",
    transform: "translate(-388.946 -277.447)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M414.257,293.867a.5.5,0,0,1-.282-.883c.1-.088.284-.118.354,0a.325.325,0,0,1,.028.164l-.008.745-.128-.02Z",
    transform: "translate(-392.367 -281.756)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M413.725,292.257c.074-.232-.136-.455-.333-.6s-.424-.327-.407-.571a.206.206,0,0,1,.09-.17c.146-.09.3.1.443.194a1.8,1.8,0,0,0,.387.134.822.822,0,0,1,.529.757.451.451,0,0,1-.827-.06Z",
    transform: "translate(-393.186 -283.776)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M414.68,291.4l.252-.128a.343.343,0,0,0-.272-.331.286.286,0,0,0-.322.254.244.244,0,0,0,.318.228Z",
    transform: "translate(-391.829 -283.729)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M417.5,295.829c-.184-.014-.274.24-.208.413a5.218,5.218,0,0,0,.3.463.669.669,0,0,1,.02.551.324.324,0,0,1-.234.212.423.423,0,0,1-.212-.058,1.982,1.982,0,0,1-.835-.677.931.931,0,0,1-.014-1.025.713.713,0,0,1,1.236.166Z",
    transform: "translate(-389.988 -279.235)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M419.2,296.918a.446.446,0,0,0,.543-.292.638.638,0,0,0-.18-.629c-.07-.072-.186-.132-.268-.072a.255.255,0,0,0-.076.186l-.094.843Z",
    transform: "translate(-387.029 -278.754)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M413.028,297.422a.75.75,0,0,1-.134-1.182,1.89,1.89,0,0,1,.737.775.65.65,0,0,1-.375.875l-.551-.316Z",
    transform: "translate(-393.507 -278.412)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M417.309,294l.254-.146a.622.622,0,0,0-.266-.356c-.138-.062-.349.044-.312.192a.286.286,0,0,0,.1.138l.389.386Z",
    transform: "translate(-389.178 -281.18)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M410.722,305.539a1.79,1.79,0,0,0,.7-.184.608.608,0,0,0,.326-.6.545.545,0,0,0-.18-.3.669.669,0,1,0-.819,1.056Z",
    transform: "translate(-395.711 -270.327)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M409.743,298.133l.375-.318a.876.876,0,0,0-.234-.292.462.462,0,0,0-.268.589Z",
    transform: "translate(-396.595 -277.127)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M406.12,309.674a.256.256,0,0,1-.212-.286.467.467,0,0,1,.214-.32.456.456,0,0,1,.214-.092.334.334,0,0,1,.352.326.359.359,0,0,1-.352.339.387.387,0,0,1-.365-.336Z",
    transform: "translate(-400.284 -265.643)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M411.767,298l.377-.318a.855.855,0,0,0-.234-.292.463.463,0,0,0-.27.589Z",
    transform: "translate(-394.565 -277.255)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M421.281,289.436c.172.066.334-.15.322-.334s-.12-.349-.152-.531a.673.673,0,0,1,.142-.533.318.318,0,0,1,.286-.132.4.4,0,0,1,.186.116,1.992,1.992,0,0,1,.6.893.926.926,0,0,1-.288.983.713.713,0,0,1-1.132-.523Z",
    transform: "translate(-384.902 -286.774)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M411.652,302.745a1.035,1.035,0,0,0-.409.062.351.351,0,0,0-.222.32c.016.228.3.324.423.521s.068.485.246.629a.388.388,0,0,0,.553-.2,1,1,0,0,0-.02-.665,1.1,1.1,0,0,0-.278-.529.433.433,0,0,0-.551-.052Z",
    transform: "translate(-395.155 -271.889)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M416.024,299.326a5.477,5.477,0,0,0-1.264,2.143.964.964,0,0,0-.06.4.786.786,0,0,0,.489.567,1.606,1.606,0,0,0,1.761-.362,1.986,1.986,0,0,0,.483-1.777,1.341,1.341,0,0,0-.531-.875.758.758,0,0,0-.959.09.164.164,0,0,0,.26.086Z",
    transform: "translate(-391.47 -275.354)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M417.51,302.826a.589.589,0,0,0,.332.168.611.611,0,0,0,.333-.138,5.634,5.634,0,0,1,.883-.469l-1.592-.495a.3.3,0,0,1-.12-.056c-.116-.1-.046-.292-.09-.439-.064-.216-.346-.27-.571-.25C415.086,301.286,416.977,302.39,417.51,302.826Z",
    transform: "translate(-390.106 -273.494)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M415.616,299.585l.26-.11a.342.342,0,0,0-.248-.349.286.286,0,0,0-.339.23.243.243,0,0,0,.3.25Z",
    transform: "translate(-390.876 -275.524)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M417.262,300.952a.448.448,0,0,0,.525.326.645.645,0,0,0,.457-.469c.026-.1.02-.228-.072-.27a.255.255,0,0,0-.2.028l-.777.336Z",
    transform: "translate(-388.965 -274.112)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M416.281,299.68a1.484,1.484,0,0,0,1.011.821,1.524,1.524,0,0,0,.1-.595.521.521,0,0,0-.336-.461c-.266-.074-.515.148-.7.351l-.01-.228Z",
    transform: "translate(-389.88 -275.213)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M416.3,298.7a.666.666,0,0,1-.359-.184,1.138,1.138,0,0,1,1.013-.012c.184.062.4.17.411.366.006.136-.094.25-.136.381-.086.26.036.631-.2.757a.336.336,0,0,1-.4-.13.973.973,0,0,1-.138-.439l-.148-1Z",
    transform: "translate(-390.223 -276.253)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M416.3,301.457a1.126,1.126,0,0,0,.523.833c.126-.248.25-.5.375-.747a.714.714,0,0,0,.11-.372.447.447,0,0,0-.569-.354.634.634,0,0,0-.407.595Z",
    transform: "translate(-389.866 -273.841)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M418.622,300.151c-.08-.166-.346-.118-.465.024a5.121,5.121,0,0,0-.25.491.663.663,0,0,1-.469.29.318.318,0,0,1-.3-.1.4.4,0,0,1-.054-.21,1.976,1.976,0,0,1,.172-1.062.929.929,0,0,1,.881-.523.715.715,0,0,1,.471,1.156Z",
    transform: "translate(-389.083 -275.586)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M411.97,300.761a1.784,1.784,0,0,0,.5.513.611.611,0,0,0,.679-.014.541.541,0,0,0,.172-.308.669.669,0,1,0-1.322-.186Z",
    transform: "translate(-394.203 -274.489)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M413.272,302.933a1.478,1.478,0,0,0,1.013.821,1.516,1.516,0,0,0,.1-.593.52.52,0,0,0-.339-.461c-.266-.074-.515.148-.7.351l-.01-.228Z",
    transform: "translate(-392.898 -271.948)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M416.567,298.839c.088-.228-.1-.463-.29-.623s-.4-.357-.367-.6a.214.214,0,0,1,.1-.164c.154-.078.29.122.429.226a1.813,1.813,0,0,0,.377.162.818.818,0,0,1,.475.789.451.451,0,0,1-.821-.116Z",
    transform: "translate(-390.256 -277.214)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M408.245,302.956l.142-.242a.345.345,0,0,0-.409-.132.286.286,0,0,0-.132.389.245.245,0,0,0,.391.02Z",
    transform: "translate(-398.372 -272.077)",
    fill: "#4723a9",
    opacity: 0.5
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M415.2,301.24l.254.148a.624.624,0,0,0,.176-.409c-.014-.152-.21-.278-.323-.176a.326.326,0,0,0-.072.152l-.14.529Z",
    transform: "translate(-391.065 -273.873)",
    fill: "#4723a9",
    opacity: 0.5
  }))), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M437.24,158.255s2.572,4.136,5.354,3.567,3.6-7.428,3.253-8.874A21.591,21.591,0,0,0,437.24,158.255Z",
    transform: "translate(-270.526 -63.509)",
    fill: "#1c2636"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M454.97,161.6l2.115,1.941a6.677,6.677,0,0,0,2-4.166,18.391,18.391,0,0,0-.236-6.069s-3.485,2.646-4.2,5.021A12.063,12.063,0,0,0,454.97,161.6Z",
    transform: "translate(-253.076 -63.148)",
    fill: "#1c2636"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M440.776,155.784s3.233-.971,5.506,0C446.282,155.784,442.789,156.9,440.776,155.784Z",
    transform: "translate(-266.98 -61.098)",
    fill: "#fff"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M456.585,155.836s3.235-.971,5.506,0C462.091,155.836,458.6,156.948,456.585,155.836Z",
    transform: "translate(-251.126 -61.046)",
    fill: "#fff"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M114.624,66.742c-2.869-5.939-5.109-28.376,14.787-35.408s63.107-3.676,74.482,2.6,13.2,16.512,9.147,19.217a5.231,5.231,0,0,1-5.118,1.31c-11.765-3.369-39.111-14.2-44.975-11.541-7.275,3.3-22.059,12.171-22.059,12.171S117.493,72.681,114.624,66.742Z",
    fill: "#1e2c3c"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357.134 11.424)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.82 79.181)"
  }, _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M540.926,219.694S555.138,218,572.5,209s31.444-58.308,26.834-64.433-41.538,18.524-50.854,38.468-3.3,32.834-3.3,32.834l-4.468,1.875Z",
    transform: "translate(-540.714 -143.617)",
    fill: "url(#cn)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M544.31,214.962s27.01-52.894,49.6-70.762C593.914,144.2,595.368,208.325,544.31,214.962Z",
    transform: "translate(-537.108 -143.032)",
    opacity: 0.82,
    fill: "url(#co)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M544.166,163.431a3.382,3.382,0,0,0,1.394-2.638,3.49,3.49,0,0,0-1.376.04,1.189,1.189,0,0,0-.883.961c-.048.629.559,1.092,1.1,1.424l-.507.122Z",
    transform: "translate(-521.303 -47.261)",
    fill: "#047fc4"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M545.926,165.292a1.523,1.523,0,0,1,.327.863c-.8-.084-1.342-.831-1.738-1.53-.222-.389-.423-.905-.14-1.252.2-.24.547-.282.817-.437.541-.312.9-1.13,1.506-.975a.768.768,0,0,1,.485.841,2.228,2.228,0,0,1-.435.955q-.637.961-1.276,1.927Z",
    transform: "translate(-520.364 -46.06)",
    fill: "#047fc4"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M535.04,147.988c.092-.643-.955-.9-1.4-.429a2.367,2.367,0,0,0-.375,1.849,2.274,2.274,0,0,0,2.157-1.31Z",
    transform: "translate(-531.393 -60.725)",
    fill: "#047fc4",
    opacity: 0.5
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M539.068,162.146a.9.9,0,0,0,1.374-.729,1.563,1.563,0,0,0-.941-.312.767.767,0,0,0-.725.589c-.048.334.3.685.619.567Z",
    transform: "translate(-525.843 -46.903)",
    fill: "#047fc4"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M542.256,162.471c-.336.254-.11.829.26,1.027a12.08,12.08,0,0,0,1.214.346,1.516,1.516,0,0,1,.859.921.724.724,0,0,1-.086.717.9.9,0,0,1-.451.218,4.55,4.55,0,0,1-2.459.084,2.127,2.127,0,0,1-1.56-1.748,1.632,1.632,0,0,1,2.381-1.568Z",
    transform: "translate(-524.581 -45.712)",
    fill: "#047fc4"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M547,161.315a1.016,1.016,0,0,0,.5-1.318,1.465,1.465,0,0,0-1.254-.817c-.23-.016-.519.056-.571.28a.571.571,0,0,0,.146.437l1.1,1.6Z",
    transform: "translate(-518.932 -48.832)",
    fill: "#047fc4"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M564.083,107.887a14.192,14.192,0,0,0-5.357-3.587,2.485,2.485,0,0,0-1.02-.214,2.027,2.027,0,0,0-1.542,1.18,4.165,4.165,0,0,0,.681,4.61,5.157,5.157,0,0,0,4.52,1.512,3.486,3.486,0,0,0,2.345-1.246,1.961,1.961,0,0,0-.088-2.5.423.423,0,0,0-.26.661Z",
    transform: "translate(-508.82 -104.083)",
    fill: "#047fc4"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M538.441,153.907a2.991,2.991,0,0,0-.743-1.134.51.51,0,0,0-.18-.124.422.422,0,0,0-.395.1.877.877,0,0,0-.246.947,1.079,1.079,0,0,0,.751.663.728.728,0,0,0,.555-.048.412.412,0,0,0,.188-.491.089.089,0,0,0-.1.106Z",
    transform: "translate(-527.79 -55.396)",
    fill: "#047fc4"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M543.9,157.576c-.118.4.409.733.825.669a12.062,12.062,0,0,0,1.178-.451,1.526,1.526,0,0,1,1.242.222.726.726,0,0,1,.359.627.911.911,0,0,1-.228.445,4.553,4.553,0,0,1-1.919,1.54,2.13,2.13,0,0,1-2.3-.465,1.633,1.633,0,0,1,.969-2.682Z",
    transform: "translate(-521.944 -50.533)",
    fill: "#047fc4"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M538.979,162.729l-.363-.535a.785.785,0,0,0-.673.709.651.651,0,0,0,.669.659.559.559,0,0,0,.429-.785Z",
    transform: "translate(-526.673 -45.808)",
    fill: "#047fc4"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M550.314,169.777a15.394,15.394,0,0,0-3.465-6.071,2.685,2.685,0,0,0-.883-.7,2.2,2.2,0,0,0-2.067.4,4.513,4.513,0,0,0-1.568,4.8,5.6,5.6,0,0,0,3.655,3.653,3.771,3.771,0,0,0,2.876-.078,2.121,2.121,0,0,0,1.122-2.461.459.459,0,0,0-.573.515Z",
    transform: "translate(-522.441 -45.112)",
    fill: "#047fc4"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M538.036,157.04a3.382,3.382,0,0,0-.465-2.946,3.5,3.5,0,0,0-1.078.857,1.185,1.185,0,0,0-.132,1.3c.339.533,1.1.539,1.732.483l-.334.4Z",
    transform: "translate(-528.399 -53.93)",
    fill: "#047fc4"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M535.619,154.421a1.313,1.313,0,0,0-.307-.793,1.38,1.38,0,0,0-.775-.278,12.828,12.828,0,0,1-2.221-.555l1.951,3.279a.753.753,0,0,1,.118.276c.046.35-.371.569-.521.887-.22.467.176.987.587,1.3C537.381,160.746,535.855,155.979,535.619,154.421Z",
    transform: "translate(-532.316 -55.233)",
    fill: "#047fc4"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M534.289,129.1a.905.905,0,0,0,.663-1.408,1.578,1.578,0,0,0-.941.314.765.765,0,0,0-.226.907.51.51,0,0,0,.833.08Z",
    transform: "translate(-530.914 -80.406)",
    fill: "#047fc4"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M539.207,153.293a1.014,1.014,0,0,0-.393-1.352,1.457,1.457,0,0,0-1.492.1c-.194.126-.383.355-.29.567a.587.587,0,0,0,.381.262q.919.306,1.837.617Z",
    transform: "translate(-527.611 -56.254)",
    fill: "#047fc4"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M539.718,167.063a4.062,4.062,0,0,0,1.388-.881,1.385,1.385,0,0,0,.3-1.524,1.232,1.232,0,0,0-.6-.535,1.529,1.529,0,1,0-1.053,2.866Z",
    transform: "translate(-525.942 -43.985)",
    fill: "#047fc4"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M542.439,159.231l.453-.5a1.416,1.416,0,0,0-.827-.589c-.345-.042-.727.336-.549.633a.71.71,0,0,0,.307.238c.37.19.743.379,1.114.569Z",
    transform: "translate(-523.136 -49.873)",
    fill: "#047fc4"
  }))), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M496.039,172.776l-14.483-3.866,1.158-3.55,14.085,5.279Z",
    transform: "translate(-226.085 -31.208)",
    fill: "url(#cp)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M494.677,172.836l-5.7-13.694,3.524-1.234,4.336,14.235Z",
    transform: "translate(-218.643 -38.681)",
    fill: "url(#cq)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M496.267,172.27l6.349-13.993,3.321,1.707-7.681,13.376Z",
    transform: "translate(-211.333 -38.312)",
    fill: "url(#cr)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.fa1a510c7bc19efd8307151d897b7109.svg";
export { ForwardRef as ReactComponent };